import store from "../store";
import { getAccessToken } from "./utils";
import moment from "moment-timezone";
import {
    getEntityColor,
    getSentimentColor,
    intToRGB,
    hashCode,
    radialColor,
    green_colors,
    red_colors,
    neutral_colors,
    getPlatformColorCode,
    getStrokeColor,
} from "../components/MainContent/Dashboard/Charts/utils";
import { ProductAttributes } from "../components/MainContent/Dashboard/ProductAttributeValues";
import { getSettings } from "./reportsAndAlertsActions";
import { MetricsList, dimensionNameObj, metricsNameObj } from "../components/MainContent/AdvancedCustomChart/MetricsList";
import { updateDashboardTabInView } from "./dashboardAction";
const getCustomQueryData = (data) => {
    let customQueryData = "";
    let customQueryArrayData = [];
    let searchtextinPost;
    let searchtextinImage;
    let logolabel;
    let objectsname;
    let scenesname;

    // if (data.filterImageOptions && data.filterImageOptions.logos && data.filterImageOptions.logos.length > 0) {
    //     logolabel = data.filterImageOptions.logos.map((v) => `logo.label:"${v}"`).join(" OR ");

    //     logolabel = `(${logolabel})`;
    // }
    // if (data.filterImageOptions && data.filterImageOptions.objects && data.filterImageOptions.objects.length > 0) {
    //     objectsname = data.filterImageOptions.objects.map((v) => `objects.name:"${v}"`).join(" OR ");

    //     objectsname = `(${objectsname})`;
    // }

    // if (data.filterImageOptions && data.filterImageOptions.scenes && data.filterImageOptions.scenes.length > 0) {
    //     scenesname = data.filterImageOptions.scenes.map((v) => `scenes.name:"${v}"`).join(" OR ");

    //     scenesname = `(${scenesname})`;
    // }

    if (data.filterImageOptions && data.filterImageOptions.ocr_custom_query && data.filterImageOptions.ocr_custom_query.length > 0) {
        searchtextinImage = data.filterImageOptions.ocr_custom_query.map((v) => `ocr.name:"${v}"`).join(" AND ");

        searchtextinImage = `(${searchtextinImage})`;
    }

    if (data.filterImageOptionsOCR && data.filterImageOptionsOCR.ocr_custom_query && data.filterImageOptionsOCR.ocr_custom_query.length > 0) {
        searchtextinImage = data.filterImageOptionsOCR.ocr_custom_query.map((v) => `ocr.name:"${v}"`).join(" AND ");

        searchtextinImage = `(${searchtextinImage})`;
    }
    // if (data.custom_query && data.custom_query !== "" && data.custom_query.indexOf("_id:") > 0) {
    //     searchtextinPost = `(post.content:${data.custom_query})`;
    // } else
    if (data.custom_query && data.custom_query !== "") {
        searchtextinPost = `${data.custom_query}`;
    }

    if (searchtextinImage && searchtextinImage !== "") customQueryArrayData.push(searchtextinImage);
    if (logolabel && logolabel !== "") customQueryArrayData.push(logolabel);
    if (objectsname && objectsname !== "") customQueryArrayData.push(objectsname);
    if (scenesname && scenesname !== "") customQueryArrayData.push(scenesname);
    if (searchtextinPost && searchtextinPost !== "") customQueryArrayData.push(searchtextinPost);

    //if (customQueryArrayData.length > 1) {
    customQueryData = customQueryArrayData.join(" AND ");
    // }

    return customQueryData;
};

export const getParams = (data) => {
    // console.log("firstdatttta", data);
    let params = {};
    if (data.languages) params.language = data.languages;
    if (data.countries) params.location = data.countries;
    if (data.platforms) params.platform = data.platforms;
    if (data.product_attribute_categories) {
        params.product_attribute_categories = data.product_attribute_categories;
        params.extraFields = data.extraFields;
    }
    if (data.exclude_engagement_types) params.exclude_engagement_types = data.exclude_engagement_types;
    if (data.advanceChart) params.multi_dimension_chart_config = data.advanceChart;
    //Image Analytics Chart Data
    // if (data.logos && data.logos.length > 0) {
    //    // params.image_analytics_types = ["logo"];

    //     params.custom_query = data.logos.map((v) => `logo.name:"${v}"`).join(" OR ");
    //     params.custom_query = data.logos[0] === "selectAll" ? "" : `(${params.custom_query})`;

    //     if (data.objects) {
    //         let objects = data.objects.map((v) => `objects.name:"${v}"`).join(" OR ");
    //         objects = `(${objects})`;
    //         params.custom_query = `${params.custom_query} AND ${objects}`;
    //     }
    // }

    // duration
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.graph && data.graph === "GAUGE") {
        params.start_date = moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "custom") {
        /* params.append('start_date', moment(data.start_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss'))
    params.append('end_date', moment(data.end_date).tz(tz).format('YYYY-MM-DDTHH:mm:ss')) */
        params.start_date = moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "24HRS") {
        params.end_date = moment(new Date()).tz(tz).startOf("minute").format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment(new Date()).tz(tz).subtract(1, "day").startOf("minute").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastmonth") {
        params.start_date = moment(new Date()).subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("month").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastquarter") {
        params.start_date = moment(new Date()).startOf("quarter").subtract(1, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "last2quarter") {
        params.start_date = moment(new Date()).startOf("quarter").subtract(2, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else {
        params.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(data.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
    }
    if (data.post_address_country) {
        params.post_address_country = data.post_address_country;
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59");
    }

    // params.groupSize = 50;
    if (data.data) params.data = 1;
    if (data.child_tags_of) params.child_tags_of = data.child_tags_of;

    // entity type
    if (data.entityType !== "all" && data.entityType && data.entityType !== "") {
        params.entity_boolean = formatEntityType(data.entityType, data.entitySubType);
    }

    if (data.publications) {
        if (data.publications === "all_tagged_pubs") {
            let configured_publications = data.public_data
                ? store.getState().filterSettingReducer.masterPublications
                : store.getState().filterSettingReducer.publicationsActive;
            params.publication = configured_publications.map((elem) => elem.name).toString();
        } else if (data.publications === "all_untagged_pubs") params.fields_not_exist = "publications";
        else if (data.publications === "not_listed_pubs") {
            let configured_publications = data.public_data
                ? store.getState().filterSettingReducer.masterPublications
                : store.getState().filterSettingReducer.publicationsActive;
            configured_publications = configured_publications.map((elem) => elem.name);
            params.publications_not_in = configured_publications.toString();
        } else {
            // params.publication = data.publications;
            if (data.public_data) params.publication = data.publications;
            else {
                // when any publication is added and filter has been saved for future, if delete publication, then deleted publication should be filtered
                const activePubs = {};
                const existingPubsFromActiveFilter = [];

                store.getState().filterSettingReducer.publicationsActive?.forEach((obj) => (activePubs[obj.name] = obj));

                data.publications?.forEach((publication) => {
                    if (activePubs[publication]) {
                        existingPubsFromActiveFilter.push(publication);
                    }
                });

                params.publication = existingPubsFromActiveFilter;
            }
        }
    }

    if (data.topics_data && data.topics_data.length > 0) params.topic_data = data.topics_data;

    // sort option
    if (data.sortBy) {
        if (data.sortBy === "published_date_desc") {
            params.orderBy = "post.published_date";
            params.order = "desc";
        } else if (data.sortBy === "published_date_asc") {
            params.orderBy = "post.published_date";
            params.order = "asc";
        } else if (data.sortBy === "impact_prediction_score") {
            params.orderBy = "impact_prediction_score";
        } else if (data.sortBy === "trending_now_virality") {
            params.virality_parameter = 0;
            params.orderBy = "impact_value";
        } else if (data.sortBy === "predicted_virality") {
            params.virality_parameter = 1;
            params.orderBy = "impact_prediction_score";
        } else if (data.sortBy === "impact_value") {
            params.post_type = 0;
            params.orderBy = "impact_value";
        } else params.orderBy = data.sortBy;
    }

    if (data.offset) params.offset = data.offset;
    // if (data) params.aggs = "top_objects,top_scenes";
    if (data.recordsPerPage) params.recordsPerPage = data.recordsPerPage;

    // refine filter

    if (data.refineOptions?.sentiment && data.refineOptions?.sentiment[0] !== "all") {
        if (Array.isArray(data.refineOptions.sentiment)) params.sentiment = data.refineOptions.sentiment.join(",");
        else params.sentiment = data.refineOptions.sentiment;
    }
    if (data.refineOptions?.sentimentType !== "all") params.sentiment_source = data.refineOptions?.sentimentType;

    // data passing for content safety and content safety type filters

    if (data.refineOptions?.contentSafety === "nsfw") {
        params.content_safety = "nsfw";
    } else if (data.refineOptions?.contentSafety === "sfw") {
        params.content_safety = "sfw";
    } else {
        params.content_safety = "all";
    }

    if (data.refineOptions?.contentSafetyType !== "all") {
        params.content_safety_source = data.refineOptions.contentSafetyType;
    }

    if (data.refineOptions?.media !== "all" && data.refineOptions) {
        // if (data.refineOptions.media === "reel") params.post_subtype = data.refineOptions.media;
        if (["long_video", "short_video"].includes(data.refineOptions.media)) {
            params.post_media_type = "video";
            params.post_media_subtype = data.refineOptions.media;
        } else params.post_media_type = data.refineOptions.media;
    }

    if (data.refineOptions?.channel !== "all" && data.refineOptions) {
        params.source_type = data.refineOptions.channel;
    }
    if (data.refineOptions?.postType !== "all" && data.refineOptions) params.post_type = data.refineOptions?.postType;
    if (data.refineOptions?.sampling && +data.refineOptions?.sampling !== 100) {
        params.sampling_value = data.refineOptions.sampling;
    }
    if (data.refineOptions?.exclusion) params.apply_exclusion = data.refineOptions.exclusion;
    if (data.refineOptions?.reviewStatus) params.synced_collection_status = data.refineOptions.reviewStatus;
    if (data.refineOptions?.sourceType) params.influencer_types = data.refineOptions.sourceType.join(",");
    if (data.tag_category_ids) {
        params.tag_category_ids = data.tag_category_ids;
    }

    if (data.post_ids) params.post_ids = data.post_ids;

    // if (
    //     !data.logos &&
    //     data.aggs !== "volume-of-conversation-per-object" &&
    //     data.aggs !== "object_overtime" &&
    //     data.aggs !== "scene_overtime" &&
    //     data.aggs !== "logo_overtime"
    // ) {
    params.image_analytics_types = [];
    if (data.filterImageOptions?.logos && data.filterImageOptions?.logos?.length > 0) {
        params.image_analytics_types = [...params.image_analytics_types, "logo"];

        if (data.filterImageOptions.logos[0] === "selectAll") params.logos = [];
        else params.logos = data.filterImageOptions.logos;
    }

    if (data.filterImageOptions?.scenes && data.filterImageOptions?.scenes.length > 0) {
        params.image_analytics_types = [...params.image_analytics_types, "scenes"];
        if (data.filterImageOptions.scenes[0] === "selectAll") params.scenes = [];
        else params.scenes = data.filterImageOptions.scenes;
    }
    if (data.filterImageOptions?.objects && data.filterImageOptions?.objects?.length > 0) {
        params.image_analytics_types = [...params.image_analytics_types, "objects"];

        if (data.filterImageOptions.objects[0] === "selectAll") params.objects = [];
        else params.objects = data.filterImageOptions.objects;
    }

    if (data.logos || data.objects || data.scenes) {
        params.logos = data.logos?.includes("selectAll") ? [] : data.logos;
        params.objects = data.objects?.includes("selectAll") ? [] : data.objects;
        params.scenes = data.scenes?.includes("selectAll") ? [] : data.scenes;
        //  if(params.image_analytics_types) params.image_analytics_types = data.image_analytics_types;
    }

    if (params.image_analytics_types?.length == 0 && data.image_analytics_types) {
        params.image_analytics_types = data.image_analytics_types;
    }

    if (data.emotions) {
        params.emotions = data.emotions;
    }

    // }

    //Image Analytics Chart Data
    // if (
    //     data.logos ||
    //     data.objects ||
    //     data.aggs === "volume-of-conversation-per-object" ||
    //     data.aggs === "object_overtime" ||
    //     data.aggs === "scene_overtime" ||
    //     data.aggs === "logo_overtime"
    // ) {

    //
    //     if (data.logos?.length > 0 && data.logos[0] !== null) {
    //         params.image_analytics_types = ["logo"];
    //         if (data.objects) {
    //             params.image_analytics_types = ["all"];
    //             params.objects = data.objects;
    //         }

    //         if (data.scenes) {
    //             params.image_analytics_types = ["all"];
    //             params.scenes = data.scenes;
    //         }
    //         params.logos = data.logos[0] === "selectAll" ? "" : data.logos;
    //     } else if ((data.aggs === "object_overtime" && data.image_analytics_types) || (data.objects && data.logos[0] === null)) {
    //         params.image_analytics_types = ["objects"];
    //         params.objects = data.objects;
    //     } else if ((data.aggs === "scene_overtime" && data.image_analytics_types) || (data.scenes && data.logos[0] === null)) {
    //         params.image_analytics_types = ["scenes"];
    //         params.scenes = data.scenes;
    //     } else if (data.aggs == "logo_overtime" && data.logos?.length < 1) {
    //         params.logos = [];
    //         params["image_analytics_types"] = ["logo"];
    //     }
    // }

    if (getCustomQueryData(data) !== "") {
        params.custom_query = getCustomQueryData(data);
    }

    if (data.refineOptions?.postSubType !== "all" && data.refineOptions) {
        if (data.refineOptions.postSubType === "ads") params.post_subtype = "ads";
        else if (data.refineOptions.postSubType === "noads") params.exclude_dark_post = 1;
    }
    // }
    if (data.extraFields || data.image_analytics_types) {
        params.extraFields = data.extraFields;
        //  params.image_analytics_types = data.image_analytics_types;
    }

    if (data.public_data) params.public_data = data.public_data;

    // collection
    if (data.synced_collection_id) params.synced_collection_id = data.synced_collection_id;

    // smr keyword posts
    if (data.show_smr_pending_posts) params.show_smr_pending_posts = data.show_smr_pending_posts;
    if (data.smr_rule_ids) params.smr_rule_ids = data.smr_rule_ids;

    // downloads
    if (data.download_type) params.download_type = data.download_type;
    if (data.selected_fields) params.selected_fields = data.selected_fields;
    if (data.download_name) params.download_name = data.download_name;
    if (data.parent_id) params.parent_id = data.parent_id;

    // chart aggregation type

    if (data.aggs) params.aggs = data.aggs;
    if (data.size) params.size = data.size;
    if (data.lat_long_exact) params.lat_long_exact = data.lat_long_exact;
    if (data["aggs-interval"]) params["aggs-interval"] = data["aggs-interval"];

    // top topics type
    if (data["sentiment"]) params["sentiment"] = data["sentiment"];
    if (data["clustering_sort_by"]) params["clustering_sort_by"] = data["clustering_sort_by"];
    // wordcloud
    if (data["wordcloud_drilldown_query"]) params["wordcloud_drilldown_query"] = data["wordcloud_drilldown_query"];
    if (data["ocr_wordcloud_drilldown_query"]) params["ocr_wordcloud_drilldown_query"] = data["ocr_wordcloud_drilldown_query"];

    // top influencer
    if (data["arrangeBy"]) params["arrangeBy"] = data["arrangeBy"];

    if (data.extras) {
        data.extras.forEach((param) => {
            if (param.key === "Gender") {
                let genderVal = param.value === "unknown" ? "unknown,na,unisex" : param.value;
                params.gender = genderVal;
            }
            if (param.key === "region") params.region = param.value;
            if (param.key === "sub_region") params.sub_region = param.value;
            if (param.key === "lat_long_exact") params.lat_long_exact = param.value;
            if (param.key === "Source Type") params.source_type = param.value === "online" ? "0,1,3" : "2";
            if (param.key === "Sentiment") params.sentiment = param.value;
            if (param.key === "orderBy") {
                params.orderBy = param.value;
                params.order = "desc";
            }
            if (param.key === "clustering_category") params.clustering_category = param.value;
            if (param.key === "clustering_keyword") params.clustering_keyword = param.value;
            if (param.key === "User") {
                params.username = param.value;
                params.handlers = param.value;
            }

            if (param.key === "post_media_type") params.post_media_type = param.value;
            if (param.key === "Drilled Down Words") {
                let contentTerms = param.value[param.value.length - 1];
                params.content_terms = contentTerms;
                let drilldownQuery = param.value.slice(0, param.value.length - 1);
                if (drilldownQuery.length > 0) params.wordcloud_drilldown_query = drilldownQuery.map((w) => `+"${w}"`).join(" ");
            }
            if (param.key === "OCR Drilled Down Words") {
                let contentTerms = param.value[param.value.length - 1];
                params.ocr_content_terms = contentTerms;
                let drilldownQuery = param.value.slice(0, param.value.length - 1);
                if (drilldownQuery.length > 0) params.ocr_wordcloud_drilldown_query = drilldownQuery.map((w) => `+"${w}"`).join(" ");
            }
            if (param.key === "post_type") params.post_type = param.value;
            if (param.key === "published_date") params.published_date = param.value;
        });
    }

    return params;
};

const getFbAggsVal = (filter) => {
    let duration = filter.duration;
    if (duration === "custom") {
        duration = moment(filter.end_date).diff(filter.start_date, "days", true);
    }
    if (duration == "24HRS" || (duration >= 0 && duration <= 29)) {
        return "daily";
    } else if ((duration > 29 && duration <= 90) || duration === "lastmonth" || duration === "lastquarter") {
        return "weekly";
    } else if ((duration > 90 && duration < 500) || duration === "last2quarter") {
        return "monthly";
    } else return "yearly";
};

export const getFBDate = (filter) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let start_date, end_date;

    if (filter.duration === "custom") {
        start_date = moment(filter.start_date).format("YYYY-MM-DD");
        end_date = moment(filter.end_date).format("YYYY-MM-DD");
    } else if (filter.duration === "24HRS") {
        end_date = moment(new Date()).tz(tz).format("YYYY-MM-DD");
        start_date = moment(new Date())
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DD");
    } else if (filter.duration === "lastmonth") {
        start_date = moment(new Date()).subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end_date = moment(new Date()).startOf("month").subtract(1, "second").format("YYYY-MM-DD");
    } else if (filter.duration === "lastquarter") {
        start_date = moment(new Date()).startOf("quarter").subtract(1, "quarter").format("YYYY-MM-DD");
        end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DD");
    } else if (filter.duration === "last2quarter") {
        start_date = moment(new Date()).startOf("quarter").subtract(2, "quarter").format("YYYY-MM-DD");
        end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DD");
    } else {
        end_date = moment(new Date()).tz(tz).format("YYYY-MM-DD");
        start_date = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(filter.duration - 1, "days")
            .format("YYYY-MM-DD");
    }

    return { start_date, end_date };
};

export const getFbParams = ({ filter, selectedFbPage, widget, activeIndex, isUnique }) => {
    let params = {};

    // params["page_id"] = "230144587024811";
    params["page_id"] = selectedFbPage?.value;

    const { start_date, end_date } = getFBDate(filter);

    params["start_date"] = start_date;
    params["end_date"] = end_date;

    if (filter.aggs) params["filter_type"] = filter.aggs;

    if (filter["aggs-interval"]?.slice(-2) === "ly") params["agreegate_interval"] = filter["aggs-interval"];
    else
        params["agreegate_interval"] =
            filter["aggs-interval"] === undefined
                ? getFbAggsVal(filter)
                : filter["aggs-interval"] === "day" || filter["aggs-interval"] === "hour"
                ? "daily"
                : filter["aggs-interval"] + "ly";

    // params["is_unique"] = true;
    if (typeof isUnique === "boolean") params["is_unique"] = isUnique;

    if (["fbTotalAudienceByAge", "fbTotalAudienceByGender", "fbTotalAudienceByCountry"].includes(widget.chart_name)) delete params.is_unique;

    if (widget.chart_name === "fbPageViews") {
        if (activeIndex === 0) params["filter_type"] = "fb_page_view_by_total";
        else if (activeIndex === 2) {
            params["filter_type"] = "fb_page_view_by_device";
            params["is_unique"] = true;
        } else if (activeIndex === 1) {
            params["filter_type"] = "fb_page_view_by_section";
            params["is_unique"] = false;
        }
    }

    return params;
};

export const getFbUniqueParameter = (widgetName, isUnique) => {
    let data;
    switch (widgetName) {
        case "fbPageViews":
            if (isUnique) data = "totalUniqueViews";
            else data = "totalViews";
            break;
        case "fbPageFollowers":
            if (isUnique) data = "totalUniqueLikes";
            else data = "totalLikes";
            break;
        case "fbPageEngagement":
            if (isUnique) data = "totalUniqueEngagement";
            else data = "totalEngagement";
            break;
        case "fbPageReach":
            if (isUnique) data = "totalUniqueReach";
            else data = "totalReach";
            break;
        case "fbTotalPostLikes":
            data = "totalPostLikes";
            break;
        default:
            data = widgetName;
            break;
    }
    return data;
};

export const getTwitterParams = ({ filter, selectedTwitterPage }) => {
    let params = {};

    // params["page_id"] = "1500791145127116805";
    params["page_id"] = selectedTwitterPage?.value;

    let { start_date, end_date } = getFBDate(filter);
    params["start_date"] = start_date;
    params["end_date"] = end_date;

    if (filter.aggs) params["metrics"] = filter.aggs;

    if (filter["aggs-interval"]?.slice(-2) === "ly") params["agreegate_interval"] = filter["aggs-interval"];
    else
        params["agreegate_interval"] =
            filter["aggs-interval"] === undefined
                ? getFbAggsVal(filter)
                : filter["aggs-interval"] === "day" || filter["aggs-interval"] === "hour"
                ? "daily"
                : filter["aggs-interval"] + "ly";

    return params;
};
export const getReachChartParams = (arg) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    const { widget, filter, selectedInstagramPage } = arg;
    let param1 = {};

    if (filter.duration === "custom") {
        param1["start_date"] = moment(filter.start_date).format("YYYY-MM-DD");
        param1["end_date"] = moment(filter.end_date).format("YYYY-MM-DD");
    } else if (filter.duration === "24HRS") {
        param1["end_date"] = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        param1["start_date"] = moment(new Date())
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    } else {
        param1["end_date"] = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        param1["start_date"] = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(filter.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
    }
    let durationGap = moment(param1["end_date"]).diff(moment(param1["start_date"]), "days");
    param1["agreegate_interval"] = "daily";
    param1["filter_type"] = filter.aggs;
    param1["account_id"] = selectedInstagramPage?.value;
    let param2 = {};
    param2["end_date"] = param1["start_date"];
    param2["start_date"] = moment(param1["start_date"])
        .subtract(durationGap + 1, "days")
        .startOf("day")
        .format("YYYY-MM-DD");
    param2["agreegate_interval"] = "daily";
    param2["filter_type"] = filter.aggs;
    param2["account_id"] = selectedInstagramPage?.value;
    return { param1, param2 };
};
export const getInstagramParams = (widget, filter, selectedInstagramPage, activeTab, showUniqueLines) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    let filterType = filter.aggs;
    let params = {};
    if (widget.chart_name === "IgAudienceMetrics") {
        if (activeTab === 0) {
            params["chart_name"] = "audience_metrics_by_age";
        }
        if (activeTab === 1) {
            params["chart_name"] = "audience_metrics_by_gender";
        }
        if (activeTab === 2) {
            params["chart_name"] = "audience_metrics_by_country";
            filterType = "insta_audience_by_country";
        }
        if (activeTab === 3) {
            params["chart_name"] = "audience_metrics_by_city";
            filterType = "insta_audience_by_city";
        }
    }
    if (widget.chart_name === "IgPageFollowers") {
        params["chart_name"] = "insta_page_follower_change";
    }
    if (widget.chart_name === "IgPageViews") {
        params["chart_name"] = "insta_page_profile_views";
    }
    if (widget.chart_name === "IgPageEngagement") {
        if (activeTab === 0) {
            params["chart_name"] = "engagement_over_time";
            filterType = "insta_post_engagment_by_like_comment";
        }
        if (activeTab === 1) {
            params["chart_name"] = "engagement_by_reach";
            filterType = "insta_post_engagment_by_reach";
        }
        if (activeTab === 2) {
            params["chart_name"] = "engagement_by_impressions";
            filterType = "insta_post_engagment_by_impressions";
        }
        if (activeTab === 3) {
            params["chart_name"] = "engagement_by_video";
            filterType = "insta_post_engagment_by_video_views";
        }
        if (activeTab === 4) {
            params["chart_name"] = "engagement_by_bookmark";
            filterType = "insta_post_engagment_by_bookmark";
        }
    }
    if (widget.chart_name === "IgStoriesEngagement") {
        if (activeTab === 0) {
            params["chart_name"] = "insta_story";
            filterType = "insta_story_by_view_and_exits";
        }
        if (activeTab === 1) {
            params["chart_name"] = "insta_story_replies";
            filterType = "insta_story_by_replies";
        }
        if (activeTab === 2) {
            params["chart_name"] = "insta_story_by_taps";
            filterType = "insta_story_by_taps";
        }
        if (activeTab === 3) {
            params["chart_name"] = "insta_story_by_reach";
            filterType = "insta_story_by_reach";
        }
    }
    if (filter.duration === "custom") {
        params["start_date"] = moment(filter.start_date).format("YYYY-MM-DD");
        params["end_date"] = moment(filter.end_date).format("YYYY-MM-DD");
    } else if (filter.duration === "24HRS") {
        params["end_date"] = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params["start_date"] = moment(new Date())
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    } else {
        params["end_date"] = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params["start_date"] = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(filter.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
    }
    if (showUniqueLines) {
        params["is_unique"] = true;
    }
    params["agreegate_interval"] = filter["aggs-interval"] || getFbAggsVal(filter);
    params["filter_type"] = filterType || "";
    params["account_id"] = selectedInstagramPage?.value || "";

    return params;
};
export const getParamsURLEncoded = (data) => {
    let params = new URLSearchParams();
    Object.keys(data).map((d) => {
        if (d === "topic_data") {
            params.append(d, JSON.stringify(data[d]));
        } else params.append(d, data[d]);
    });

    return params;
};

export const formatEntityType = (et, est) => {
    let entityType = et.split(",");
    let entitySubType = est.split(",");
    let boolStrings = [];

    if (entityType.includes("person")) {
        let personBoolean = "post.entity_type:person ";
        let subParams = [];
        if (entitySubType.includes("male")) subParams.push("male");
        if (entitySubType.includes("female")) subParams.push("female");
        if (entitySubType.includes("unknown")) subParams.push("unknown");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            personBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${personBoolean})`);
    }

    if (entityType.includes("non-person")) {
        let nonPerBoolean = "post.entity_type:non-person ";
        let subParams = [];
        if (entitySubType.includes("brand")) subParams.push("brand");
        if (entitySubType.includes("news")) subParams.push("news");
        if (subParams.length) {
            subParams = subParams.map((sp) => "post.entity_sub_type:" + sp).join(" OR ");
            nonPerBoolean += `AND (${subParams})`;
        }
        boolStrings.push(`(${nonPerBoolean})`);
    }

    if (entityType.includes("unknown")) {
        boolStrings.push(`(post.entity_type:unknown)`);
    }

    return boolStrings.join(" OR ");
};

export const formatVolumeOfNewsData = (response, params) => {
    let xs = [];
    let nodata = true;
    let data = {};
    data.total = [];
    data.online = [];
    data.offline = [];

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    response.aggregations.volume_of_conversation_source_type_breakup.buckets.forEach((d, i) => {
        let date = d.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        xs.push(date);
        data.total.push(d.doc_count);
        let online_value = d.source_type_breakup.buckets.filter((ov) => ov.key === 0 || ov.key === 1 || ov.key === 3);
        let offline_value = d.source_type_breakup.buckets.filter((ov) => ov.key === 2);
        if (online_value.length) {
            nodata = false;
            let online_total = 0;
            online_value.forEach((v) => {
                online_total += v.doc_count;
            });
            data.online.push(online_total);
        } else {
            data.online.push(0);
        }
        if (offline_value.length) {
            nodata = false;
            data.offline.push(offline_value[0].doc_count);
        } else {
            data.offline.push(0);
        }
    });

    let finalData = {
        online: [],
        offline: [],
        total: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    xs.forEach((x, i) => {
        finalData.online.push({ x, y: data.online[i], newsType: "online" });
        finalData.offline.push({ x, y: data.offline[i], newsType: "offline" });
        finalData.total.push({ x, y: data.total[i], newsType: "total" });
    });
    finalData.date.start_date = params.start_date;
    finalData.date.end_date = params.end_date;

    return { xs, data: finalData, nodata: nodata };
};

export const formatData = ({ data, chart_name, options = {}, params, previousData, comparisionData, widget, advanceChart }) => {
    let res = {};
    if (advanceChart) {
        res = formatAdvanceChartData(data, advanceChart, params);
    }
    if (chart_name === "estReach") res = formatEstimatedReach(data, params);
    if (chart_name === "volumeOfNews") res = formatVolumeOfNewsData(data, params);
    if (chart_name === "overallEntityAnalysis") res = formatOverallEntity(data);
    if (chart_name === "platformWiseEntityAnalysis") res = formatPlatformWiseEntityAnalysis(data, params);
    if (chart_name === "platformWiseMediaBreakdown") res = formatPlatformWiseMediaBreakdown(data);
    if (chart_name === "platformWiseSentimentAnalysis") res = formatPlatformWiseSentimentAnalysis(data);
    if (chart_name === "entitywiseSentimentBreakup") res = formatEntitySentiment(data);
    if (chart_name === "channelAnalysis") res = formatChannelAnalysis(data);
    if (chart_name === "channelAnalysisEngagementWise") res = formatChannelAnalysisEngagementWise(data);
    if (chart_name === "netSentiment") {
        res = formatNetSentiment(data, params);
    }

    if (chart_name === "conversationOverTimeWithAverageBand") {
        res = formatConversationOvertimeWithAVGChart(data, params);
    }
    if (chart_name === "conversationOverTime" || chart_name === "sentimentOverTime") {
        res = formatSentimentOvertimeChart(data, params);
    }
    if (chart_name === "positiveSentimentPercentOverTime") {
        res = formatPositiveSentimentOvertime(data, params);
    }
    if (chart_name === "engagementOverTime") {
        res = formatEngagementOvertime(data, params);
    }
    if (chart_name === "uniqueUsersOverTime") {
        res = formatUniqueUsersOverTime(data, params, comparisionData);
    }
    if (chart_name === "topTopics") {
        res = formatTopTopics(data, options, params);
    }
    if (chart_name === "overallSentiment") res = formatOverallSentiment(data);
    if (chart_name === "wordcloud") res = formatWordcloud(data, params);
    if (chart_name === "ocrWordcloud") res = formatOCRWordcloud(data, params);
    if (chart_name === "mentionsMap") res = formatMentionsMap(data);
    if (chart_name === "moments") {
        res = getMomentsData(data.aggregations.tag_categories_breakup_over_time.buckets, data.meta.child_tags_data);
    }
    if (chart_name === "momentovertime") {
        res = getMomentsOvertimeData(data.aggregations.tag_categories_breakup_over_time.buckets, data.meta.child_tags_data, params);
    }
    if (chart_name === "topKeywordsPositive" || chart_name === "topKeywordsNegative") {
        res = data.aggregations.wordcloud.buckets;
    }
    if (chart_name === "overallShareOfVoice") {
        res = formatOverallShareOfVoiceData(data, params);
    }
    if (chart_name === "overallShareOfVoiceBySubtopics") {
        res = formatOverallShareOfVoiceBySubtopicsData(data, params);
    }
    if (chart_name === "shareOfVoiceNews") {
        res = formatOverallShareOfVoiceByNewsData(data, params);
    }
    if (chart_name === "topicWiseSentimentBreakup") {
        res = formatSubTopicWiseSentimentBreakup(data);
    }
    if (chart_name === "subtopicWiseSentimentBreakup") {
        res = formatTopicWiseSentimentBreakup(data);
    }
    if (chart_name === "topicWiseStackedSentimentBreakup") {
        res = formatSubTopicWiseStackedSentimentBreakup(data);
    }
    if (chart_name === "subtopicWiseStackedSentimentBreakup") {
        res = formatTopicWiseStackedSentimentBreakup(data);
    }
    if (chart_name === "generalTrends") {
        res = formatGeneralTrends(data, params);
    }
    if (chart_name === "generalTrendsWithTopics") {
        //res = data;
        res = formatGeneralTrendsWithTopicsData(data, params);
    }
    if (chart_name === "leaderboardAndHealth") {
        res = formatLeaderboardAndHealthData(data);
    }
    if (chart_name === "rawConversations") {
        res = data.hits;
    }
    if (chart_name === "totalMentions") {
        res = { current: data?.hits?.total, previous: previousData?.hits?.total };
    }
    if (chart_name === "totalNegativeSentiment") {
        res = { current: data?.hits?.total, previous: previousData?.hits?.total };
    }
    if (chart_name === "totalUniqueUsers") {
        res = {
            current: data?.aggregations?.total_unique_users?.value,
            previous: previousData?.aggregations?.total_unique_users?.value,
        };
    }
    if (chart_name === "totalEstimatedReach") {
        res = {
            current: data?.aggregations?.total_estimated_reach?.value,
            previous: previousData?.aggregations?.total_estimated_reach?.value,
        };
    }
    if (chart_name === "totalEngagement") {
        let currentData;
        let prevData;

        currentData = data?.aggregations?.comment_count?.value + data?.aggregations?.like_count?.value + data?.aggregations?.share_count?.value;
        prevData =
            previousData?.aggregations?.comment_count?.value + previousData?.aggregations?.like_count?.value + previousData?.aggregations?.share_count?.value;

        if (!widget?.widget_filter?.excludeViews) {
            currentData += data?.aggregations?.view_count?.value;
            prevData += previousData?.aggregations?.view_count?.value;
        }
        res = { current: currentData, previous: prevData };
        // res = { current: data?.aggregations?.total_impact_value?.value, previous: previousData?.aggregations?.total_impact_value?.value };
    }

    if (chart_name === "IAoverallShareOfVoiceForLogo") {
        res = formatOverallShareOfVoiceDataForLogo(data, params);
    }

    if (chart_name === "IAoverallShareOfVoiceForObject") {
        res = formatOverallShareOfVoiceDataForObject(data, params);
    }

    if (chart_name === "IAoverallShareOfVoiceForScenes") {
        res = formatOverallShareOfVoiceDataForScene(data, params);
    }

    if (chart_name === "PAShareOfVoice") {
        res = formatProductAttributeShareOfVoiceData(data, params);
    }
    if (chart_name === "topicWiseStackedPlatformBreakdown") {
        res = formatTopicWiseStackedPlatformBreakdown(data, params);
    }

    if (chart_name === "subTopicWiseStackedPlatformBreakdown") {
        res = formatSubTopicWiseStackedPlatformBreakdown(data, params);
    }

    if (chart_name === "PAInsights") {
        res = formatProductAttributesSentimentAnalysis(data, params);
    }
    if (chart_name === "uniqueUsersOverTimebyTopic") {
        res = formatUniqueUsersOverTimeByTopic(data, params);
    }
    if (chart_name === "engagementOverTimeByTopic") {
        res = formatEngagementOverTimeByTopic(data, params);
    }
    if (chart_name === "engagementOverTimeBySubTopic") {
        res = formatEngagementOverTimeBySubTopic(data, params);
    }
    if (chart_name === "EAShareOfVoice") {
        res = formatEmotionAnalyticsShareOfVoiceData(data, params);
    }
    if (chart_name === "topicWiseStackedEmotionsBreakdown") {
        res = formatTopicWiseStackedEmotionsBreakdown(data, params);
    }
    if (chart_name === "shareOfVoiceSubTopicWiseBreakDown") {
        res = formatShareOfVoiceWithSubTopicWiseBreakdown(data, params);
    }
    if (chart_name === "uniqueUsersOverTimebySubTopic") {
        res = formatUniqueUsersOverTimeBySubTopic(data, params);
    }
    if (chart_name === "dashboardEngagementOverTime") {
        res = formatDashboardEngagementOverTime(data, params);
    }
    if (chart_name === "TopicwiseEngagementOverTime") {
        res = formatTopicEngagementOverTime(data, params);
    }

    return res;
};

export const formatData_2 = ({ data, chart_name, options = {}, params }) => {
    let res = {};

    if (chart_name === "mentionsMap") res = formatMentionMapStateData(data);

    return res;
};

export const formatConversationOvertimeWithAVGChart = (data, params) => {
    let res = {
        chartData: [],
        nodata: false,
        total: 0,
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let values = [];

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    data.aggregations.conversation_over_time_sentiment.buckets.forEach((d, i) => {
        let date = d.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        res.chartData.push({
            x: date,
            y: d.doc_count,
        });
        res.total += d.doc_count;
        values.push(d.doc_count);
    });

    if (res.total > 0) {
        let avgBandValues = [0, 0];

        let absAverages = 0;
        let tpAverage = 0;
        if (values.length > 0) tpAverage = res.total / values.length;
        let diff = 0;

        if (values.length > 1) {
            for (let i = values.length - 1; i >= 1; i--) {
                diff = values[i] - values[i - 1];
                absAverages += Math.abs(diff);
            }
        } else {
            absAverages = values[0];
        }

        absAverages = absAverages / values.length;
        absAverages = absAverages * 2.66;

        avgBandValues[0] = +Math.round(tpAverage + absAverages).toFixed(0);
        avgBandValues[1] = +Math.round(tpAverage - absAverages).toFixed(0);

        let minValue = Math.min(...values);
        let maxValue = Math.max(...values);

        let range = Math.round((maxValue - minValue) / 10);

        if (!range) {
            range += 1;
        }

        if (maxValue > parseInt(avgBandValues[0])) {
            maxValue = maxValue + range;
        } else {
            maxValue = parseInt(avgBandValues[0]) + range;
        }

        if (minValue < parseInt(avgBandValues[1])) {
            minValue = minValue - range;
        } else {
            minValue = parseInt(avgBandValues[1]) - range;
        }

        res.minValue = minValue;
        res.maxValue = maxValue;
        res.avgBandValues = avgBandValues;
    } else res.nodata = true;
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;
    return res;
};

export const formatLeaderboardAndHealthData = (data) => {
    let reach_sum = 0;
    let mentions_sum = 0;
    let engagement_sum = 0;
    let nodata = false;
    data.forEach((elem) => {
        reach_sum += elem.total_reach;
        mentions_sum += elem.total_mentions;
        engagement_sum += elem.total_engagement;
    });
    if (reach_sum === 0 && mentions_sum === 0 && engagement_sum === 0) nodata = true;
    let res = { data, reach_sum, mentions_sum, engagement_sum, nodata };
    return res;
};

export const formatOverallSentiment = (response) => {
    let data = {
        chartData: [],
        nodata: false,
        total: 0,
    };

    response = formatSentimentOvertime(response);

    let res = [];
    for (let sent in response.data) {
        let z = response.data[sent].reduce((x, y) => x + y, 0);
        data.total += z;
        res.push([sent, z]);
    }

    if (data.total === 0) data.nodata = true;
    else
        res.forEach((x) => {
            data.chartData.push({
                color: getSentimentColor(x[0]),
                name: toTitleCase(x[0]),
                y: +((x[1] / data.total) * 100).toFixed(2),
                doc_count: x[1],
                short_name: x[0],
            });
        });

    data.response = res;
    return data;
};

export const formatSentimentOvertime = (data) => {
    let res = {};
    res.xs = [];
    let neutral = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let positive = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let negative = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);

    res.data = { positive, negative, neutral };

    data.aggregations.conversation_over_time_sentiment.buckets.forEach((bucket, ind) => {
        res.xs.push(bucket.key);
        bucket["sentiments.sentiment_group"].group1.group2.buckets.forEach((sent) => {
            if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res.data[sent.key][ind] = sent.doc_count;
        });
    });

    return res;
};

export const formatNetSentiment = (data, params) => {
    let xs = [];
    let neutral = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let positive = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let negative = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let netSentimentPercentage = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);

    let res = {
        nodata: false,
        chartData: [],
        positive: [],
        negative: [],
        neutral: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let temp = { positive, negative, neutral, netSentimentPercentage };
    let total = 0;

    data.aggregations.conversation_over_time_sentiment.buckets.forEach((bucket, ind) => {
        xs.push(bucket.key);

        let totalData = bucket.doc_count;
        total += totalData;
        bucket["sentiments.sentiment_group"].group1.group2.buckets.forEach((sent) => {
            if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                temp[sent.key][ind] = sent.doc_count;
            }
        });
        res.positive.push(temp.positive[ind]);
        res.negative.push(temp.negative[ind]);
        res.neutral.push(temp.neutral[ind]);
        if (totalData !== 0) {
            temp.positive[ind] = (temp.positive[ind] / totalData) * 100;
            temp.negative[ind] = (temp.negative[ind] / totalData) * 100;
            temp.netSentimentPercentage[ind] = temp.positive[ind] - temp.negative[ind];
        } else {
            temp.positive[ind] = 0;
            temp.negative[ind] = 0;
        }
    });

    // Axes
    let netSentiment = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);

    if (total === 0) res.nodata = true;
    //if (res.total.average==="0.00") res.nodata = true;
    else {
        let avg = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        for (let i = 0; i < netSentiment.length; i++) {
            if (temp.positive[i] == 0 && temp.negative[i] == 0) {
                netSentiment[i] = 0;
            } else {
                // netSentiment[i] = (temp.positive[i] - temp.negative[i]) / (temp.positive[i] + temp.negative[i]);

                // netSentiment[i] = netSentiment[i] * 5;
                // netSentiment[i] = netSentiment[i] ? netSentiment[i].toFixed(2) : "0";

                netSentiment[i] = temp.netSentimentPercentage[i].toFixed(2);
            }
            avg += +netSentiment[i];
            let date = xs[i];
            if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) continue;
            if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
            res.chartData.push({
                x: date,
                y: +netSentiment[i],
                positive: res.positive[i],
                negative: res.negative[i],
                neutral: res.neutral[i],
            });
        }

        if (netSentiment.length > 0) avg /= netSentiment.length;
        res.average = avg.toFixed(2);
        // if( res.average ==="0.00")res.nodata = true;
    }
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;

    return res;
};

export const formatSentimentOvertimeChart = (data, params) => {
    let res = {};
    let chartData = {
        positive: [],
        negative: [],
        neutral: [],
        total: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let nodata = false;
    let totalData = 0;
    res.xs = [];
    let neutral = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let positive = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let negative = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);
    let total = new Array(data.aggregations.conversation_over_time_sentiment.buckets.length).fill(0);

    res.data = { positive, negative, neutral, total };

    data.aggregations.conversation_over_time_sentiment.buckets.forEach((bucket, ind) => {
        res.xs.push(bucket.key);
        bucket["sentiments.sentiment_group"].group1.group2.buckets.forEach((sent) => {
            if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res.data[sent.key][ind] = sent.doc_count;
        });
        res.data["total"][ind] = bucket.doc_count;
        totalData += bucket.doc_count;
    });

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (totalData > 0) {
        Object.keys(res.data).forEach((x) => {
            res.data[x].forEach((d, i) => {
                let date = res.xs[i];
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                date = chartData[x].push({
                    x: date,
                    y: d,
                    sentiment: x,
                });
            });
        });
    } else nodata = true;
    chartData.date.start_date = params.start_date;
    chartData.date.end_date = params.end_date;

    return { nodata, chartData };
};

export const formatPositiveSentimentOvertime = (data, params) => {
    let res = {
        date: {
            start_date: "",
            end_date: "",
        },
    };
    res.xs = [];
    let nodata = true;

    let neutral = [];
    let positive = [];
    let negative = [];

    res.data = { positive, negative, neutral };

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    data.aggregations.conversation_over_time_sentiment.buckets.forEach((bucket, ind) => {
        let date = bucket.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        res.xs.push(date);
        bucket["sentiments.sentiment_group"].group1.group2.buckets.forEach((sent) => {
            if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                res.data[sent.key].push(sent.doc_count);
                if (sent.key === "positive" && sent.doc_count) {
                    nodata = false;
                }
            }
        });
    });

    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;

    return { data: res, nodata: nodata };
};

export const formatEstimatedReach = (data, params) => {
    let estReach = {};
    let executed = false;
    let fcount = 0;
    estReach.timeseries = formatEstReachTimeseries(data, params);
    estReach.agg = formatEstReachAgg(estReach.timeseries);
    if (fcount == 0) {
        fcount++;
        estReach.agg = formatEstReachAgg(estReach.timeseries);
    } else {
        fcount++;
        estReach.agg = formatEstReachAgg(estReach.timeseries);
    }
    return estReach;
};

let formatEstReachTimeseries = (data, params) => {
    let xset = new Set();
    let xs = [];
    let avgres = {};
    let totres = {};

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    data.aggregations.conversation_over_time_platformwise_estimated_reach.buckets.forEach((bucket) => {
        bucket.data_over_time.buckets.forEach((bkt, ind) => {
            let date = bkt.key;
            if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
            if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
            xset.add(date);
        });
    });
    xset.forEach((v) => xs.push(v));
    data.aggregations.conversation_over_time_platformwise_estimated_reach.buckets.forEach((bucket) => {
        avgres[bucket.key] = Array(xs.length).fill(0);
        totres[bucket.key] = Array(xs.length).fill(0);
        bucket.data_over_time.buckets.forEach((bkt, i) => {
            // totres[bucket.key][xs.indexOf(bkt.key)] = bkt.stats.sum || 0;
            // avgres[bucket.key][xs.indexOf(bkt.key)] = bkt.stats.avg || 0;
            if (i <= xs.length - 1) {
                totres[bucket.key][i] = bkt.stats.sum || 0;
                avgres[bucket.key][i] = bkt.stats.avg || 0;
            }
        });
    });

    // get data for all
    let totAll = Array(xs.length).fill(0);
    let avgAll = Array(xs.length).fill(0);

    for (let plrfm in totres) {
        totres[plrfm].forEach((val, ind) => {
            totAll[ind] += val;
        });
    }

    for (let plrfm in avgres) {
        avgres[plrfm].forEach((val, ind) => {
            avgAll[ind] += val;
        });
    }

    avgres["ALL"] = avgAll;
    totres["ALL"] = totAll;

    return { xs, avgres, totres };
};

let formatEstReachAgg = (data) => {
    let tot = {};
    let avg = {};
    for (let pltfr in data.totres) {
        if (pltfr !== "ALL") tot[pltfr] = data.totres[pltfr].reduce((x, y) => x + y, 0);
    }
    for (let pltfr in data.avgres) {
        if (pltfr !== "ALL") avg[pltfr] = data.avgres[pltfr].reduce((x, y) => x + y, 0);
    }
    return { tot, avg };
};

export const formatOverallEntity = (response) => {
    let data = {
        chartData: [],
        nodata: false,
        total: 0,
    };
    let res = {};
    let total = 0;
    response.aggregations["entity-sub-type-breakup"].buckets.forEach((entity) => {
        if (entity.key.includes("unknown")) return;
        res[entity.key] = entity.doc_count || 0;
        total += entity.doc_count;
    });
    if (total === 0) data.nodata = true;
    else {
        data.total = total;
        data.chartData.push({
            color: getEntityColor("male"),
            name: "Male",
            y: +((+res.male / total) * 100).toFixed(2),
            doc_count: +res.male,
            short_name: "male",
        });
        data.chartData.push({
            color: getEntityColor("female"),
            name: "Female",
            y: +((+res.female / total) * 100).toFixed(2),
            doc_count: +res.female,
            short_name: "female",
        });
        // data.chartData.push({
        //     color: getEntityColor("unknown"),
        //     name: "Unknown",
        //     y: +((+res.unknown / total) * 100).toFixed(2),
        //     doc_count: +res.unknown,
        //     short_name: "unknown",
        // });
        data.chartData.push({
            color: getEntityColor("news"),
            name: "News",
            y: +((+res.news / total) * 100).toFixed(2),
            doc_count: +res.news,
            short_name: "news",
        });
        data.chartData.push({
            color: getEntityColor("brand"),
            name: "Brand",
            y: +((+res.brand / total) * 100).toFixed(2),
            doc_count: +res.brand,
            short_name: "brand",
        });

        data.chartData.sort((a, b) => b.doc_count - a.doc_count);
    }
    data.response = res;

    return data;
};

export const formatPlatformWiseEntityAnalysis = (response, params) => {
    const platforms = store.getState().filterSettingReducer.platformsActive;
    const data = {};
    const excludePlatformId = "6ce32d7c-a789-11e4-a34f-74867a1157ba";

    if (params.platform) {
        params.platform = params.platform.filter((p) => p !== excludePlatformId);

        params.platform.forEach((p) => {
            let platformData = platforms.find((x) => x.id === p);
            data[p] = {
                platformId: p,
                platformName: platformData.name,
                platformShortName: platformData.short_name,
                entity: [],
                chartData: [],
                total: 0,
            };
        });
    } else {
        platforms.forEach((p) => {
            data[p.id] = {
                platformId: p.id,
                platformName: p.name,
                platformShortName: p.short_name,
                entity: [],
                chartData: [],
                total: 0,
            };
        });
    }
    let res = { data: [], total: 0, nodata: false };

    response.aggregations["platforms-with-entity-sub-type-breakup"].buckets.forEach((platform) => {
        let entity = [];
        platform.sentiment_group.buckets.map((e) => {
            if (!e.key.includes("unknown")) entity.push([e.key, e.doc_count]);
        });

        // let platformData = platforms.find((p) => p.id === platform.key);
        let t = 0;
        let chartData = entity.map((d) => {
            t += d[1];
            return {
                color: getEntityColor(d[0].toLowerCase()),
                name: toTitleCase(d[0]),
                entityType: d[0],
                platformId: platform.key,
                y: +d[1],
                doc_count: d[1],
                short_name: d[0],
            };
        });

        if (t === 0) return;

        res.total += t;
        data[platform.key] = {
            ...data[platform.key],
            entity,
            chartData,
            total: t,
        };
    });

    if (res.total === 0) res.nodata = true;
    else {
        res.data = Object.values(data);
        res.data.sort((a, b) => {
            if (a.platformName?.toLowerCase() > b.platformName?.toLowerCase()) {
                return 1;
            }
            if (b.platformName?.toLowerCase() > a.platformName?.toLowerCase()) {
                return -1;
            }
            return 0;
        });
    }

    return res;
};

export const formatTopicWiseStackedPlatformBreakdown = (data, params) => {
    const platforms = store.getState().filterSettingReducer.masterPlatforms;
    const topicsObject = store.getState().filterSettingReducer.topicsObject;

    let ret = {
        others: [],
        maximizeStackedBarData: [],
        chartDataBar: [],
        nodata: false,
        total: 0,
        csvData: [],
    };
    let barData = [];
    let total = 0;
    let platformObj = {};
    platforms.forEach((ele) => {
        platformObj[ele.id] = ele.name;
    });
    let allPlatforms = params.platform;
    let platformInfo = [];
    let maximiseInfo = [];
    let staticData = [];
    let maximizeBar = [];
    let downloadStaticData = [];
    let respData = data.sort((a, b) => b.total - a.total);

    let othersTopicCount = 0;
    respData.forEach((topic, tpc_index) => {
        if (topic.value != 0 && tpc_index < 49) {
            maximizeBar.push({
                name: topic.topic_name,
                y: 0,
                topicId: [],
                subtopicId: [],
                platformId: [],
                topic_total: topic.total,
            });
        }
        if (tpc_index < 9) {
            staticData.push({
                name: topic.topic_name,
                y: 0,
                topicId: [],
                subtopicId: [],
                platformId: [],
                topic_total: topic.total,
            });
        } else {
            othersTopicCount += topic.total;
        }
        downloadStaticData.push({ name: topic.topic_name, y: 0 });
    });
    if (respData.length > 9) {
        staticData.push({
            name: "Others",
            y: 0,
            topicId: [],
            subtopicId: [],
            platformId: [],
            topic_total: othersTopicCount,
        });
    }

    allPlatforms.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["platform_id"] = key;
        allPlatformsOutput["name"] = platformObj[key];
        allPlatformsOutput["color"] = getPlatformColorCode(platformObj[key]);
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(staticData));
        allPlatformsOutput["download_data"] = JSON.parse(JSON.stringify(downloadStaticData));
        platformInfo.push(allPlatformsOutput);
    });

    allPlatforms.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["platform_id"] = key;
        allPlatformsOutput["name"] = platformObj[key];
        allPlatformsOutput["color"] = getPlatformColorCode(platformObj[key]);
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(maximizeBar));
        maximiseInfo.push(allPlatformsOutput);
    });

    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topic_id);
        topic?.aggregations?.channel_analysis?.buckets?.forEach((bucket, b_index) => {
            let p_id = bucket.key;
            total += bucket.doc_count;
            let index_p = platformInfo.findIndex((ele) => ele.platform_id === p_id);
            if (index_p !== -1) {
                if (tpc_index < 9) {
                    platformInfo[index_p].data[tpc_index].y = bucket.doc_count;
                    if (topicsObject[topic.topic_id].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[tpc_index].topicId.push(topic.topic_id);
                    } else {
                        platformInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                    }

                    platformInfo[index_p].data[tpc_index].platformId.push(platformInfo[index_p].platform_id);
                    platformInfo[index_p].count += bucket.doc_count;
                    count += bucket.doc_count;
                } else {
                    platformInfo[index_p].data[9].y += bucket.doc_count;
                    if (topicsObject[topic.topic_id].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[9].topicId.push(topic.topic_id);
                    } else {
                        platformInfo[index_p].data[9].subtopicId.push(subTopic[0]?.subtopicIds);
                    }
                    platformInfo[index_p].data[9].platformId.push(platformInfo[index_p].platform_id);
                    platformInfo[index_p].count += bucket.doc_count;
                    count += bucket.doc_count;
                }
                platformInfo[index_p].download_data[tpc_index].y = bucket.doc_count;
            }
        });
    });

    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topic_id);
        topic?.aggregations?.channel_analysis?.buckets?.forEach((bucket, b_index) => {
            let p_id = bucket.key;
            total += bucket.doc_count;
            let index_p = maximiseInfo.findIndex((ele) => ele.platform_id === p_id);
            if (index_p !== -1) {
                maximiseInfo[index_p].data[tpc_index].y = bucket.doc_count;
                if (topicsObject[topic.topic_id].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                    maximiseInfo[index_p].data[tpc_index].topicId.push(topic.topic_id);
                } else {
                    maximiseInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                }

                maximiseInfo[index_p].data[tpc_index].platformId?.push(maximiseInfo[index_p].platform_id);
                maximiseInfo[index_p].count += bucket.doc_count;
                count += bucket.doc_count;
            }
        });
    });
    let filteredData = platformInfo.filter((ele) => ele.count > 0);
    let filteredMaximiseData = maximiseInfo.filter((ele) => ele.count > 0);
    if (total === 0) {
        ret.nodata = true;
    } else {
        ret.chartDataBar = filteredData;
        ret.total = total;
        ret.maximizeStackedBarData = filteredMaximiseData;
    }
    return ret;
};
export const formatSubTopicWiseStackedPlatformBreakdown = (data, params) => {
    const platforms = store.getState().filterSettingReducer.masterPlatforms;
    let ret = {
        others: [],
        maximizeStackedBarData: [],
        chartDataBar: [],
        nodata: false,
        total: 0,
        csvData: [],
    };
    let total = 0;
    let platformObj = {};
    platforms.forEach((ele) => {
        platformObj[ele.id] = ele.name;
    });
    let allPlatforms = params.platform;
    let platformInfo = [];
    let maximiseInfo = [];
    let staticData = [];
    let maximizeBar = [];
    let downloadStaticData = [];
    let respData = data;
    let othersTopicCount = 0;

    let unSortedSubTopic = [];
    respData.forEach((topic, tpc_index) => {
        topic.subtopics.forEach((subtopic, sub_index) => {
            unSortedSubTopic.push({
                main_subtopic_name: `${subtopic.subtopic_name + " (" + topic.topic_name + ")"}`,
                subtopic_name: subtopic.subtopic_id,
                topicId: topic.topic_id,
                subtopicId: subtopic.subtopic_id,
                total: subtopic.total,
                aggregations: subtopic.aggregations,
                topic_name: topic.topic_name,
            });
        });
    });
    let sortedSubTopic = unSortedSubTopic.sort((a, b) => b.total - a.total);
    let othersSubTopics = [];
    sortedSubTopic.forEach((subtopic, sub_ind) => {
        if (sub_ind < 9) {
            staticData.push({
                name: subtopic.subtopic_name,
                main_subtopic_name: subtopic.main_subtopic_name,
                y: 0,
                topicId: [],
                subtopicId: [subtopic.subtopicId],
                platformId: [],
                subtopic_total: subtopic.total,
                topic_name: subtopic.topic_name,
            });
        } else {
            othersTopicCount += subtopic.total;
            othersSubTopics.push(subtopic.subtopicId);
        }
        maximizeBar.push({
            name: subtopic.subtopic_name,
            main_subtopic_name: subtopic.main_subtopic_name,
            y: 0,
            topicId: [],
            subtopicId: [subtopic.subtopicId],
            platformId: [],
            subtopic_total: subtopic.total,
            topic_name: subtopic.topic_name,
        });
        downloadStaticData.push({ name: subtopic.main_subtopic_name, y: 0 });
    });
    if (sortedSubTopic.length > 9) {
        staticData.push({
            name: "Others",
            y: 0,
            topicId: [],
            subtopicId: othersSubTopics,
            platformId: [],
            subtopic_total: othersTopicCount,
            topic_name: "",
            main_subtopic_name: "Others",
        });
    }
    allPlatforms.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["platform_id"] = key;
        allPlatformsOutput["name"] = platformObj[key];
        allPlatformsOutput["color"] = getPlatformColorCode(platformObj[key]);
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(staticData));
        allPlatformsOutput["download_data"] = JSON.parse(JSON.stringify(downloadStaticData));
        platformInfo.push(allPlatformsOutput);
    });

    allPlatforms.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["platform_id"] = key;
        allPlatformsOutput["name"] = platformObj[key];
        allPlatformsOutput["color"] = getPlatformColorCode(platformObj[key]);
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(maximizeBar));
        maximiseInfo.push(allPlatformsOutput);
    });
    sortedSubTopic.forEach((subtopic, sub_index) => {
        let count = 0;
        subtopic?.aggregations?.channel_analysis?.buckets?.forEach((bucket, b_index) => {
            let p_id = bucket.key;
            total += bucket.doc_count;
            let index_p = platformInfo.findIndex((ele) => ele.platform_id === p_id);
            if (index_p !== -1) {
                if (sub_index < 9) {
                    platformInfo[index_p].data[sub_index].y = bucket.doc_count;
                    platformInfo[index_p].data[sub_index].platformId.push(platformInfo[index_p].platform_id);
                    platformInfo[index_p].count += bucket.doc_count;
                    count += bucket.doc_count;
                } else {
                    platformInfo[index_p].data[9].y += bucket.doc_count;
                    platformInfo[index_p].data[9].platformId.push(platformInfo[index_p].platform_id);
                    platformInfo[index_p].count += bucket.doc_count;
                    count += bucket.doc_count;
                }
                platformInfo[index_p].download_data[sub_index].y = bucket.doc_count;
                maximiseInfo[index_p].data[sub_index].y = bucket.doc_count;
                maximiseInfo[index_p].data[sub_index].platformId?.push(maximiseInfo[index_p].platform_id);
                maximiseInfo[index_p].count += bucket.doc_count;
            }
        });
    });
    let filteredData = platformInfo.filter((ele) => ele.count > 0).sort((a, b) => b.count - a.count);
    let filteredMaximiseData = maximiseInfo.filter((ele) => ele.count > 0).sort((a, b) => b.count - a.count) || [];
    if (filteredMaximiseData[0]?.data?.length > 50) {
        filteredMaximiseData = filteredMaximiseData.map((ele) => {
            return { ...ele, data: ele.data.splice(0, 49) };
        });
    }
    if (total === 0) {
        ret.nodata = true;
    } else {
        ret.chartDataBar = filteredData;
        ret.total = total;
        ret.maximizeStackedBarData = filteredMaximiseData;
    }

    return ret;
};
export const formatPlatformWiseMediaBreakdown = (data) => {
    const platforms = store.getState().filterSettingReducer.masterPlatforms;
    let res = [];
    data.aggregations["platforms-with-media-breakup"].buckets.forEach((platform) => {
        let medias = platform.media_group.buckets.map((media) => [media.key, media.doc_count]);

        try {
            ["image", "text", "video"].forEach((media) => {
                if (!medias.find((x) => x[0] === media)) medias.push([media, 0]);
            });
        } catch (e) {
            console.log(e);
        }

        let chartData = medias.map((d) => {
            return {
                color: getEntityColor(d[0].toLowerCase()),
                name: toTitleCase(d[0]),
                mediaType: d[0],

                platformId: platform.key,
                y: d[1],
                doc_count: d[1],
                short_name: d[0],
            };
        });

        let platformData = platforms.find((p) => p.id === platform.key);
        if (platformData)
            res.push({
                platformId: platform.key,
                platformName: platformData.name,
                medias,
                platformShortName: platformData.short_name,
                chartData,
                total: platform.doc_count,
            });
    });
    return res;
};

export const formatEntitySentiment = (data) => {
    let agg = {};
    data.aggregations["entity-sub-type-sentiments-breakup"].buckets.forEach((entity) => {
        if (entity.key !== "unknown") {
            agg[entity.key] = {};
            entity.sentiment_group.group1.group2.buckets.forEach((sent) => {
                agg[entity.key][sent.key] = sent.doc_count;
            });
        }
    });

    let res = {};
    res.positive = [];
    res.negative = [];
    res.neutral = [];
    res.keys = [];
    res.nodata = true;

    for (let gender in agg) {
        if (gender) {
            let gendername = gender.split("");
            let initLetter = gendername[0].toUpperCase();
            let actualName = gendername.slice(1, gendername.length);

            actualName.unshift(initLetter);
            actualName = actualName.join("");
            res.keys.push(actualName);
            let positive = agg[gender].positive || 0;
            let negative = agg[gender].negative || 0;
            let neutral = agg[gender].neutral || 0;
            res.positive.push({
                entityType: gender,
                sentiment: "positive",
                y: positive,
            });
            res.negative.push({
                entityType: gender,
                sentiment: "negative",
                y: negative,
            });
            res.neutral.push({
                entityType: gender,
                sentiment: "neutral",
                y: neutral,
            });
            if (positive > 0 || negative > 0 || neutral > 0) res.nodata = false;
        }
    }
    return res;
};

export const formatTopicWiseStackedSentimentBreakup = (data) => {
    let totalData = 0;
    let tot = 0;
    let restPos = 0;
    let resNegative = 0;
    let resNeut = 0;
    let resIds = [];
    let maxtot = 0;
    let maxrestPos = 0;
    let maxresNegative = 0;
    let maxresNeut = 0;
    let maxresIds = [];

    const allTopics = store.getState().filterSettingReducer.topicsAndSubtopics;

    let csvRes = {
        keys: [],
        positive: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
    };

    data.forEach((d, i) => {
        let total = d.data && d.data.aggregations.sentiments_breakup.group1.doc_count;
        let subtopic = d.input && allTopics.find((subtopic) => subtopic.subtopic_id === d.input);
        csvRes.keys.push(`${subtopic.subtopic_name} (${subtopic.topic_name})`);
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent, ind) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    csvRes[sent.key][i] = total > 0 ? ((sent.doc_count / total) * 100).toFixed(2) : 0;
                }
            });
    });

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        maxkeys: [],
        maxpositive: [],
        maxnegative: [],
        maxneutral: [],
        csvRes: csvRes,
    };

    let sortedData = [...data].sort((a, b) => {
        {
            if (a.data && b.data) {
                return a.data &&
                    a.data.aggregations &&
                    a.data.aggregations.sentiments_breakup.group1.doc_count < b.data.aggregations.sentiments_breakup.group1.doc_count
                    ? 1
                    : b.data &&
                      b.data.aggregations &&
                      b.data.aggregations.sentiments_breakup.group1.doc_count < a.data.aggregations.sentiments_breakup.group1.doc_count
                    ? -1
                    : 0;
            }
        }
    });

    let dataFirst = sortedData && sortedData.length && sortedData.length >= 10 ? sortedData.slice(0, 9) : sortedData;
    let dataSecond = sortedData && sortedData.length && sortedData.length >= 10 ? sortedData.slice(-(data.length - 9)) : [];
    let dataThird = sortedData.slice(0, 50);
    let dataForth = sortedData && sortedData.length && sortedData.length >= 50 ? sortedData.slice(-(data.length - 49)) : [];

    let res = {
        key: [],
        positive: new Array(dataFirst.length).fill(0),
        negative: new Array(dataFirst.length).fill(0),
        neutral: new Array(dataFirst.length).fill(0),
        total: new Array(dataFirst.length).fill(0),
        maxkey: [],
        maxpositive: new Array(dataThird.length).fill(0),
        maxnegative: new Array(dataThird.length).fill(0),
        maxneutral: new Array(dataThird.length).fill(0),
        maxtotal: new Array(dataThird.length).fill(0),
    };

    dataFirst.forEach((d, i) => {
        d.input && res.key.push(d.input);
        res.total[i] = d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
        totalData += res.total[i];
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res[sent.key][i] = sent.doc_count;
            });
    });
    dataThird.forEach((d, i) => {
        d.input && res.maxkey.push(d.input);
        res.maxtotal[i] = d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
        totalData += res.maxtotal[i];
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res["max" + sent.key][i] = sent.doc_count;
            });
    });

    dataSecond &&
        dataSecond.forEach((d, i) => {
            tot += d.data ? d.data && d.data.aggregations.sentiments_breakup.group1.doc_count : 0;

            d.input && resIds.push(d.input);
            d.data &&
                d.data.aggregations.sentiments_breakup.group1.group2.buckets.length &&
                d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                    if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                        if (sent.key === "positive") {
                            restPos += sent.doc_count;
                        } else if (sent.key === "negative") {
                            resNegative += sent.doc_count;
                        } else if (sent.key === "neutral") {
                            resNeut += sent.doc_count;
                        }
                    }
                });
        });

    // dataForth &&
    //     dataForth.forEach((d, i) => {
    //         maxtot += d.data ? d.data && d.data.aggregations.sentiments_breakup.group1.doc_count : 0;

    //         d.input && maxresIds.push(d.input);
    //         d.data &&
    //             d.data.aggregations.sentiments_breakup.group1.group2.buckets.length &&
    //             d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
    //                 if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
    //                     if (sent.key === "positive") {
    //                         maxrestPos += sent.doc_count;
    //                     } else if (sent.key === "negative") {
    //                         maxresNegative += sent.doc_count;
    //                     } else if (sent.key === "neutral") {
    //                         maxresNeut += sent.doc_count;
    //                     }
    //                 }
    //             });
    //     });

    if (dataSecond && dataSecond.length) {
        res.key.push("others");
        res.positive.push(restPos);
        res.negative.push(resNegative);
        res.neutral.push(resNeut);
        res.total.push(tot);
    }
    // if (dataForth && dataForth.length) {
    //     res.maxkey.push("others");
    //     res.maxpositive.push(maxrestPos);
    //     res.maxnegative.push(maxresNegative);
    //     res.maxneutral.push(maxresNeut);
    //     res.maxtotal.push(maxtot);
    // }

    if (totalData + tot === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.subtopic_id === d) : "Others";

            if (subtopic) {
                let name = d !== "others" ? `${subtopic.subtopic_name} (${subtopic.topic_name})` : subtopic;
                chartData.keys.push(name);
                //let tot = res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                let x = {
                    name: d,
                    totalData: res.total[i] ? res.total[i] : 0,
                    totData: res.total[i] ? res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && resIds.length > 0) {
                    x.subtopicIds = resIds;
                }

                chartData.positive.push({
                    ...x,
                    y: (res.positive && +((res.positive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.positive[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });

                chartData.negative.push({
                    ...x,
                    y: (res.negative && +((res.negative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.negative[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.neutral.push({
                    ...x,
                    y: (res.neutral && +((res.neutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.neutral[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
            }
        });

        res.maxkey.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.subtopic_id === d) : "Others";

            if (subtopic) {
                let name = d !== "others" ? `${subtopic.subtopic_name} (${subtopic.topic_name})` : subtopic;
                chartData.maxkeys.push(name);
                //let tot = res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                let x = {
                    name: d,
                    totalData: res.maxtotal[i] ? res.maxtotal[i] : 0,
                    totData: res.maxtotal[i] ? res.maxtotal[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && maxresIds.length > 0) {
                    x.subtopicIds = maxresIds;
                }

                chartData.maxpositive.push({
                    ...x,
                    y: (res.maxpositive && +((res.maxpositive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.maxpositive[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });

                chartData.maxnegative.push({
                    ...x,
                    y: (res.maxnegative && +((res.maxnegative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.maxnegative[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.maxneutral.push({
                    ...x,
                    y: (res.maxneutral && +((res.maxneutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.maxneutral[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
            }
        });
    }
    return chartData;
};

export const formatSubTopicWiseStackedSentimentBreakup = (data) => {
    let totalData = 0;
    let tot = 0;
    let restPos = 0;
    let resNegative = 0;
    let resNeut = 0;
    let resIds = [];
    let maxtot = 0;
    let maxrestPos = 0;
    let maxresNegative = 0;
    let maxresNeut = 0;
    let maxresIds = [];

    const allTopics = store.getState().filterSettingReducer.topicsAndSubtopics;

    let csvRes = {
        keys: [],
        positive: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
    };

    data.forEach((d, i) => {
        let total = d && d.aggregations.sentiments_breakup.group1.doc_count;
        let subtopic = d.topic_id && allTopics.find((subtopic) => subtopic.topic_id === d.topic_id);
        csvRes.keys.push(`${subtopic.topic_name}`);
        d &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent, ind) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    csvRes[sent.key][i] = total > 0 ? ((sent.doc_count / total) * 100).toFixed(2) : 0;
                }
            });
    });

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        maxkeys: [],
        maxpositive: [],
        maxnegative: [],
        maxneutral: [],
        csvRes: csvRes,
    };

    let sortedData = [...data].sort((a, b) => {
        {
            if (a && b) {
                return a && a.aggregations && a.aggregations.sentiments_breakup.group1.doc_count < b.aggregations.sentiments_breakup.group1.doc_count
                    ? 1
                    : b && b.aggregations && b.aggregations.sentiments_breakup.group1.doc_count < a.aggregations.sentiments_breakup.group1.doc_count
                    ? -1
                    : 0;
            }
        }
    });

    let dataFirst = sortedData && sortedData.length && sortedData.length >= 10 ? sortedData.slice(0, 9) : sortedData;
    let dataSecond = sortedData && sortedData.length && sortedData.length >= 10 ? sortedData.slice(-(data.length - 9)) : [];
    let dataThird = sortedData.slice(0, 50);
    let dataForth = sortedData && sortedData.length && sortedData.length >= 50 ? sortedData.slice(-(data.length - 49)) : [];

    let res = {
        key: [],
        positive: new Array(dataFirst.length).fill(0),
        negative: new Array(dataFirst.length).fill(0),
        neutral: new Array(dataFirst.length).fill(0),
        total: new Array(dataFirst.length).fill(0),
        maxkey: [],
        maxpositive: new Array(dataThird.length).fill(0),
        maxnegative: new Array(dataThird.length).fill(0),
        maxneutral: new Array(dataThird.length).fill(0),
        maxtotal: new Array(dataThird.length).fill(0),
    };

    dataFirst.forEach((d, i) => {
        d.topic_id && res.key.push(d.topic_id);
        res.total[i] = d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
        totalData += res.total[i];
        d &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res[sent.key][i] = sent.doc_count;
            });
    });
    dataThird.forEach((d, i) => {
        d.topic_id && res.maxkey.push(d.topic_id);
        res.maxtotal[i] = d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
        totalData += res.maxtotal[i];
        d &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res["max" + sent.key][i] = sent.doc_count;
            });
    });

    dataSecond &&
        dataSecond.forEach((d, i) => {
            tot += d ? d && d.aggregations.sentiments_breakup.group1.doc_count : 0;

            d.topic_id && resIds.push(d.topic_id);
            d &&
                d.aggregations.sentiments_breakup.group1.group2.buckets.length &&
                d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                    if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                        if (sent.key === "positive") {
                            restPos += sent.doc_count;
                        } else if (sent.key === "negative") {
                            resNegative += sent.doc_count;
                        } else if (sent.key === "neutral") {
                            resNeut += sent.doc_count;
                        }
                    }
                });
        });

    // dataForth &&
    //     dataForth.forEach((d, i) => {
    //         maxtot += d.data ? d.data && d.data.aggregations.sentiments_breakup.group1.doc_count : 0;

    //         d.input && maxresIds.push(d.input);
    //         d.data &&
    //             d.data.aggregations.sentiments_breakup.group1.group2.buckets.length &&
    //             d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
    //                 if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
    //                     if (sent.key === "positive") {
    //                         maxrestPos += sent.doc_count;
    //                     } else if (sent.key === "negative") {
    //                         maxresNegative += sent.doc_count;
    //                     } else if (sent.key === "neutral") {
    //                         maxresNeut += sent.doc_count;
    //                     }
    //                 }
    //             });
    //     });

    if (dataSecond && dataSecond.length) {
        res.key.push("others");
        res.positive.push(restPos);
        res.negative.push(resNegative);
        res.neutral.push(resNeut);
        res.total.push(tot);
    }
    // if (dataForth && dataForth.length) {
    //     res.maxkey.push("others");
    //     res.maxpositive.push(maxrestPos);
    //     res.maxnegative.push(maxresNegative);
    //     res.maxneutral.push(maxresNeut);
    //     res.maxtotal.push(maxtot);
    // }

    if (totalData + tot === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.topic_id === d) : "Others";

            if (subtopic) {
                let name = d !== "others" ? `${subtopic.topic_name} ` : subtopic;
                chartData.keys.push(name);
                //let tot = res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                let x = {
                    name: d,
                    totalData: res.total[i] ? res.total[i] : 0,
                    totData: res.total[i] ? res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && resIds.length > 0) {
                    x.subtopicIds = resIds;
                }

                chartData.positive.push({
                    ...x,
                    y: (res.positive && +((res.positive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.positive[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });

                chartData.negative.push({
                    ...x,
                    y: (res.negative && +((res.negative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.negative[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.neutral.push({
                    ...x,
                    y: (res.neutral && +((res.neutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.neutral[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
            }
        });

        res.maxkey.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.topic_id === d) : "Others";

            if (subtopic) {
                let name = d !== "others" ? `${subtopic.topic_name}` : subtopic;
                chartData.maxkeys.push(name);
                //let tot = res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                let x = {
                    name: d,
                    totalData: res.maxtotal[i] ? res.maxtotal[i] : 0,
                    totData: res.maxtotal[i] ? res.maxtotal[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && maxresIds.length > 0) {
                    x.subtopicIds = maxresIds;
                }

                chartData.maxpositive.push({
                    ...x,
                    y: (res.maxpositive && +((res.maxpositive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.maxpositive[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });

                chartData.maxnegative.push({
                    ...x,
                    y: (res.maxnegative && +((res.maxnegative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.maxnegative[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.maxneutral.push({
                    ...x,
                    y: (res.maxneutral && +((res.maxneutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.maxneutral[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
            }
        });
    }

    return chartData;
};

export const formatProductAttributesSentimentAnalysis = (value, params) => {
    let totalData = 0;
    let tot = 0;
    let restPos = 0;
    let resNegative = 0;
    let resNeut = 0;
    let resIds = [];

    let data = value.aggregations.channel_analysis.buckets;

    let ProductattributeSemtimentBucket = {};
    params.product_attribute_categories &&
        params.product_attribute_categories.forEach((attr) => {
            let values = {
                key: attr,
                doc_count: 0,
                positive: 0,
                negative: 0,
                neutral: 0,
            };

            ProductattributeSemtimentBucket[attr] = values;
        });

    if (params.product_attribute_categories.length == 0) {
        ProductAttributes.data.forEach((attr) => {
            let values = {
                key: attr.categoryName,
                doc_count: 0,
                positive: 0,
                negative: 0,
                neutral: 0,
            };

            ProductattributeSemtimentBucket[attr.categoryName] = values;
        });
    }

    if (ProductattributeSemtimentBucket) {
        data.forEach((d) => {
            if (ProductattributeSemtimentBucket[d.key]) ProductattributeSemtimentBucket[d.key].doc_count = d.doc_count;

            d.sentiment_group.group1.group2.buckets.forEach((s) => {
                if (ProductattributeSemtimentBucket[d.key]) ProductattributeSemtimentBucket[d.key][s.key] = s.doc_count;
            });
        });
    }

    let ret = {
        data: [],
    };
    Object.entries(ProductattributeSemtimentBucket).forEach(([k, v]) => {
        ret.data.push(v);
    });

    let sortedData = ret.data.sort((a, b) => {
        return a.doc_count < b.doc_count ? 1 : b.doc_count < a.doc_count ? -1 : 0;
    });

    let updatedsortedData = JSON.parse(JSON.stringify(sortedData));
    let csvRes = {
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
    };

    updatedsortedData.forEach((d, i) => {
        let total = d.doc_count;
        let ProductAttributesName = ProductAttributes.data.filter((val) => {
            return val.categoryName === d.key;
        });

        csvRes.keys.push(ProductAttributesName[0]?.attributeName);
        if (total == 0) {
            csvRes.positive.push(0);
            csvRes.negative.push(0);
            csvRes.neutral.push(0);
        } else {
            csvRes.positive.push(((d.positive / total) * 100).toFixed(2));
            csvRes.negative.push(((d.negative / total) * 100).toFixed(2));
            csvRes.neutral.push(((d.neutral / total) * 100).toFixed(2));
        }
    });

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        csvRes: csvRes,
    };

    updatedsortedData.forEach((ele) => {
        let ProductAttributesName = ProductAttributes.data.filter((val) => {
            return val.categoryName === ele.key;
        });
        ele.key = ProductAttributesName[0]?.attributeName;
    });

    let dataFirst = updatedsortedData && updatedsortedData.length && updatedsortedData.length >= 10 ? updatedsortedData.slice(0, 9) : updatedsortedData;
    let dataSecond = updatedsortedData && updatedsortedData.length && updatedsortedData.length >= 10 ? updatedsortedData.slice(-(ret.data.length - 9)) : [];
    let dataThird = updatedsortedData && updatedsortedData.length && updatedsortedData.length >= 10 ? updatedsortedData.slice(-(ret.data.length - 9)) : [];

    let res = {
        key: [],
        positive: [],
        negative: [],
        neutral: [],
        total: [],
    };

    dataFirst.forEach((d, i) => {
        d.key && res.key.push(d.key);
        totalData += d.doc_count;
        res.positive.push(d.positive);
        res.negative.push(d.negative);
        res.neutral.push(d.neutral);
        res.total.push(d.doc_count);
    });

    dataThird.forEach((d, i) => {
        d.key && res.key.push(d.key);
        totalData += d.doc_count;
        res.positive.push(d.positive);
        res.negative.push(d.negative);
        res.neutral.push(d.neutral);
        res.total.push(d.doc_count);
    });

    dataSecond.forEach((d, i) => {
        resIds.push(d.key);
        tot += d.doc_count;
        restPos += d.positive;
        resNegative += d.negative;
        resNeut += d.neutral;
    });
    if (dataSecond && dataSecond.length) {
        res.key.push("others");
        res.positive.push(restPos);
        res.negative.push(resNegative);
        res.neutral.push(resNeut);
        res.total.push(tot);
    }

    if (totalData + tot === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            let subtopic = d !== "others" ? d : "Others";

            if (subtopic) {
                let name = d !== "others" ? `${subtopic}` : subtopic;
                chartData.keys.push(name);

                let x = {
                    name,
                    totalData: res.total[i] ? res.total[i] : 0,
                    totData: res.total[i] ? res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                    subtopicId: d,
                };

                if (subtopic === "Others" && resIds.length > 0) {
                    x.subtopicIds = resIds;
                }

                // if (res.total[i]) {
                chartData.positive.push({
                    ...x,
                    y: (res.positive && +((res.positive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.positive[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.negative.push({
                    ...x,
                    y: (res.negative && +((res.negative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.negative[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                chartData.neutral.push({
                    ...x,
                    y: (res.neutral && +((res.neutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.neutral[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                });
                // }
            }
        });
    }

    chartData.negative = chartData.negative.filter((ele) => ele.totalData != 0);
    chartData.neutral = chartData.neutral.filter((ele) => ele.totalData != 0);
    chartData.positive = chartData.positive.filter((ele) => ele.totalData != 0);

    return chartData;
};

export const formatPlatformWiseSentimentAnalysis = (data) => {
    let nodata = true;
    let totalData = 0;

    let csvRes = {
        keys: [],
        positive: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
    };

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        //csvRes: csvRes,
    };

    let res = {
        key: [],
        platformId: [],
        positive: new Array(data.length).fill(0),
        positiveTot: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        negativeTot: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
        neutralTot: new Array(data.length).fill(0),
        total: new Array(data.length).fill(0),
    };

    const platforms = store.getState().filterSettingReducer.masterPlatforms;

    data.aggregations.channel_analysis.buckets.forEach((platform, i) => {
        let sentiments = [];
        let total = platform.doc_count;
        res.total[i] = platform ? platform.doc_count : 0;
        totalData += total;
        let pl = platform.key && platforms.find((p) => p.id === platform.key);

        res.platformId[i] = platform.key;

        if (pl) res.key.push(`${pl.name}`);
        else res.key.push(``);

        res.positive[i] = "0";
        res.positiveTot[i] = 0;
        res.negative[i] = "0";
        res.negativeTot[i] = 0;
        res.neutralTot[i] = 0;
        res.neutral[i] = "0";

        platform.sentiment_group.group1.group2.buckets.forEach((sent, ind) => {
            if (sent.key === "positive") {
                res.positive[i] = sent.doc_count ? sent.doc_count : 0;
                res.positiveTot[i] = sent.doc_count;
            }

            if (sent.key === "negative") {
                res.negative[i] = sent.doc_count ? sent.doc_count : 0;
                res.negativeTot[i] = sent.doc_count;
            }

            if (sent.key === "neutral") {
                res.neutral[i] = sent.doc_count ? sent.doc_count : 0;
                res.neutralTot[i] = sent.doc_count;
            }
        });
    });

    if (totalData === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            chartData.keys.push(d);
            let x = {
                name: d,
                totalData: res.total[i] ? res.total[i] : 0,
                totData: res.total[i] ? res.total[i].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
                platformId: res.platformId[i],
            };
            if (res.total[i]) {
                chartData.positive.push({
                    ...x,
                    y: (res.positive && res.positive[i] && +((res.positive[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "positive",
                    doc_count: res.positiveTot[i] || 0,
                });
                chartData.negative.push({
                    ...x,
                    y: (res.negative && res.negative[i] && +((res.negative[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "negative",
                    doc_count: res.negativeTot[i] || 0,
                });
                chartData.neutral.push({
                    ...x,
                    y: (res.neutral && res.neutral[i] && +((res.neutral[i] / x.totalData) * 100).toFixed(2)) || 0,
                    sentiment: "neutral",
                    doc_count: res.neutralTot[i] || 0,
                });
            }
        });
    }

    return { data: chartData, nodata: chartData.nodata };
};

export const formatChannelAnalysis = (data) => {
    let res = {};
    let nodata = true;
    data.aggregations.channel_analysis.buckets.forEach((platform) => {
        let sentiments = [];
        let total = platform.doc_count;
        platform.sentiment_group.group1.group2.buckets.forEach((sent) => {
            nodata = false;

            sentiments.push([sent.key, sent.doc_count]);
        });
        res[platform.key] = {};
        res[platform.key].sentiments = sentiments;
        res[platform.key].total = total;
    });
    return { data: res, nodata: nodata };
};

export const formatChannelAnalysisEngagementWise = (data) => {
    let res = {};
    let nodata = true;
    data.aggregations.channel_analysis_by_impact_value.buckets.forEach((platform) => {
        if (platform.group1.value > 0) {
            nodata = false;
            let total = platform.group1.value;
            res[platform.key] = {};
            res[platform.key].total = total;
        }
    });
    return { data: res, nodata: nodata };
};

export const formatEngagementOvertime = (data, params) => {
    let res = {
        chartData: [],
        nodata: false,
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let total = 0;

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    data.aggregations.engagement_overtime.buckets.forEach((bucket, ind) => {
        let date = bucket.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        res.chartData.push({
            x: date,
            y: bucket.by_impact.value,
            doc_count: bucket.doc_count,
        });
        total += bucket.by_impact.value;
    });

    if (total === 0) res.nodata = true;
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;
    return res;
};

export const formatUniqueUsersOverTime = (data, params) => {
    let res = {
        chartData: [],
        nodata: false,
        date: {
            start_date: "",
            end_date: "",
        },
    };

    res.xs = [];
    let values = new Array(data.aggregations.unique_conversation_over_time_by_username.buckets.length).fill(0);
    res.data = { values };

    let total = 0;

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    data.aggregations.unique_conversation_over_time_by_username.buckets.forEach((bucket, ind) => {
        let date = bucket.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        res.xs.push(date);
        res.data["values"][ind] = bucket.unique_value.value;
        res.chartData.push({
            x: date,
            y: bucket.unique_value.value,
            doc_count: bucket.doc_count,
        });
        total += bucket.unique_value.value;
    });

    if (total === 0) res.nodata = true;
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;
    return res;
};
export const formatUniqueUsersOverTimeByTopic = (data, params) => {
    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        chartDataLine: [],
        othersBar: [],
        maximizeBar: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        csvLineData: [],
    };
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let topic_data = params.topic_data;
    let hasLineData = data[0] && data[0].aggregations && data[0].aggregations?.unique_conversation_over_time_by_username?.buckets;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;
    let pieData = [];
    let barData = [];
    let lineData = [];
    let line;
    let total = 0;
    if (!hasLineData) {
        data.forEach((topic, index) => {
            total += topic.aggregations.total_unique_users.value;
            let pie = {
                y: topic.aggregations.total_unique_users.value,
                name: topic.topic_name,
                topicId: topic.topic_id,
                color: topicsObject[topic.topic_id].color,
            };
            let bar = {
                data: [
                    {
                        name: topic.topic_name,
                        y: topic.aggregations.total_unique_users.value,
                    },
                ],
                name: topic.topic_name,
                value: topic.aggregations.total_unique_users.value,
                topicId: topic.topic_id,
                color: topicsObject[topic.topic_id].color,
            };
            pieData.push(pie);
            barData.push(bar);
        });
        ret.total = total;

        if (ret.total === 0) ret.nodata = true;
        else {
            pieData.sort((a, b) => b.y - a.y);
            barData.sort((a, b) => b.value - a.value);
            ret.csvData = pieData;
            ret.maximizeBar = barData.slice(9);
            if (pieData.length < 10) {
                ret.chartDataPie = pieData;
                ret.chartDataBar = barData;
            } else {
                ret.chartDataPie = pieData.slice(0, 9);
                ret.chartDataBar = barData.slice(0, 9);
                let total = 0;
                let subtopics = [];
                let items = [];
                for (let i = 9; i < pieData.length; i++) {
                    total += pieData[i].y;
                    subtopics.push(pieData[i].topicId);
                    items.push({ name: pieData[i].name, value: pieData[i].y });
                }

                ret.chartDataPie.push({
                    y: total,
                    name: "Others",
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    items,
                });

                ret.othersBar.push({
                    data: [{ name: "Others", y: total }],
                    name: "Others",
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    items,
                });
            }
        }
    }
    if (hasLineData) {
        data.forEach((topic, index) => {
            line = {
                data: [],
                name: topic.topic_name,
                topicId: topic.topic_id,
                color: topicsObject[topic.topic_id].color,
                allSubtopicSelected: false,
                value: 0,
            };
            let count = 0;
            topic.aggregations.unique_conversation_over_time_by_username.buckets.map((b) => {
                let date = b.key;
                total += b.unique_value.value;
                count += b.unique_value.value;

                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                line.data.push({
                    x: date,
                    y: b.unique_value.value,
                });
            });
            line.value = count;
            lineData.push(line);
        });
        ret.total = total;
        lineData.sort((a, b) => b.value - a.value);
        ret.csvLineData = lineData;
        if (lineData.length < 10) {
            ret.chartDataLine = lineData;
        } else {
            ret.chartDataLine = lineData.slice(0, 9);
            let othersLineData = {};
            for (let i = 9; i < lineData.length; i++) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
            let x = [];
            Object.keys(othersLineData).map((k) => x.push({ x: +k, y: othersLineData[k] }));
            ret.chartDataLine.push({
                data: x,
                name: "Others",
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
            });
        }
    }
    return ret;
};
export const formatUniqueUsersOverTimeBySubTopic = (data, params) => {
    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        chartDataLine: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        csvLineData: [],
        maximizeStackedBarData: [],
    };
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
            };
        });
    }
    let hasLineData = data[0] && data[0].subtopics[0].aggregations && data[0].subtopics[0].aggregations?.unique_conversation_over_time_by_username?.buckets;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;
    let pieData = [];
    let barData = [];
    let lineData = [];
    let line;
    let total = 0;
    if (!hasLineData) {
        data.forEach((topic, index) => {
            topic.subtopics.forEach((subTopic, ind) => {
                let subtopicColor = subtopicObject[subTopic.subtopic_id].subtopic_color || "#FF0000";
                total += subTopic.aggregations.total_unique_users.value;
                let subtopicUniqueUsers = subTopic.aggregations.total_unique_users.value;
                let pie = {
                    y: subtopicUniqueUsers,
                    name: subTopic.subtopic_name,
                    topicId: topic.topic_id,
                    subtopicId: subTopic.subtopic_id,
                    topic_name: topic.topic_name,
                    color: subtopicColor,
                };
                let bar = {
                    data: [{ name: subTopic.subtopic_name, y: subtopicUniqueUsers }],
                    name: subTopic.subtopic_name,
                    value: subtopicUniqueUsers,
                    topicId: topic.topic_id,
                    subtopicId: subTopic.subtopic_id,
                    topic_name: topic.topic_name,
                    color: subtopicColor,
                };
                pieData.push(pie);
                barData.push(bar);
            });
        });
        ret.total = total;

        if (ret.total === 0 && !hasLineData) ret.nodata = true;
        else {
            pieData.sort((a, b) => b.y - a.y);
            barData.sort((a, b) => b.value - a.value);
            ret.csvData = pieData;
            ret.maximizeStackedBarData = barData;

            if (pieData.length < 10) {
                ret.chartDataPie = pieData;
                ret.chartDataBar = barData;
            } else {
                ret.chartDataPie = pieData.slice(0, 9);
                ret.chartDataBar = barData.slice(0, 9);
                let total = 0;
                let subtopics = [];
                let topics = [];
                let items = [];
                for (let i = 9; i < pieData.length; i++) {
                    total += pieData[i].y;
                    subtopics.push(pieData[i].subtopicId);
                    items.push({ name: pieData[i].name, value: pieData[i].y });
                }

                ret.chartDataPie.push({
                    y: total,
                    name: "Others",
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    topic_name: "",
                    items,
                });

                ret.chartDataBar.push({
                    data: [{ name: "Others", y: total }],
                    name: "Others",
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    topic_name: "",
                    items,
                });
            }
        }
    }
    if (hasLineData) {
        data.forEach((topic, index) => {
            topic.subtopics.forEach((subTopic, ind) => {
                let subtopicColor = subtopicObject[subTopic.subtopic_id].subtopic_color || "#FF0000";
                line = {
                    data: [],
                    name: subTopic.subtopic_name,
                    topicId: topic.topic_id,
                    color: subtopicColor,
                    allSubtopicSelected: false,
                    topic_name: topic.topic_name,
                    subtopicId: subTopic.subtopic_id,
                    value: 0,
                };
                let count = 0;
                subTopic.aggregations.unique_conversation_over_time_by_username.buckets.map((b) => {
                    let date = b.key;
                    total += b.unique_value.value;
                    count += b.unique_value.value;

                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.unique_value.value,
                    });
                });
                line.value = count;
                lineData.push(line);
            });
        });
        ret.total = total;
        lineData.sort((a, b) => b.value - a.value);
        ret.chartDataLine = lineData;
        ret.csvLineData = lineData;
    }
    return ret;
};
function getGroupColour(net_score, sentiment) {
    if (net_score >= -2 && net_score <= 2) {
        return neutral_colors;
    } else if (net_score < -2) {
        let net_score_adjusted = Math.abs(Math.floor(net_score / 10));
        if (net_score_adjusted >= 4) {
            return red_colors[4];
        } else {
            return red_colors[net_score_adjusted];
        }
    } else {
        let net_score_adjusted = Math.floor(net_score / 10);
        if (sentiment === "negative") {
            if (net_score_adjusted >= 4) {
                return red_colors[4];
            } else {
                return red_colors[net_score_adjusted];
            }
        } else {
            if (net_score_adjusted >= 4) {
                return green_colors[4];
            } else {
                return green_colors[net_score_adjusted];
            }
        }
    }
}

const formatTopicData = (data, params) => {
    data = data.map((bkt) => {
        let x = bkt;
        x.drilldown = bkt.drilldown ? bkt.drilldown : [];
        return x;
    });

    let topTenData = data.slice(0, 10);
    let total_value = 0;

    let formatted_data = [];

    const addDrillDownNodes = (parentNode, level, allArray) => {
        let drillArr = parentNode.drilldown;

        drillArr.forEach((g) => {
            const y = { ...g };
            y.parent = parentNode.id;
            y.level = level;
            y.net_sentiment_score = Math.floor(g.net_sentiment_score);
            y.hexColor = getGroupColour(y.net_sentiment_score, params.sentiment);
            y.color = radialColor(y.hexColor);
            y.value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? g.traction : g.impact_score) : g.doc_count;
            total_value += y.value;
            delete y.drilldown;
            if (g.drilldown) {
                y.type = "cluster";
                addDrillDownNodes(g, level + 1, allArray);
            } else y.type = "keyword";
            allArray.push(y);
        });
    };

    topTenData.forEach((d) => {
        const x = { ...d };
        delete x.drilldown;
        x.level = 1;
        x.type = "cluster";
        x.net_sentiment_score = Math.floor(d.net_sentiment_score);
        x.hexColor = getGroupColour(x.net_sentiment_score, params.sentiment);
        x.color = radialColor(x.hexColor);
        x.value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? d.traction : d.impact_score) : d.doc_count;
        total_value += x.value;
        formatted_data.push(x);
        addDrillDownNodes(d, 2, formatted_data);
    });

    let showMoreData = [];

    if (data.length > 10) {
        showMoreData = JSON.parse(JSON.stringify(formatted_data));

        let doc_count = 0,
            impact_score = 0,
            negative_percentage = 0,
            net_sentiment_score = 0,
            neutral_percentage = 0,
            positive_percentage = 0,
            traction = 0,
            weight = 0,
            count = 0;
        data.slice(10, data.length).forEach((d) => {
            const x = { ...d };
            delete x.drilldown;
            x.level = 1;
            x.parent = "others";
            x.type = "cluster";
            x.net_sentiment_score = Math.floor(d.net_sentiment_score);
            x.hexColor = getGroupColour(x.net_sentiment_score, params.sentiment);
            x.color = radialColor(x.hexColor);
            x.value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? d.traction : d.impact_score) : d.doc_count;
            total_value += x.value;
            showMoreData.push(x);
            doc_count += x.doc_count;
            impact_score += x.impact_score;
            negative_percentage += x.negative_percentage;
            net_sentiment_score += x.net_sentiment_score;
            neutral_percentage += x.neutral_percentage;
            positive_percentage += x.positive_percentage;
            traction += x.traction;
            weight += x.weight;
            count++;
            addDrillDownNodes(d, 2, showMoreData);
        });
        negative_percentage /= count;
        net_sentiment_score /= count;
        neutral_percentage /= count;
        positive_percentage /= count;
        const hexColor = getGroupColour(net_sentiment_score, params.sentiment);
        let value = params.clustering_sort_by ? (params.clustering_sort_by === "traction" ? traction : impact_score) : doc_count;
        total_value += value;
        showMoreData.push({
            name: "Others",
            label: "Others",
            id: "others",
            level: "others",
            doc_count,
            impact_score,
            negative_percentage: Math.floor(net_sentiment_score),
            net_sentiment_score,
            neutral_percentage,
            positive_percentage,
            traction,
            weight,
            hexColor,
            value,
            color: radialColor(hexColor),
        });
    }

    return { formatted_data, showMoreData, total_value };
};

const distinctKeys = (drillArr) => {
    let distinctKeys = {};

    drillArr.forEach((g) => {
        let distk = g.name.toLowerCase();
        if (distinctKeys[distk]) {
            distinctKeys[distk].doc_count += g.doc_count;
            distinctKeys[distk].traction += g.traction;
            distinctKeys[distk].impact_score += g.impact_score;
            distinctKeys[distk].weight += g.weight;
            distinctKeys[distk].negative_percentage += g.negative_percentage;
            distinctKeys[distk].negative_percentage /= 2;
            distinctKeys[distk].positive_percentage += g.positive_percentage;
            distinctKeys[distk].positive_percentage /= 2;
            distinctKeys[distk].neutral_percentage += g.neutral_percentage;
            distinctKeys[distk].neutral_percentage /= 2;
            distinctKeys[distk].net_sentiment_score = distinctKeys[distk].positive_percentage - distinctKeys[distk].negative_percentage;
            distinctKeys[distk].keywords.push(g.name);
        } else {
            distinctKeys[distk] = g;
            distinctKeys[distk].keywords = [g.name];
        }
    });

    return Object.values(distinctKeys);
};

// export const formatTopTopics = (data, options, params) => {
//     let formattedData = [];

//     formattedData = data.aggregations.by_cluster_categories_l2.buckets
//         .filter((b) => b.id !== "cluster_319")
//         .map((bucket) => {
//             let x = getIndividualBuckets(bucket, options);
//             if (bucket.by_cluster_categories_l3.buckets.length > 0)
//                 x.drilldown = bucket.by_cluster_categories_l3.buckets.map((category) => {
//                     let y = getIndividualBuckets(category, x);
//                     y.drilldown = distinctKeys(category.by_keyword_ner_l3.buckets.map((keyword) => getIndividualBuckets(keyword, y)));
//                     return y;
//                 });
//             else x.drilldown = distinctKeys(bucket.by_keyword_ner_l2.buckets.map((keyword) => getIndividualBuckets(keyword, x)));

//             return x;
//         });

//     let { formatted_data, showMoreData, total_value } = formatTopicData(formattedData, params);

//     // let z = JSON.parse(JSON.stringify({ data: formattedData, formatted_data: formatted_data, showMoreData }));
//

//     return { data: formattedData, formatted_data: formatted_data, showMoreData, total_value };
// };

export const formatTopTopics = (data, options, params) => {
    const Company = store.getState().globalReducer.company;

    let formattedData = [];

    formattedData = data.aggregations.by_cluster_categories_l2.buckets
        .filter((b) => b.id !== "cluster_319")
        .map((bucket) => {
            let x = getIndividualBuckets(bucket, options);
            if (bucket.by_cluster_categories_l3.buckets.length > 0)
                x.drilldown = bucket.by_cluster_categories_l3.buckets.map((category) => {
                    let y = getIndividualBuckets(category, x);
                    y.drilldown = distinctKeys(category.by_keyword_ner_l3.buckets.map((keyword) => getIndividualBuckets(keyword, y)));
                    //Added formation for y drilldown for 2 topic RAD-4544
                    // let hasKeywordList = y.drilldown.filter((obj) => ["ホワイトデー", "ホワイト"].includes(obj.label));

                    let hasKeywordList2 =
                        Company.lite_company_id == 10614
                            ? y.drilldown.filter((obj) => !["ホワイト", "white"].includes(obj.label.toLowerCase() == "white" ? "white" : obj.label))
                            : y.drilldown;
                    // if (hasKeywordList?.length === 2) {
                    //     let topic1 = y.drilldown.filter((ele) => ele.label == "ホワイトデー");
                    //     let topic2 = y.drilldown.filter((ele) => ele.label == "ホワイト");
                    // let res = JSON.parse(
                    //     JSON.stringify(
                    //         topic1.map((ele) => {
                    //             ele.doc_count = ele.doc_count + topic2[0].doc_count;
                    //             ele.impact_score = ele.impact_score + topic2[0].impact_score;
                    //             ele.traction = ele.traction + topic2[0].traction;
                    //             ele.weight = ele.weight + topic2[0].weight;
                    //             return ele;
                    //         }),
                    //     ),
                    // );

                    //     y.drilldown = [...topic1, ...hasKeywordList2];
                    //
                    // }
                    //
                    y.drilldown = hasKeywordList2;
                    //end y formation RAD-4544

                    return y;
                });
            else {
                x.drilldown = distinctKeys(
                    bucket.by_keyword_ner_l2.buckets.map((keyword) => {
                        let xy = getIndividualBuckets(keyword, x);

                        return getIndividualBuckets(keyword, x);
                    }),
                );
            }
            //Added formation for x drilldown for 2 topic RAD-4544
            // let hasKeywordList = x.drilldown.filter((obj) => ["ホワイトデー", "ホワイト"].includes(obj.label));
            let hasKeywordList2 =
                Company.lite_company_id == 10614
                    ? x.drilldown.filter((obj) => !["ホワイト", "White"].includes(obj.label.toLowerCase() == "white" ? "white" : obj.label))
                    : x.drilldown;
            // if (hasKeywordList?.length === 2) {
            //     let topic1 = x.drilldown.filter((ele) => ele.label == "ホワイトデー");
            //     let topic2 = x.drilldown.filter((ele) => ele.label == "ホワイト");
            // let res = JSON.parse(
            //     JSON.stringify(
            //         topic1.map((ele) => {
            //             ele.doc_count = ele.doc_count + topic2[0].doc_count;
            //             ele.impact_score = ele.impact_score + topic2[0].impact_score;
            //             ele.traction = ele.traction + topic2[0].traction;
            //             ele.weight = ele.weight + topic2[0].weight;
            //             return ele;
            //         }),
            //     ),
            // );

            //

            //     x.drilldown = [...topic1, ...hasKeywordList2];
            // }
            x.drilldown = hasKeywordList2;
            //end x formation RAD-4544

            //

            return x;
        });

    let { formatted_data, showMoreData, total_value } = formatTopicData(formattedData, params);

    // let z = JSON.parse(JSON.stringify({ data: formattedData, formatted_data: formatted_data, showMoreData }));

    return {
        data: formattedData,
        formatted_data: formatted_data,
        showMoreData,
        total_value,
    };
};

const getIndividualBuckets = (bucket, options) => {
    let data = {
        label: bucket.key,
        name: bucket.key,
        doc_count: bucket.doc_count,
        id: bucket.id ? bucket.id : options.id + "_" + bucket.key,
        traction: bucket.by_velocity ? bucket.by_velocity.value : 0,
        impact_score: bucket.by_impact_value ? bucket.by_impact_value.value : 0,
        weight: bucket.doc_count,
    };

    if (bucket.by_sentiments_total) {
        let { negative, positive, neutral, net_sentiment_score } = getBucketSentiment(bucket);
        data.negative_percentage = +negative;
        data.positive_percentage = +positive;
        data.neutral_percentage = +neutral;
        data.net_sentiment_score = +net_sentiment_score;
    } else if (bucket.by_sentiment) {
        data.negative_percentage = bucket.by_sentiment.negative_percentage ? +bucket.by_sentiment.negative_percentage : 0;
        data.positive_percentage = bucket.by_sentiment.positive_percentage ? +bucket.by_sentiment.positive_percentage : 0;
        data.neutral_percentage = bucket.by_sentiment.neutral_percentage ? +bucket.by_sentiment.neutral_percentage : 0;
        data.net_sentiment_score = +bucket.by_sentiment.net_sentiment_score;
    }

    return data;
};

const getBucketSentiment = (bucket) => {
    let doc_count = bucket.doc_count;

    let sentiment = {
        positive: 0,
        negative: 0,
        neutral: 0,
    };

    bucket.by_sentiments_total.group1.by_sentiments_category.buckets.forEach((s) => {
        sentiment[s.key] = ((s.doc_count * 100) / doc_count).toFixed(2);
    });

    let net_sentiment_score = sentiment.positive - sentiment.negative;

    return { ...sentiment, net_sentiment_score };
};

export const formatWordcloud = (data, params) => {
    localStorage.removeItem("drilledWords");
    let dataRender = [];

    let aggs = params.aggs;

    data.aggregations &&
        data.aggregations.wordcloud.buckets &&
        data.aggregations.wordcloud.buckets.map((item, i) => {
            dataRender.push({
                name: item.key.toUpperCase(),
                weight: aggs === "frequency-wordcloud" ? item.doc_count : item.score,
                color: i > 30 ? "#9BE1FF" : i > 10 ? "#2E5CCF" : "#8334A3",
                className: null,
            });
        });

    return dataRender.slice(0, 50);
};

export const formatOCRWordcloud = (data, params) => {
    localStorage.removeItem("drilledWords");
    let dataRender = [];

    let aggs = params.aggs;

    data.aggregations &&
        data.aggregations.wordcloud.buckets &&
        data.aggregations.wordcloud.buckets.map((item, i) => {
            dataRender.push({
                name: item.key.toUpperCase(),
                weight: aggs === "ocr-frequency-wordcloud" ? item.doc_count : item.score,
                color: i > 30 ? "#9BE1FF" : i > 10 ? "#2E5CCF" : "#8334A3",
                className: null,
                ocrName: item.key,
            });
        });

    return dataRender.slice(0, 50);
};

export const formatMentionsMap = (data) => {
    return (
        data.aggregations.country_region_sentiments_breakup &&
        !data.aggregations.country_sub_region_sentiments_breakup &&
        data.aggregations.country_region_sentiments_breakup.buckets.map((country) => {
            let country_data = {
                name: country.key,
                regions: [],
                total: country.doc_count,
            };
            country.breakup.buckets.map((region) => {
                let positive = region["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "positive");
                let neutral = region["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "neutral");
                let negative = region["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "negative");
                country_data.regions.push({
                    name: region.key,
                    total: region["sentiments.sentiment_group"].group1.doc_count,
                    negative: negative ? negative.doc_count : 0,
                    neutral: neutral ? neutral.doc_count : 0,
                    positive: positive ? positive.doc_count : 0,
                });
            });
            return country_data;
        })
    );
};

export const formatMentionMapStateData = (data) => {
    return (
        data.aggregations.country_sub_region_sentiments_breakup &&
        data.aggregations.country_sub_region_sentiments_breakup.buckets.map((country) => {
            let state_data = {
                name: country.key,
                subregions: [],
                total: country.doc_count,
            };
            country.breakup.buckets.map((subregion) => {
                let positive = subregion["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "positive");
                let neutral = subregion["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "neutral");
                let negative = subregion["sentiments.sentiment_group"].group1.group2.buckets.find((x) => x.key === "negative");
                state_data.subregions.push({
                    name: subregion.key,
                    total: subregion["sentiments.sentiment_group"].group1.doc_count,
                    negative: negative ? negative.doc_count : 0,
                    neutral: neutral ? neutral.doc_count : 0,
                    positive: positive ? positive.doc_count : 0,
                });
            });
            return data.aggregations.country_sub_region_sentiments_breakup ? state_data : null;
        })
    );
};

const getMomentsData = (buckets, top_moments) => {
    let res = {
        chartDonutData: [],
        othersBar: [],
        maximizeBar: [],
        chartBarData: [],

        nodata: false,
        total: 0,
        momentsData: [],
        top_moments,
    };
    let donut = [];
    let bar = [];

    let others = [];

    buckets.forEach((b, i) => {
        let currentObj = {
            id: b.key,
            value: b.doc_count,
            name: top_moments.find((elem) => elem.id === b.key).name,
        };
        res.momentsData.push(currentObj);
        let count = 0;

        res.total += b.doc_count;

        if (i < 9) {
            res.chartDonutData.push({
                y: currentObj.value,
                name: currentObj.name,
                momentId: currentObj.id,
                color: intToRGB(hashCode(currentObj.name)),
            });

            res.chartBarData.push({
                data: [{ name: currentObj.name, y: currentObj.value }],
                momentId: currentObj.id,
                name: currentObj.name,
                color: intToRGB(hashCode(currentObj.name)),
            });
        } else {
            others.push(currentObj);
            res.maximizeBar.push({
                data: [{ name: currentObj.name, y: currentObj.value }],
                momentId: currentObj.id,
                name: currentObj.name,
                color: intToRGB(hashCode(currentObj.name)),
            });
        }
    });

    if (res.total === 0) res.nodata = true;
    else {
        if (others.length > 0) {
            let y = 0;
            let momentIds = [];
            others.forEach((o) => {
                y += o.value;
                momentIds.push(o.id);
            });

            res.chartDonutData.push({
                y,
                name: "Others",
                momentIds,
                color: intToRGB(hashCode("Others")),
                othersItems: others,
            });

            res.othersBar.push({
                data: [{ name: "Others", y }],
                momentIds,
                name: "Others",
                color: intToRGB(hashCode("Others")),
                othersItems: others,
            });
        }
    }

    return res;
};

export const formatOverallShareOfVoiceByNewsData = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;

    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    if (
        dt.uniqueDataAcrossTopic &&
        dt.uniqueDataAcrossTopic.aggregations &&
        dt.uniqueDataAcrossTopic.aggregations.volume_of_conversation &&
        dt.uniqueDataAcrossTopic.aggregations.volume_of_conversation.buckets
    ) {
        let data = dt.uniqueDataAcrossTopic.aggregations.volume_of_conversation.buckets;
        let topic = {
            name: "All",
            value: 0,
            chartDataPie: [],
            chartDataBar: [],
            othersBar: [],
            maximizeBar: [],
            csvData: [],
        };
        let t = 0;
        let total = 0;
        let items = [];
        data.forEach((pub, i) => {
            topic.csvData.push({ pub: pub.key, value: pub.doc_count });
            t += pub.doc_count;

            if (i < 9) {
                let pie = {
                    y: pub.doc_count,
                    topicId: "all",
                    name: toTitleCase(pub.key),
                };

                let bar = {
                    data: [{ name: toTitleCase(pub.key), y: pub.doc_count }],
                    name: toTitleCase(pub.key),
                    topicId: "all",
                    value: pub.doc_count,
                };
                topic.chartDataPie.push(pie);
                topic.chartDataBar.push(bar);
            } else {
                total += pub.doc_count;
                items.push({ name: toTitleCase(pub.key), value: pub.doc_count });
                let maxbar = {
                    data: [{ name: toTitleCase(pub.key), y: pub.doc_count }],
                    name: toTitleCase(pub.key),
                    topicId: "all",
                    value: pub.doc_count,
                };

                topic.maximizeBar.push(maxbar);
            }
        });
        topic.value = t;
        ret.total += topic.value;
        if (total > 0) {
            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: "all",
                // visible: false,
                items,
                optionType: "others",
            });
            topic.othersBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                topicId: "all",
                value: total,
                // visible: false,
                items,
                optionType: "others",
            });
        }

        ret.data.push(topic);
    }

    let topic_data = params.topic_data;

    dt.dataPerTopic.forEach((tpc, i) => {
        let tpc_data = topic_data.find((t) => t.topic_id === tpc.topic_id);
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            allSubtopicSelected: tpc_data.subtopicIds.length === topicsObject[tpc.topic_id].subtopicsIds.length,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],
            othersBar: [],
            maximizeBar: [],
            csvData: [],
        };

        if (tpc.total === 0) return;
        let t = 0;

        let total = 0;
        let items = [];
        tpc.aggregations.volume_of_conversation.buckets.forEach((pub, i) => {
            topic.csvData.push({ pub: toTitleCase(pub.key), value: pub.doc_count });
            t += pub.doc_count;
            if (i < 9) {
                let pie = {
                    y: pub.doc_count,
                    name: toTitleCase(pub.key),
                    topicId: tpc.topic_id,
                    subtopicIds: tpc_data.subtopicIds,
                    allSubtopicSelected: topic.allSubtopicSelected,
                };

                let bar = {
                    data: [{ name: toTitleCase(pub.key), y: pub.doc_count }],
                    name: toTitleCase(pub.key),
                    value: pub.doc_count,
                    topicId: tpc.topic_id,
                    subtopicIds: tpc_data.subtopicIds,
                    allSubtopicSelected: topic.allSubtopicSelected,
                };
                topic.chartDataPie.push(pie);
                topic.chartDataBar.push(bar);
            } else {
                total += pub.doc_count;
                items.push({ name: toTitleCase(pub.key), value: pub.doc_count });
                let maxbar = {
                    data: [{ name: toTitleCase(pub.key), y: pub.doc_count }],
                    name: toTitleCase(pub.key),
                    value: pub.doc_count,
                    topicId: tpc.topic_id,
                    subtopicIds: tpc_data.subtopicIds,
                    allSubtopicSelected: topic.allSubtopicSelected,
                };

                topic.maximizeBar.push(maxbar);
            }
        });
        topic.value = t;
        ret.total += topic.value;
        if (total > 0) {
            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: tpc.topic_id,
                subtopicIds: tpc_data.subtopicIds,
                // visible: false,
                allSubtopicSelected: topic.allSubtopicSelected,
                items,
                optionType: "others",
            });
            topic.othersBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                value: total,
                topicId: tpc.topic_id,
                subtopicIds: tpc_data.subtopicIds,
                // visible: false,
                allSubtopicSelected: topic.allSubtopicSelected,
                items,
                optionType: "others",
            });
        }

        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    return ret;
};

export const formatOverallShareOfVoiceBySubtopicsData = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;

    ret.hasLineData = hasLineData;

    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],
            othersBar: [],
            maximizeBar: [],
            csvData: [],
        };

        if (hasLineData) topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let t = 0;

        tpc.subtopics.forEach((subtpc) => {
            t += subtpc.total;
            let sub = topicsObject[tpc.topic_id].subtopics.find((s) => s.subtopic_id === subtpc.subtopic_id);

            let color;
            if (sub.subtopic_graph_color === null) {
                color = "#000000";
            } else {
                color = sub.subtopic_graph_color;
            }

            let pie = {
                y: subtpc.total,
                name: subtpc.subtopic_name,
                topicId: tpc.topic_id,
                subtopicId: sub.subtopicIds,
                color: color,
            };

            let bar = {
                data: [{ name: subtpc.subtopic_name, y: subtpc.total }],
                name: subtpc.subtopic_name,
                value: subtpc.total,
                topicId: tpc.topic_id,
                subtopicId: subtpc.subtopic_id,
                color: color,
            };
            let line;
            if (hasLineData) {
                line = {
                    data: [],
                    name: subtpc.subtopic_name,
                    value: subtpc.total,
                    topicId: tpc.topic_id,
                    subtopicId: subtpc.subtopic_id,
                    color: color,
                };

                subtpc.aggregations.volume_of_conversation.buckets.map((b) => {
                    let date = b.key;
                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.doc_count,
                    });
                });
            }
            pieData.push(pie);
            barData.push(bar);
            if (line) {
                lineData.push(line);
                topic.csvData.push(line);
            } else topic.csvData.push(bar);
        });
        ret.total += t;
        topic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            if (hasLineData) topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);
            if (hasLineData) {
                lineData.sort((a, b) => b.value - a.value);
                topic.chartDataLine = lineData.slice(0, 9);
            }
            topic.maximizeBar.push(barData.slice(9));

            let total = 0;
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;
                subtopics.push(pieData[i].subtopicId);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                if (hasLineData) {
                    lineData[i].data.map((d) => {
                        if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                        else othersLineData[d.x] = d.y;
                    });
                }
            }

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            topic.othersBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            if (hasLineData) {
                let x = [];
                Object.keys(othersLineData).map((k) => x.push({ x: Number(k), y: othersLineData[k] }));
                topic.chartDataLine.push({
                    data: x,
                    name: "Others",
                    topicId: lineData[0].topicId,
                    value: total,
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    optionType: "others",
                    items,
                });
            }
        }
        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};
export const formatShareOfVoiceWithSubTopicWiseBreakdown = (data, params) => {
    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        chartDataLine: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        csvLineData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
            };
        });
    }
    let hasLineData = data[0] && data[0].subtopics[0].aggregations;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;
    let pieData = [];
    let barData = [];
    let lineData = [];
    let line;
    let total = 0;
    let colorSet = ["#B33030", "#2F8F9D", "#2155CD", "#E04D01", "#4E944F", "#FFD24C", "#EBD8C3", "#BFFFF0", "#A85CF9", "#446A46", "#2E0249"];
    data.forEach((topic, index) => {
        let count = 0;
        topic.subtopics.forEach((subTopic, ind) => {
            let subtopicColor = subtopicObject[subTopic.subtopic_id].subtopic_color || "#FF0000";
            total += subTopic.total;
            let pie = {
                y: subTopic.total,
                name: subTopic.subtopic_name,
                topicId: topic.topic_id,
                subtopicId: subTopic.subtopic_id,
                topic_name: topic.topic_name,
                color: subtopicColor,
            };
            let bar = {
                data: [{ name: subTopic.subtopic_name, y: subTopic.total }],
                name: subTopic.subtopic_name,
                value: subTopic.total,
                topicId: topic.topic_id,
                subtopicId: subTopic.subtopic_id,
                topic_name: topic.topic_name,
                color: subtopicColor,
            };
            pieData.push(pie);
            barData.push(bar);
        });
    });
    ret.total = total;

    if (ret.total === 0 && !hasLineData) ret.nodata = true;
    else {
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);
        ret.csvData = pieData;

        if (pieData.length < 10) {
            ret.chartDataPie = pieData;
            ret.chartDataBar = barData;
            if (hasLineData) {
                ret.chartDataLine = lineData;
                ret.csvLineData = lineData;
            }
        } else {
            ret.chartDataPie = pieData.slice(0, 9);
            ret.chartDataBar = barData.slice(0, 9);

            let total = 0;
            let subtopics = [];
            let items = [];
            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;
                subtopics.push(pieData[i].subtopicId);
                items.push({ name: pieData[i].name, value: pieData[i].y });
            }

            ret.chartDataPie.push({
                y: total,
                name: "Others",
                topic_name: "Others",
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });

            ret.chartDataBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                topic_name: "Others",
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });
        }
    }
    if (hasLineData) {
        data.forEach((topic, index) => {
            let count = 0;
            topic.subtopics.forEach((subTopic, ind) => {
                let subtopicColor = subtopicObject[subTopic.subtopic_id].subtopic_color || "#FF0000";
                let line = {
                    data: [],
                    name: subTopic.subtopic_name,
                    value: subTopic.total,
                    topicId: topic.topic_id,
                    subtopicId: subTopic.subtopic_id,
                    allSubtopicSelected: false,
                    topic_name: topic.topic_name,
                    color: subtopicColor,
                };

                subTopic.aggregations.volume_of_conversation.buckets.map((b) => {
                    let date = b.key;
                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.doc_count,
                    });
                });
                lineData.push(line);
                count += count + 1;
            });
            lineData.sort((a, b) => {
                return b.value - a.value;
            });
            ret.csvLineData = lineData;
            ret.chartDataLine = lineData;
            // if (lineData.length <= 9) {
            //     ret.csvLineData = lineData;
            //     ret.chartDataLine = lineData;
            // }
            // if (lineData.length > 9) {
            //     let subtopics = [];
            //     let items = [];
            //     let total = 0;
            //     ret.csvLineData = lineData;
            //     ret.chartDataLine = lineData.slice(0, 9);
            //     let othersLineData = {};
            //     for (let i = 9; i < lineData.length; i++) {
            //         total += lineData[i].y;
            //         subtopics.push(lineData[i].subtopicId);
            //         items.push({ name: lineData[i].name, value: lineData[i].y });
            //         lineData[i].data.map((d) => {
            //             if (othersLineData[d.x]) othersLineData[d.x] += d.y;
            //             else othersLineData[d.x] = d.y;
            //         });
            //     }
            //     let x = [];
            //     Object.keys(othersLineData).map((k) => x.push({ x: +k, y: othersLineData[k] }));
            //     ret.chartDataLine.push({
            //         data: x,
            //         name: "Others",
            //         topic_name: "Others",
            //         value: total,
            //         subtopicIds: subtopics,
            //         color: intToRGB(hashCode("Others")),
            //         allSubtopicSelected: "others",
            //         items,
            //     });
            // }
        });
    }
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;
    return ret;
};

export const formatOverallShareOfVoiceData = (dt, params, topicsObjectparams = false) => {
    // const topicsObject = store.getState().filterSettingReducer.topicsObject;
    const topicsObject = topicsObjectparams ? topicsObjectparams : store.getState().filterSettingReducer.topicsObject;

    let topic_data = params.topic_data;

    let hasLineData = dt[0] && dt[0].aggregations;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;

    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        othersBar: [],
        maximizeBar: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    if (hasLineData) ret.chartDataLine = [];

    let pieData = [];
    let barData = [];
    let lineData = [];

    dt.forEach((tpc, i) => {
        ret.total += tpc.total;
        let tpc_data = topic_data.find((t) => t.topic_id === tpc.topic_id);
        let pie = {
            y: tpc.total,
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            color: topicsObject[tpc.topic_id].color,
            allSubtopicSelected: false,
        };

        let bar = {
            data: [{ name: tpc.topic_name, y: tpc.total }],
            // data: tpc.total,
            name: tpc.topic_name,
            value: tpc.total,
            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            color: topicsObject[tpc.topic_id].color,
            allSubtopicSelected: false,
        };
        let line;
        if (hasLineData) {
            line = {
                data: [],
                name: tpc.topic_name,
                value: tpc.total,
                topicId: tpc.topic_id,
                subtopicIds: tpc_data.subtopicIds,
                color: topicsObject[tpc.topic_id].color,
                allSubtopicSelected: false,
            };

            tpc.aggregations.volume_of_conversation.buckets.map((b) => {
                let date = b.key;
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                line.data.push({
                    x: date,
                    y: b.doc_count,
                });
            });
        }
        let sub = topicsObject[tpc.topic_id].subtopics;
        if (sub.length === tpc_data.subtopicIds.length) {
            pie.allSubtopicSelected = true;
            bar.allSubtopicSelected = true;
            if (line) line.allSubtopicSelected = true;
        }

        pieData.push(pie);
        barData.push(bar);
        if (line) {
            lineData.push(line);
            ret.csvData.push(line);
        } else ret.csvData.push(bar);
    });

    if (ret.total === 0) ret.nodata = true;
    else {
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);
        ret.maximizeBar = barData.slice(9);
        if (pieData.length < 10) {
            ret.chartDataPie = pieData;
            ret.chartDataBar = barData;

            if (hasLineData) ret.chartDataLine = lineData;
        } else {
            ret.chartDataPie = pieData.slice(0, 9);
            ret.chartDataBar = barData.slice(0, 9);
            if (hasLineData) {
                lineData.sort((a, b) => b.value - a.value);
                ret.chartDataLine = lineData.slice(0, 9);
            }

            let total = 0;
            let subtopics = [];
            let topics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;
                if (pieData[i].allSubtopicSelected) topics.push(pieData[i].topicId);
                else subtopics.push(...pieData[i].subtopicIds);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                if (hasLineData) {
                    lineData[i].data.map((d) => {
                        if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                        else othersLineData[d.x] = d.y;
                    });
                }
            }

            ret.chartDataPie.push({
                y: total,
                name: "Others",
                topicIds: topics,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });

            ret.othersBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                topicIds: topics,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });

            if (hasLineData) {
                let x = [];
                Object.keys(othersLineData).map((k) => x.push({ x: Number(k), y: othersLineData[k] }));
                ret.chartDataLine.push({
                    data: x,
                    name: "Others",
                    topicIds: topics,
                    value: total,
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    items,
                });
            }
        }
    }
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};
export const formatEngagementOverTimeByTopic = (data, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let topic_data = params.topic_data;
    let hasLineData = data[0]?.aggregations?.engagement_overtime?.buckets;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;

    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        chartDataLine: [],
        csvLineData: [],
        othersBar: [],
        maximizeBar: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let pieData = [];
    let barData = [];
    let lineData = [];
    let total = 0;
    data.forEach((_topic, _index) => {
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === _topic.topic_id);
        let engagementCount = 0;
        let line = {
            data: [],
            name: _topic.topic_name,
            value: engagementCount,
            topicId: _topic.topic_id,
            subtopicId: [],
            color: topicsObject[_topic.topic_id].color,
            allSubtopicSelected: false,
        };

        _topic.aggregations.engagement_overtime.buckets.forEach((_engagement, _ind) => {
            engagementCount += _engagement.by_impact.value;
            total += _engagement.by_impact.value;
            let date = _engagement.key;
            if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
            if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

            line.data.push({
                x: date,
                y: _engagement.by_impact.value,
            });
        });

        let pie = {
            y: engagementCount,
            name: _topic.topic_name,
            value: engagementCount,
            topicId: _topic.topic_id,
            subtopicId: [],
            color: topicsObject[_topic.topic_id].color,
            allSubtopicSelected: false,
        };

        let bar = {
            data: [{ name: _topic.topic_name, y: engagementCount }],
            name: _topic.topic_name,
            value: engagementCount,
            topicId: _topic.topic_id,
            subtopicId: [],
            color: topicsObject[_topic.topic_id].color,
            allSubtopicSelected: false,
        };
        line.value = engagementCount;

        if (topicsObject[_topic.topic_id].subtopicsIds.length === subTopic[0].subtopicIds.length) {
            line.allSubtopicSelected = true;
            pie.allSubtopicSelected = true;
            bar.allSubtopicSelected = true;
        } else {
            line.subtopicId = subTopic[0].subtopicIds;
            pie.subtopicId = subTopic[0].subtopicIds;
            bar.subtopicId = subTopic[0].subtopicIds;
        }

        lineData.push(line);
        pieData.push(pie);
        barData.push(bar);
    });
    pieData.sort((a, b) => b.y - a.y);
    barData.sort((a, b) => b.value - a.value);
    lineData.sort((a, b) => b.value - a.value);
    ret.csvData = pieData;
    ret.csvLineData = lineData;
    ret.total = total;
    if (total === 0) ret.nodata = true;
    if (lineData.length <= 9) {
        ret.chartDataBar = barData;
        ret.chartDataPie = pieData;
        ret.chartDataLine = lineData;
    } else {
        ret.chartDataBar = barData.slice(0, 9);
        ret.chartDataPie = pieData.slice(0, 9);
        ret.maximizeBar = barData.slice(9);
        ret.chartDataLine = lineData.slice(0, 9);
        if (pieData.length > 9) {
            let othersCount = 0;
            let othersLineData = {};
            let othersTopicIds = [];
            let othersSubtopicIds = [];
            for (let i = 9; i < pieData.length; i++) {
                othersCount += pieData[i].y;
                if (pieData[i].allSubtopicSelected) {
                    othersTopicIds.push(pieData[i].topicId);
                } else {
                    othersSubtopicIds.push(pieData[i].subtopicId);
                }
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
            ret.chartDataPie.push({
                y: othersCount,
                name: "Others",
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                topicId: othersTopicIds,
                subtopicId: othersSubtopicIds,
            });
            ret.othersBar.push({
                data: [{ name: "Others", y: othersCount }],
                name: "Others",
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                topicId: othersTopicIds,
                subtopicId: othersSubtopicIds,
            });
            let lineArray = [];
            Object.keys(othersLineData).map((k) => lineArray.push({ x: Number(k), y: othersLineData[k] }));
            ret.chartDataLine.push({
                data: lineArray,
                name: "Others",
                color: intToRGB(hashCode("Others")),
                topicId: othersTopicIds,
                subtopicId: othersSubtopicIds,
                allSubtopicSelected: "others",
            });
        }
    }
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;
    return ret;
};
export const formatEngagementOverTimeBySubTopic = (data, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
            };
        });
    }

    let hasLineData = data[0]?.subtopics[0]?.aggregations?.engagement_overtime?.buckets;
    let tz;
    if (hasLineData) tz = JSON.parse(localStorage.company).user_timezone_name;

    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        chartDataLine: [],
        csvLineData: [],
        maximizeStackedBarData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let pieData = [];
    let barData = [];
    let lineData = [];
    let total = 0;
    data.forEach((_topic, _index) => {
        _topic.subtopics.forEach((subtopic, sub_index) => {
            let subtopicColor = subtopicObject[subtopic.subtopic_id].subtopic_color || "#FF0000";
            let engagementCount = 0;
            let line = {
                data: [],
                name: subtopic.subtopic_name,
                value: engagementCount,
                topicId: [],
                subtopicId: subtopic.subtopic_id,
                color: subtopicColor,
                allSubtopicSelected: false,
                topic_name: _topic.topic_name,
            };

            subtopic.aggregations.engagement_overtime.buckets.forEach((_engagement, _ind) => {
                engagementCount += _engagement.by_impact.value;
                total += _engagement.by_impact.value;
                let date = _engagement.key;
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                line.data.push({
                    x: date,
                    y: _engagement.by_impact.value,
                });
            });

            let pie = {
                y: engagementCount,
                name: subtopic.subtopic_name,
                value: engagementCount,
                topicId: [],
                subtopicId: subtopic.subtopic_id,
                color: subtopicColor,
                allSubtopicSelected: false,
                topic_name: _topic.topic_name,
            };

            let bar = {
                data: [{ name: subtopic.subtopic_name, y: engagementCount }],
                name: subtopic.subtopic_name,
                value: engagementCount,
                topicId: [],
                subtopicId: subtopic.subtopic_id,
                color: subtopicColor,
                allSubtopicSelected: false,
                topic_name: _topic.topic_name,
            };
            line.value = engagementCount;
            lineData.push(line);
            pieData.push(pie);
            barData.push(bar);
        });
    });
    pieData.sort((a, b) => b.y - a.y);
    barData.sort((a, b) => b.value - a.value);
    lineData.sort((a, b) => b.value - a.value);
    ret.maximizeStackedBarData = JSON.parse(JSON.stringify(barData));
    ret.csvData = pieData;
    ret.csvLineData = lineData;
    ret.total = total;
    if (total === 0) ret.nodata = true;
    if (lineData.length <= 9) {
        ret.chartDataBar = barData;
        ret.chartDataPie = pieData;
        ret.chartDataLine = lineData;
    } else {
        ret.chartDataBar = barData.slice(0, 9);
        ret.chartDataPie = pieData.slice(0, 9);
        ret.chartDataLine = lineData;
        if (pieData.length > 9) {
            let othersCount = 0;
            let othersLineData = {};
            let othersTopicIds = [];
            let othersSubtopicIds = [];
            for (let i = 9; i < pieData.length; i++) {
                othersCount += pieData[i].y;
                if (pieData[i].allSubtopicSelected) {
                    othersTopicIds.push(pieData[i].topicId);
                } else {
                    othersSubtopicIds.push(pieData[i].subtopicId);
                }
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
            ret.chartDataPie.push({
                y: othersCount,
                name: "Others",
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                topicId: othersTopicIds,
                subtopicId: othersSubtopicIds,
                topic_name: "Others",
            });
            ret.chartDataBar.push({
                data: [{ name: "Others", y: othersCount }],
                name: "Others",
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                topicId: othersTopicIds,
                subtopicId: othersSubtopicIds,
                topic_name: "Others",
            });
        }
    }
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatProductAttributeShareOfVoiceData = (dt, params, topicsObjectparams = null) => {
    const topicsObject = topicsObjectparams ? topicsObjectparams : store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;
    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],

            othersBar: [],
            maximizeBar: [],

            csvData: [],
        };

        topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let t = 0;

        tpc.aggregations.channel_analysis.buckets.forEach((subtpc) => {
            t += subtpc.doc_count;

            sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);

            let name = ProductAttributes.data.filter((val) => {
                return val.categoryName === subtpc.key;
            });

            name = name[0].attributeName;
            let pie = {
                y: subtpc.doc_count,
                name,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                color: intToRGB(hashCode(subtpc.key)),
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected: false,
            };

            let bar = {
                data: [
                    {
                        name,
                        y: subtpc.doc_count,
                        categoryName: subtpc.key,
                        topicId: tpc.topic_id,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected: false,
                    },
                ],
                name: name,
                value: subtpc.doc_count,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode(subtpc.key)),
                allSubtopicSelected: false,
            };
            let line;

            line = {
                data: [],
                name,
                value: subtpc.doc_count,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode(subtpc.key)),
                allSubtopicSelected: false,
            };

            subtpc.channel_analysis.buckets.map((b) => {
                let date = b.key;

                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                line.data.push({
                    x: date,
                    y: b.doc_count,
                    categoryName: subtpc.key,
                    topicId: tpc.topic_id,
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected: false,
                });
            });

            pieData.push(pie);
            barData.push(bar);
            if (line) {
                lineData.push(line);
                topic.csvData.push(line);
            } else topic.csvData.push(bar);

            let subTopic = topicsObject[tpc.topic_id]?.subtopics;

            if (subTopic.length === sub[0].subtopicIds.length) {
                pie.allSubtopicSelected = true;
                bar.allSubtopicSelected = true;
                bar.data[0].allSubtopicSelected = true;
                line.allSubtopicSelected = true;
                line.data.forEach((ele) => {
                    ele.allSubtopicSelected = true;
                });

                allSubtopicSelected = true;
            }
        });
        ret.total += t;
        topic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);

            lineData.sort((a, b) => b.value - a.value);
            topic.chartDataLine = lineData.slice(0, 9);

            topic.maximizeBar.push(barData.slice(9));

            let total = 0;

            let topics = [];
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;

                subtopics.push(pieData[i].subtopicId[0]);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                // if (hasLineData) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
                // }
            }

            let subTopic = topicsObject[tpc.topic_id].subtopics;

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                allSubtopicSelected,
            });

            topic.othersBar.push({
                data: [
                    {
                        name: "Others",
                        y: total,
                        items,
                        topicId: pieData[0].topicId,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected,
                    },
                ],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            // if (hasLineData) {
            let x = [];
            Object.keys(othersLineData).map((k) =>
                x.push({
                    name: "Others",
                    x: Number(k),
                    y: othersLineData[k],
                    topicId: lineData[0].topicId,
                    items,
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected,
                }),
            );
            topic.chartDataLine.push({
                data: x,
                name: "Others",
                topicId: lineData[0].topicId,
                value: total,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });
            //  }
        }
        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatProductAttributeShareOfVoiceData1 = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
    };

    let data = dt.aggregations.channel_analysis.buckets;

    let logoBucket = {};
    let xs = [];

    params.product_attribute_categories &&
        params.product_attribute_categories.forEach((attr) => {
            logoBucket[attr] = {};
        });

    if (params.product_attribute_categories.length == 0) {
        ProductAttributes.data.forEach((attr) => {
            logoBucket[attr.categoryName] = {};
        });
    }

    data.forEach((element, index) => {
        element.channel_analysis.buckets.forEach((ele, ind) => {
            if (logoBucket[element.key]) {
                logoBucket[element.key][ele.key] = ele.doc_count;
            }
        });
    });

    data[0]?.channel_analysis.buckets.forEach((ele, ind) => {
        xs.push(ele.key);
    });

    Object.entries(logoBucket).forEach(([k, v]) => {
        let objectObj = {
            name: k,
        };

        let lineData = {};
        let totalValueForObjects = 0;

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        xs.forEach((x) => {
            let date = x;
            if (moment(params.end_date).isBefore(moment(x).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
            if (moment(params.start_date).isAfter(moment(x).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

            if (lineData[date]) {
                if (v[x]) {
                    lineData[date] += v[x];
                    totalValueForObjects += v[x];
                }
                // else lineData[date] = 0;
            } else {
                if (v[x]) {
                    lineData[date] = v[x];
                    totalValueForObjects += v[x];
                } else lineData[date] = 0;
            }
        });
        objectObj.value = totalValueForObjects;
        objectObj.lineData = Object.entries(lineData).map(([date, val]) => {
            let name = ProductAttributes.data.filter((val) => {
                return val.categoryName === k;
            });
            return {
                x: +date,
                y: val,
                name: name[0].attributeName,
                categoryName: k,
            };
        });

        ret.data.push(objectObj);
    });

    let res = {
        nodata: false,
        PieObjectData: [],
        barObjectData: [],
        maximizeBarObjectData: [],
        lineObjectData: [],
        csvData: [],
        total: 0,
        Others: [],
    };

    let PieObjectData = [];
    let barObjectData = [];
    let lineObjectData = [];
    let maximizeBarObjectData = [];

    ret.data.forEach((element, ind) => {
        res.total = JSON.parse(JSON.stringify(res.total + element.value));
        // if ((params.logos && params.logos.includes(element.name)) || params.logos == "") {
        let name = ProductAttributes.data.filter((val) => {
            return val.categoryName === element.name;
        });

        PieObjectData.push({
            y: element.value,
            name: name[0]?.attributeName,
            color: intToRGB(hashCode(element.name)),
            categoryName: element.name,
        });

        barObjectData.push({
            data: [
                {
                    name: name[0]?.attributeName,
                    y: element.value,
                    categoryName: element.name,
                },
            ],
            name: name[0]?.attributeName,
            color: intToRGB(hashCode(element.name)),
            value: element.value,
            categoryName: element.name,
        });

        lineObjectData.push({
            data: element.lineData,
            name: name[0]?.attributeName,
            color: intToRGB(hashCode(element.name)),
            value: element.value,
            categoryName: element.name,
        });

        maximizeBarObjectData.push({
            data: [
                {
                    name: name[0]?.attributeName,
                    y: element.value,
                    categoryName: element.name,
                },
            ],
            name: name[0]?.attributeName,
            color: intToRGB(hashCode(element.name)),
            value: element.value,
            categoryName: element.name,
        });

        if (lineObjectData) {
            res.csvData.push(lineObjectData);
        } else res.csvData.push(barObjectData);
        //  }
    });

    if (PieObjectData.length == 0 && barObjectData.length == 0 && lineObjectData.length == 0) res.nodata = true;
    //  else {

    PieObjectData.sort((a, b) => b.y - a.y);
    barObjectData.sort((a, b) => b.value - a.value);
    maximizeBarObjectData.sort((a, b) => b.value - a.value);

    res.maximizeBarObjectData = maximizeBarObjectData.slice(9);

    if (PieObjectData.length < 10) {
        res.PieObjectData = PieObjectData;
        res.barObjectData = barObjectData;
        if (lineObjectData) res.lineObjectData = lineObjectData;
    } else {
        res.PieObjectData = PieObjectData.slice(0, 9);
        res.barObjectData = barObjectData.slice(0, 9);
        if (lineObjectData) {
            lineObjectData.sort((a, b) => b.value - a.value);
            res.lineObjectData = lineObjectData.slice(0, 9);
        }

        let total = 0;

        let items = [];
        let othersLineData = {};

        for (let i = 9; i < PieObjectData.length; i++) {
            total += PieObjectData[i].y;

            items.push({ name: PieObjectData[i].name, value: PieObjectData[i].y });
            if (lineObjectData) {
                lineObjectData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
            }
        }

        res.PieObjectData.push({
            y: total,
            name: "Others",
            color: intToRGB(hashCode("Others")),

            items,
        });

        res.Others.push({
            data: [{ name: "Others", y: total, items }],
            name: "Others",
            color: intToRGB(hashCode("Others")),
            items,
            value: total,
        });

        if (lineObjectData) {
            let x = [];
            Object.keys(othersLineData).map((k) => x.push({ x: Number(k), y: othersLineData[k], name: "Others", items }));

            res.lineObjectData.push({
                data: x,
                name: "Others",
                value: total,
                color: intToRGB(hashCode("Others")),
            });
        }
    }
    // }
    //res.total = dt.hits.total;

    let total = 0;
    res.barObjectData.map((val) => {
        total += val.value;
    });

    if (total == 0) res.nodata = true;

    res.maximizeBarObjectData = res.maximizeBarObjectData.filter((ele) => ele.value != 0);
    res.lineObjectData = res.lineObjectData.filter((ele) => ele.value != 0);
    res.barObjectData = res.barObjectData.filter((ele) => ele.value != 0);
    res.PieObjectData = res.PieObjectData.filter((ele) => ele.value != 0);
    // res.Others.items = res.Others.items.filter((ele) => ele.value != 0);

    return res;
};

export const formatOverallShareOfVoiceDataForLogo = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;

    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],

            othersBar: [],
            maximizeBar: [],

            csvData: [],
        };

        topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let t = 0;

        tpc.aggregations.logo_overtime.buckets.forEach((subtpc) => {
            if (params.logos === undefined || params.logos.includes(subtpc.key) || params.logos.length == 0) {
                t += subtpc.doc_count;

                sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);

                // let sub = topicsObject[tpc.topic_id].subtopics.find((s) => s.subtopic_id === subtpc.subtopic_id);
                // let color;
                // if (sub.subtopic_graph_color === null) {
                //     color = "#000000";
                // } else {
                //     color = sub.subtopic_graph_color;
                // }

                let name = ProductAttributes.data.filter((val) => {
                    return val.categoryName === subtpc.key;
                });

                // name = name[0].attributeName;
                let pie = {
                    y: subtpc.doc_count,
                    name: subtpc.key,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    subtopicId: sub[0].subtopicIds,
                    color: intToRGB(hashCode(subtpc.key)),
                };

                let bar = {
                    data: [
                        {
                            name: subtpc.key,
                            y: subtpc.doc_count,
                            categoryName: subtpc.key,
                            subtopicId: sub[0].subtopicIds,
                            topicId: tpc.topic_id,
                        },
                    ],
                    name: subtpc.key,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    subtopicId: sub[0].subtopicIds,
                    //: subtpc.subtopic_id,
                    color: intToRGB(hashCode(subtpc.key)),
                };
                let line;

                line = {
                    data: [],
                    name: subtpc.key,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    subtopicId: sub[0].subtopicIds,
                    // subtopicId: subtpc.subtopic_id,
                    color: intToRGB(hashCode(subtpc.key)),
                };

                subtpc.data_over_time.buckets.map((b) => {
                    let date = b.key;

                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.doc_count,
                        categoryName: subtpc.key,
                        subtopicId: sub[0].subtopicIds,
                        topicId: tpc.topic_id,
                    });
                });

                pieData.push(pie);
                barData.push(bar);
                if (line) {
                    lineData.push(line);
                    topic.csvData.push(line);
                } else topic.csvData.push(bar);
                let subTopic = topicsObject[tpc.topic_id].subtopics;

                if (subTopic.length === sub[0].subtopicIds.length) {
                    pie.allSubtopicSelected = true;
                    bar.allSubtopicSelected = true;
                    bar.data[0].allSubtopicSelected = true;
                    line.allSubtopicSelected = true;
                    line.data.forEach((ele) => {
                        ele.allSubtopicSelected = true;
                    });

                    allSubtopicSelected = true;
                }
            }
        });
        ret.total += t;

        topic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);

            lineData.sort((a, b) => b.value - a.value);
            topic.chartDataLine = lineData.slice(0, 9);

            topic.maximizeBar.push(barData.slice(9));

            let total = 0;
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;

                subtopics.push(pieData[i].subtopicId[0]);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                // if (hasLineData) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
                // }
            }

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected,
            });

            topic.othersBar.push({
                data: [
                    {
                        name: "Others",
                        y: total,
                        items,
                        topicId: pieData[0].topicId,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected,
                    },
                ],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected,
            });

            // if (hasLineData) {
            let x = [];
            Object.keys(othersLineData).map((k) =>
                x.push({
                    name: "Others",
                    x: Number(k),
                    y: othersLineData[k],
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected,
                    topicId: lineData[0].topicId,
                    items,
                }),
            );
            topic.chartDataLine.push({
                data: x,
                name: "Others",
                topicId: lineData[0].topicId,
                value: total,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });
            //  }
        }
        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatOverallShareOfVoiceDataForObject = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;
    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],

            othersBar: [],
            maximizeBar: [],

            csvData: [],
        };

        topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let t = 0;

        tpc.aggregations.object_overtime.buckets.forEach((subtpc) => {
            if (params.objects === undefined || params.objects.includes(subtpc.key) || params.objects.length == 0) {
                t += subtpc.doc_count;
                //  let sub = topicsObject[tpc.topic_id].subtopics.find((s) => s.subtopic_id === subtpc.subtopic_id);
                // let color;
                // if (sub.subtopic_graph_color === null) {
                //     color = "#000000";
                // } else {
                //     color = sub.subtopic_graph_color;
                // }
                sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);
                let name = toTitleCase(subtpc.key);

                // name = name[0].attributeName;
                let pie = {
                    y: subtpc.doc_count,
                    name,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    color: intToRGB(hashCode(subtpc.key)),
                    subtopicId: sub[0].subtopicIds,
                    logoName: subtpc.key,
                };

                let bar = {
                    data: [
                        {
                            name,
                            y: subtpc.doc_count,
                            categoryName: subtpc.key,
                            topicId: tpc.topic_id,
                            subtopicId: sub[0].subtopicIds,
                            logoName: subtpc.key,
                        },
                    ],
                    name,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    //: subtpc.subtopic_id,
                    subtopicId: sub[0].subtopicIds,
                    logoName: subtpc.key,
                    color: intToRGB(hashCode(subtpc.key)),
                };
                let line;

                line = {
                    data: [],
                    name,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    logoName: subtpc.key,
                    subtopicId: sub[0].subtopicIds,
                    // subtopicId: subtpc.subtopic_id,
                    color: intToRGB(hashCode(subtpc.key)),
                };

                subtpc.data_over_time.buckets.map((b) => {
                    let date = b.key;

                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.doc_count,
                        categoryName: subtpc.key,
                        topicId: tpc.topic_id,
                        subtopicId: sub[0].subtopicIds,
                        logoName: subtpc.key,
                    });
                });

                pieData.push(pie);
                barData.push(bar);
                if (line) {
                    lineData.push(line);
                    topic.csvData.push(line);
                } else topic.csvData.push(bar);
                let subTopic = topicsObject[tpc.topic_id].subtopics;

                if (subTopic.length === sub[0].subtopicIds.length) {
                    pie.allSubtopicSelected = true;
                    bar.allSubtopicSelected = true;
                    bar.data[0].allSubtopicSelected = true;
                    line.allSubtopicSelected = true;
                    line.data.forEach((ele) => {
                        ele.allSubtopicSelected = true;
                    });

                    allSubtopicSelected = true;
                }
            }
        });
        ret.total += t;
        topic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);

            lineData.sort((a, b) => b.value - a.value);
            topic.chartDataLine = lineData.slice(0, 9);

            topic.maximizeBar.push(barData.slice(9));

            let total = 0;
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;

                subtopics.push(pieData[i].subtopicId[0]);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                // if (hasLineData) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
                // }
            }

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected,
            });

            topic.othersBar.push({
                data: [
                    {
                        name: "Others",
                        y: total,
                        items,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected,
                        topicId: pieData[0].topicId,
                    },
                ],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            // if (hasLineData) {
            let x = [];
            Object.keys(othersLineData).map((k) =>
                x.push({
                    name: "Others",
                    x: Number(k),
                    y: othersLineData[k],
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected,
                    topicId: lineData[0].topicId,
                    items,
                }),
            );
            topic.chartDataLine.push({
                data: x,
                name: "Others",
                topicId: lineData[0].topicId,
                value: total,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });
            //  }
        }
        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    // res.csvData = res.csvData.sort((a, b) => {
    //     if (!a.length || !b.length) {
    //         return 0;
    //     }
    //     if (a[0].logoName.toLowerCase() < b[0].logoName.toLowerCase()) {
    //         return -1;
    //     }
    //     if (a[0].logoName.toLowerCase() > b[0].logoName.toLowerCase()) {
    //         return 1;
    //     }
    // });

    return ret;
};

export const formatOverallShareOfVoiceDataForScene = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;

    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],

            othersBar: [],
            maximizeBar: [],

            csvData: [],
        };

        topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let t = 0;

        tpc.aggregations.logo_overtime.buckets.forEach((subtpc) => {
            if (params.scenes === undefined || params.scenes.includes(subtpc.key) || params.scenes.length == 0) {
                t += subtpc.doc_count;
                sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);
                // let sub = topicsObject[tpc.topic_id].subtopics.find((s) => s.subtopic_id === subtpc.subtopic_id);
                // let color;
                // if (sub.subtopic_graph_color === null) {
                //     color = "#000000";
                // } else {
                //     color = sub.subtopic_graph_color;
                // }

                let sceneName = toTitleCase(subtpc.key);
                let name = scenesNameFormating(sceneName);

                // name = name[0].attributeName;
                let pie = {
                    y: subtpc.doc_count,
                    name,
                    sceneName,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    color: intToRGB(hashCode(subtpc.key)),
                    subtopicId: sub[0].subtopicIds,
                    logoName: subtpc.key,
                };

                let bar = {
                    data: [
                        {
                            name,
                            y: subtpc.doc_count,
                            categoryName: subtpc.key,
                            topicId: tpc.topic_id,
                            subtopicId: sub[0].subtopicIds,
                            logoName: subtpc.key,
                            sceneName,
                        },
                    ],
                    name,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    sceneName,
                    subtopicId: sub[0].subtopicIds,
                    //: subtpc.subtopic_id,
                    color: intToRGB(hashCode(subtpc.key)),
                    logoName: subtpc.key,
                };
                let line;

                line = {
                    data: [],
                    name,
                    value: subtpc.doc_count,
                    topicId: tpc.topic_id,
                    categoryName: subtpc.key,
                    sceneName,
                    subtopicId: sub[0].subtopicIds,
                    // subtopicId: subtpc.subtopic_id,
                    color: intToRGB(hashCode(subtpc.key)),
                };

                subtpc.data_over_time.buckets.map((b) => {
                    let date = b.key;

                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                    line.data.push({
                        x: date,
                        y: b.doc_count,
                        sceneName,
                        topicId: tpc.topic_id,
                        subtopicId: sub[0].subtopicIds,
                        logoName: subtpc.key,
                    });
                });

                pieData.push(pie);
                barData.push(bar);
                if (line) {
                    lineData.push(line);
                    topic.csvData.push(line);
                } else topic.csvData.push(bar);
                let subTopic = topicsObject[tpc.topic_id].subtopics;

                if (subTopic.length === sub[0].subtopicIds.length) {
                    pie.allSubtopicSelected = true;
                    bar.allSubtopicSelected = true;
                    bar.data[0].allSubtopicSelected = true;
                    line.allSubtopicSelected = true;
                    line.data.forEach((ele) => {
                        ele.allSubtopicSelected = true;
                    });

                    allSubtopicSelected = true;
                }
            }
        });
        ret.total += t;
        topic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);

            lineData.sort((a, b) => b.value - a.value);
            topic.chartDataLine = lineData.slice(0, 9);

            topic.maximizeBar.push(barData.slice(9));

            let total = 0;
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;

                subtopics.push(pieData[i].subtopicId[0]);
                items.push({
                    name: pieData[i].name,
                    value: pieData[i].y,
                    sceneName: pieData[i].sceneName,
                });
                // if (hasLineData) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
                // }
            }

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected,
            });

            topic.othersBar.push({
                data: [
                    {
                        name: "Others",
                        y: total,
                        items,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected,
                        topicId: pieData[0].topicId,
                    },
                ],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            // if (hasLineData) {
            let x = [];
            Object.keys(othersLineData).map((k) =>
                x.push({
                    name: "Others",
                    x: Number(k),
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected,
                    y: othersLineData[k],
                    topicId: lineData[0].topicId,
                    items,
                }),
            );
            topic.chartDataLine.push({
                data: x,
                name: "Others",
                topicId: lineData[0].topicId,
                value: total,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });
            //  }
        }
        ret.data.push(topic);
    });

    if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatTopicWiseSentimentBreakup = (data) => {
    let totalData = 0;
    // let maxtotalData = 0;

    let tot = 0;
    let restPos = 0;
    let resNegative = 0;
    let resNeut = 0;
    let resIds = [];
    let maxtot = 0;
    let maxrestPos = 0;
    let maxresNegative = 0;
    let maxresNeut = 0;
    let maxresIds = [];

    let csvTotalData = 0;

    const allTopics = store.getState().filterSettingReducer.topicsAndSubtopics;

    let csvRes = {
        keys: [],
        positive: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
    };

    data.forEach((d, i) => {
        let subtopic = d.input && allTopics.find((subtopic) => subtopic.subtopic_id === d.input);
        csvRes.keys.push(`${subtopic.subtopic_name} (${subtopic.topic_name})`);
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) csvRes[sent.key][i] = sent.doc_count;
            });
    });

    let sortedData = [...data].sort((a, b) => {
        {
            if (a.data && b.data) {
                return a.data.aggregations.sentiments_breakup.group1.doc_count < b.data.aggregations.sentiments_breakup.group1.doc_count
                    ? 1
                    : b.data.aggregations.sentiments_breakup.group1.doc_count < a.data.aggregations.sentiments_breakup.group1.doc_count
                    ? -1
                    : 0;
            }
        }
    });

    let dataFirst = sortedData && sortedData.length >= 10 ? sortedData && sortedData.length && sortedData.slice(0, 9) : sortedData;
    let dataSecond = sortedData && sortedData.length >= 10 ? sortedData && sortedData.length && sortedData.slice(-(data.length - 9)) : [];
    let dataThird = sortedData.slice(0, 50);
    let dataFourth = sortedData && sortedData.length >= 50 ? sortedData.slice(-(data.length - 49)) : [];

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        maxkey: [],
        maxpositive: [],
        maxnegative: [],
        maxneutral: [],
        csvRes: csvRes,
    };

    let res = {
        key: [],
        positive: new Array(dataFirst.length).fill(0),
        negative: new Array(dataFirst.length).fill(0),
        neutral: new Array(dataFirst.length).fill(0),
        total: new Array(dataFirst.length).fill(0),
        maxkey: [],
        maxpositive: new Array(dataThird.length).fill(0),
        maxnegative: new Array(dataThird.length).fill(0),
        maxneutral: new Array(dataThird.length).fill(0),
        maxtotal: new Array(dataThird.length).fill(0),
    };

    dataFirst &&
        dataFirst.forEach((d, i) => {
            d.input && res.key.push(d.input);
            res.total[i] = d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
            totalData += res.total[i];
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res[sent.key][i] = sent.doc_count;
            });
        });

    dataThird &&
        dataThird.forEach((d, i) => {
            d.input && res.maxkey.push(d.input);
            res.maxtotal[i] = d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
            totalData += res.total[i];
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res["max" + sent.key][i] = sent.doc_count;
            });
        });

    dataSecond.forEach((d, i) => {
        tot += d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
        d.input && resIds.push(d.input);
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.length &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    if (sent.key === "positive") {
                        restPos += sent.doc_count;
                    } else if (sent.key === "negative") {
                        resNegative += sent.doc_count;
                    } else if (sent.key === "neutral") {
                        resNeut += sent.doc_count;
                    }
                }
            });
    });

    dataFourth.forEach((d, i) => {
        maxtot += d.data ? d.data.aggregations.sentiments_breakup.group1.doc_count : 0;
        d.input && maxresIds.push(d.input);
        d.data &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.length &&
            d.data.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    if (sent.key === "positive") {
                        maxrestPos += sent.doc_count;
                    } else if (sent.key === "negative") {
                        maxresNegative += sent.doc_count;
                    } else if (sent.key === "neutral") {
                        maxresNeut += sent.doc_count;
                    }
                }
            });
    });
    if (dataSecond && dataSecond.length) {
        res.key.push("others");
        res.positive.push(restPos);
        res.negative.push(resNegative);
        res.neutral.push(resNeut);
        res.total.push(tot);
    }
    // if (dataFourth && dataFourth.length) {
    //     res.maxkey.push("others");
    //     res.maxpositive.push(maxrestPos);
    //     res.maxnegative.push(maxresNegative);
    //     res.maxneutral.push(maxresNeut);
    //     res.maxtotal.push(maxtot);
    // }

    if (totalData + tot === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.subtopic_id === d) : "Others";
            if (subtopic) {
                let name = d !== "others" ? `${subtopic.subtopic_name} (${subtopic.topic_name})` : subtopic;
                chartData.keys.push(name);
                let x = {
                    name: d,
                    totalData: res.total[i],
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && resIds.length > 0) {
                    x.subtopicIds = resIds;
                }

                if (res.total[i]) {
                    chartData.positive.push({
                        ...x,
                        percentage: +((res.positive[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "positive",
                        doc_count: res.positive[i],
                        y: res.positive[i],
                    });
                    chartData.negative.push({
                        ...x,
                        percentage: +((res.negative[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "negative",
                        doc_count: res.negative[i],
                        y: res.negative[i],
                    });
                    chartData.neutral.push({
                        ...x,
                        percentage: +((res.neutral[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "neutral",
                        doc_count: res.neutral[i],
                        y: res.neutral[i],
                    });
                }
            }
        });

        res.maxkey.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.subtopic_id === d) : "Others";
            if (subtopic) {
                let name = d !== "others" ? `${subtopic.subtopic_name} (${subtopic.topic_name})` : subtopic;
                chartData.maxkey.push(name);
                let x = {
                    name: d,
                    totalData: res.maxtotal[i],
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && maxresIds.length > 0) {
                    x.subtopicIds = maxresIds;
                }

                if (res.maxtotal[i]) {
                    chartData.maxpositive.push({
                        ...x,
                        percentage: +((res.maxpositive[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "positive",
                        doc_count: res.maxpositive[i],
                        y: res.maxpositive[i],
                    });
                    chartData.maxnegative.push({
                        ...x,
                        percentage: +((res.maxnegative[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "negative",
                        doc_count: res.maxnegative[i],
                        y: res.maxnegative[i],
                    });
                    chartData.maxneutral.push({
                        ...x,
                        percentage: +((res.maxneutral[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "neutral",
                        doc_count: res.maxneutral[i],
                        y: res.maxneutral[i],
                    });
                }
            }
        });
    }

    return chartData;
};
export const formatSubTopicWiseSentimentBreakup = (data) => {
    let totalData = 0;
    // let maxtotalData = 0;

    let tot = 0;
    let restPos = 0;
    let resNegative = 0;
    let resNeut = 0;
    let resIds = [];
    let maxtot = 0;
    let maxrestPos = 0;
    let maxresNegative = 0;
    let maxresNeut = 0;
    let maxresIds = [];

    let csvTotalData = 0;

    const allTopics = store.getState().filterSettingReducer.topicsAndSubtopics;

    let csvRes = {
        keys: [],
        positive: new Array(data.length).fill(0),
        negative: new Array(data.length).fill(0),
        neutral: new Array(data.length).fill(0),
    };

    data.forEach((d, i) => {
        let subtopic = d.topic_id && allTopics.find((subtopic) => subtopic.topic_id === d.topic_id);
        csvRes.keys.push(`${subtopic.topic_name}`);

        d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
            if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) csvRes[sent.key][i] = sent.doc_count;
        });
    });

    let sortedData = [...data].sort((a, b) => {
        {
            if (a && b) {
                return a.aggregations.sentiments_breakup.group1.doc_count < b.aggregations.sentiments_breakup.group1.doc_count
                    ? 1
                    : b.aggregations.sentiments_breakup.group1.doc_count < a.aggregations.sentiments_breakup.group1.doc_count
                    ? -1
                    : 0;
            }
        }
    });

    let dataFirst = sortedData && sortedData.length >= 10 ? sortedData && sortedData.length && sortedData.slice(0, 9) : sortedData;
    let dataSecond = sortedData && sortedData.length >= 10 ? sortedData && sortedData.length && sortedData.slice(-(data.length - 9)) : [];
    let dataThird = sortedData.slice(0, 50);
    let dataFourth = sortedData && sortedData.length >= 50 ? sortedData.slice(-(data.length - 49)) : [];

    let chartData = {
        nodata: false,
        keys: [],
        positive: [],
        negative: [],
        neutral: [],
        maxkey: [],
        maxpositive: [],
        maxnegative: [],
        maxneutral: [],
        csvRes: csvRes,
    };

    let res = {
        key: [],
        positive: new Array(dataFirst.length).fill(0),
        negative: new Array(dataFirst.length).fill(0),
        neutral: new Array(dataFirst.length).fill(0),
        total: new Array(dataFirst.length).fill(0),
        maxkey: [],
        maxpositive: new Array(dataThird.length).fill(0),
        maxnegative: new Array(dataThird.length).fill(0),
        maxneutral: new Array(dataThird.length).fill(0),
        maxtotal: new Array(dataThird.length).fill(0),
    };

    dataFirst &&
        dataFirst.forEach((d, i) => {
            d.topic_id && res.key.push(d.topic_id);
            res.total[i] = d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
            totalData += res.total[i];
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res[sent.key][i] = sent.doc_count;
            });
        });

    dataThird &&
        dataThird.forEach((d, i) => {
            d.topic_id && res.maxkey.push(d.topic_id);
            res.maxtotal[i] = d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
            totalData += res.total[i];
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res["max" + sent.key][i] = sent.doc_count;
            });
        });

    dataSecond.forEach((d, i) => {
        tot += d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
        d.topic_id && resIds.push(d.topic_id);
        d &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.length &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    if (sent.key === "positive") {
                        restPos += sent.doc_count;
                    } else if (sent.key === "negative") {
                        resNegative += sent.doc_count;
                    } else if (sent.key === "neutral") {
                        resNeut += sent.doc_count;
                    }
                }
            });
    });

    dataFourth.forEach((d, i) => {
        maxtot += d ? d.aggregations.sentiments_breakup.group1.doc_count : 0;
        d.topic_id && maxresIds.push(d.topic_id);
        d &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.length &&
            d.aggregations.sentiments_breakup.group1.group2.buckets.forEach((sent) => {
                if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) {
                    if (sent.key === "positive") {
                        maxrestPos += sent.doc_count;
                    } else if (sent.key === "negative") {
                        maxresNegative += sent.doc_count;
                    } else if (sent.key === "neutral") {
                        maxresNeut += sent.doc_count;
                    }
                }
            });
    });
    if (dataSecond && dataSecond.length) {
        res.key.push("others");
        res.positive.push(restPos);
        res.negative.push(resNegative);
        res.neutral.push(resNeut);
        res.total.push(tot);
    }
    // if (dataFourth && dataFourth.length) {
    //     res.maxkey.push("others");
    //     res.maxpositive.push(maxrestPos);
    //     res.maxnegative.push(maxresNegative);
    //     res.maxneutral.push(maxresNeut);
    //     res.maxtotal.push(maxtot);
    // }

    if (totalData + tot === 0) chartData.nodata = true;
    else {
        res.key.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.topic_id === d) : "Others";
            if (subtopic) {
                let name = d !== "others" ? `${subtopic.topic_name}` : subtopic;
                chartData.keys.push(name);
                let x = {
                    name: d,
                    totalData: res.total[i],
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && resIds.length > 0) {
                    x.subtopicIds = resIds;
                }

                if (res.total[i]) {
                    chartData.positive.push({
                        ...x,
                        percentage: +((res.positive[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "positive",
                        doc_count: res.positive[i],
                        y: res.positive[i],
                    });
                    chartData.negative.push({
                        ...x,
                        percentage: +((res.negative[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "negative",
                        doc_count: res.negative[i],
                        y: res.negative[i],
                    });
                    chartData.neutral.push({
                        ...x,
                        percentage: +((res.neutral[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "neutral",
                        doc_count: res.neutral[i],
                        y: res.neutral[i],
                    });
                }
            }
        });

        res.maxkey.forEach((d, i) => {
            let subtopic = d !== "others" ? allTopics.find((subtopic) => subtopic.topic_id === d) : "Others";
            if (subtopic) {
                let name = d !== "others" ? `${subtopic.topic_name}` : subtopic;
                chartData.maxkey.push(name);
                let x = {
                    name: d,
                    totalData: res.maxtotal[i],
                    subtopicId: d,
                    labelName: name,
                };

                if (subtopic === "Others" && maxresIds.length > 0) {
                    x.subtopicIds = maxresIds;
                }

                if (res.maxtotal[i]) {
                    chartData.maxpositive.push({
                        ...x,
                        percentage: +((res.maxpositive[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "positive",
                        doc_count: res.maxpositive[i],
                        y: res.maxpositive[i],
                    });
                    chartData.maxnegative.push({
                        ...x,
                        percentage: +((res.maxnegative[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "negative",
                        doc_count: res.maxnegative[i],
                        y: res.maxnegative[i],
                    });
                    chartData.maxneutral.push({
                        ...x,
                        percentage: +((res.maxneutral[i] / x.totalData) * 100).toFixed(2) || 0,
                        sentiment: "neutral",
                        doc_count: res.maxneutral[i],
                        y: res.maxneutral[i],
                    });
                }
            }
        });
    }

    return chartData;
};

export const formatGeneralTrends = (data, params) => {
    let res = {
        chartData: [],
        nodata: false,
        xs: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;
    let total = 0;
    let buckets = data.data.aggregations.data_over_time.buckets;

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    buckets.map((bucket, i) => {
        let date = bucket.key;
        // if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        // res.xs.push(date);
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        res.xs.push(date);
        res.chartData.push({
            x: date,
            y: bucket.doc_count,
            doc_count: bucket.doc_count,
        });
        total += bucket.doc_count;
    });

    if (total === 0) res.nodata = true;

    return res;
};

export const formatGeneralTrendsWithTopics = (data) => {
    let buckets = data.data.aggregations.data_over_time.buckets;
    let xs = buckets.map((t) => moment(t.key).valueOf());
    let vals = buckets.map((t) => t.total_count.value);

    return { xs, vals };
};

const formatGeneralTrendsWithTopicsData = (buckets, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let response = {
        chartData: [],
        nodata: false,
        responseObj: {},
        date: {
            start_date: "",
            end_date: "",
        },
    };
    var x = [];

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    buckets[0].xs.forEach((b, i) => {
        let date = b;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        if (!x.includes(date)) {
            x.push(date);
        }
    });

    let total = 0;
    for (let i = 0; i < buckets[1].vals.length; i++) {
        if (!x[i]) continue;
        total += buckets[1].vals[i];
    }
    if (total === 0) response.nodata = true;
    else {
        buckets[0].res.forEach((tpc) => {
            tpc["color"] = topicsObject[tpc.id].color;
        });

        let series = {
            name: "General Trends",
            color: intToRGB(hashCode("GENERAL TRENDS")),
            data: [],
            total: 0,
        };
        buckets[1].vals.forEach((val, i) => {
            if (!x[i]) return;
            series.data.push({ x: x[i], y: val, seriesName: "General Trends" });
            series.total += val;
        });
        response.chartData.push(series);

        buckets[0].res.forEach((b, i) => {
            let series = {
                name: b.name,
                color: b.color,
                data: [],
                total: b.total,
                topicId: b.id,
                subtopicIds: b.subtopicIds,
                allSubtopicSelected: b.allSubtopicSelected,
            };

            b.values.forEach((val, i) => {
                if (!x[i]) return;
                series.data.push({ x: x[i], y: val, seriesName: b.name });
            });
            response.chartData.push(series);
        });

        if (response.chartData.length && response.chartData.length >= 10) {
            let updatechartTotalData = response.chartData.slice(9);
            response.chartData = response.chartData.slice(0, 9);

            let Others = {
                name: "Others",
                color: intToRGB(hashCode("Others")),
                data: [],
                total: 0,
                topicId: [],
                subtopicIds: [],
                allSubtopicSelected: "others",
            };

            for (let i = 0; i < updatechartTotalData[0].data.length; i++) {
                let common = updatechartTotalData[0].data[i].x;
                let sum = 0;
                for (let j = 0; j < updatechartTotalData.length; j++) {
                    if (i === 0) {
                        if (updatechartTotalData[j].allSubtopicSelected) {
                            Others.topicId.push(updatechartTotalData[j].topicId);
                        } else {
                            Others.subtopicIds.push(...updatechartTotalData[j].subtopicIds);
                        }
                    }
                    updatechartTotalData[j].data.forEach((element) => {
                        if (element.x == common) {
                            sum += element.y;
                        }
                    });
                }
                Others.data.push({ x: common, y: sum, seriesName: "Others" });
                Others.total = sum;
            }

            response.chartData.push(Others);
        }

        buckets[0].xs = x;
        buckets[1].xs = x;

        response.responseObj = buckets;
    }
    response.date.start_date = params.start_date;
    response.date.end_date = params.end_date;

    return response;
};

const getMomentsOvertimeData = (buckets, top_moments, params) => {
    let res = {
        chartData: [],
        nodata: false,
        responseObj: {},
        top_moments,
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let allTotal = 0;

    var x = [];

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    buckets.forEach((bucket) => {
        bucket.data_over_time.buckets.forEach((b, i) => {
            let date = b.key;
            if (x.indexOf(date) < 0) {
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                x.push(date);
            }
        });
    });

    x.sort();
    x = _.uniq(x);
    res.responseObj.xs = x;

    let others = { total: 0, data: [] };
    res.date.start_date = params.start_date;
    res.date.end_date = params.end_date;

    buckets.forEach((bucket, i) => {
        let keyName = top_moments.find((elem) => elem.id === bucket.key).name;
        res.responseObj[keyName] = [];
        let series = {
            name: keyName,
            color: intToRGB(hashCode(keyName)),
            momentId: bucket.key,
            data: [],
            total: 0,
        };
        for (let i = 0; i < x.length; i++) {
            let elem = bucket.data_over_time.buckets.find((temp) => temp.key === x[i]);
            let date = x[i];
            if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
            if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
            if (elem) {
                res.responseObj[keyName].push(elem.doc_count);
                series.data.push({ x: date, y: elem.doc_count, seriesName: keyName });
                series.total += elem.doc_count;
            } else {
                res.responseObj[keyName].push(0);
                series.data.push({ x: date, y: 0, seriesName: keyName });
            }
        }
        allTotal += series.total;

        if (i < 9) res.chartData.push(series);
        else {
            others.total += series.total;
            others.data.push(series);
        }
    });

    if (allTotal === 0) res.nodata = true;
    else {
        if (others.total > 0) {
            let othersItems = [];
            let momentIds = [];
            let othersData = {};
            let total = 0;

            others.data.forEach((o) => {
                othersItems.push({ name: o.name, total: o.total });
                momentIds.push(o.momentId);
                o.data.forEach((d) => {
                    total += d.y;
                    if (!othersData[d.x]) {
                        othersData[d.x] = { x: d.x, y: d.y, seriesName: "Others" };
                    } else {
                        othersData[d.x].y += d.y;
                    }
                });
            });
            res.chartData.push({
                name: "Others",
                color: intToRGB(hashCode("Others")),
                momentIds,
                data: Object.values(othersData),
                total,
                othersItems,
            });
        }
    }

    // res.chartObjectData.viewMore.push(viewMoreseries);

    if (x.length === 0) res.nodata = true;

    return res;
};

export const formatTimeSeriesMentionsDaywise = (data) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let xs = new Set();
    data.forEach((tpc) => {
        tpc.data.forEach((subtpc) => {
            subtpc.data &&
                subtpc.data.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
                    xs.add(moment(bucket.key).valueOf());
                });
        });
    }, this);
    xs = Array.from(xs).sort();
    let topics = [];
    data.forEach((tpc) => {
        let topic = {
            id: tpc.input.topic_id,
            name: tpc.input.name,
            values: new Array(xs.length).fill(0),
            subtopicIds: tpc.input.subtopicIds,
            allSubtopicSelected: tpc.input.subtopicIds.length === topicsObject[tpc.input.topic_id].subtopicsIds.length,
            total: tpc.uniqueData.hits.total,
        };

        tpc.uniqueData.aggregations.volume_of_conversation.buckets.forEach((bucket) => {
            let timeIndex = xs.indexOf(moment(bucket.key).valueOf());
            topic.values[timeIndex] = bucket.doc_count;
        });
        topics.push(topic);
    }, this);

    topics.sort((a, b) => b.total - a.total);

    return {
        name: "all",
        xs,
        res: topics,
    };
};

export const getGeneralTrendsParams = (data) => {
    let start_date, end_date;
    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.duration === "custom") {
        start_date = moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss");
        end_date = moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "24HRS") {
        end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        start_date = moment(new Date())
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastmonth") {
        start_date = moment(new Date()).subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm:ss");
        end_date = moment(new Date()).startOf("month").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastquarter") {
        start_date = moment(new Date()).startOf("quarter").subtract(1, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "last2quarter") {
        start_date = moment(new Date()).startOf("quarter").subtract(2, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else {
        end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        start_date = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(data.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
    }

    if (data.duration === "custom" && data.rollingDate) {
        end_date = moment(new Date()).format("YYYY-MM-DDTHH:mm:59");
    }

    let params = new URLSearchParams();

    var from_param = start_date;
    var to_param = end_date;

    if (data["aggs-interval"]) params.append(`aggs-interval`, data["aggs-interval"]);
    // else params.append(`aggs-interval`, handleIntervalOnFilterChange(data));
    let platforms = data.platforms || "";
    params.append(`platformId`, platforms);
    let countries = data.countries || "";
    params.append(`countryId`, countries);
    params.append(`access-token`, getAccessToken());
    params.append("from", from_param);
    params.append("to", to_param);
    if (data.refineOptions.exclusion) params.append("apply_exclusion", data.refineOptions.exclusion);

    // Apply Exclusions
    if (data.extras) {
        data.extras.forEach((param) => {
            Object.keys(param).forEach((key) => {
                if (key === "apply_exclusion") params += `&apply_exclusion=${param[key]}`;
            });
        });
    }

    return params;
};

const handleIntervalOnFilterChange = (filter) => {
    if (
        filter.duration === "1" ||
        filter.duration === "24HRS" ||
        (filter.duration === "custom" && moment(filter.end_date).diff(filter.start_date, "days") <= 1)
    ) {
        return "hour";
    } else {
        return "day";
    }
};

export const formatLeaderboardAndHealthBooleanData = (args) => {
    const filters = store.getState().dashboardReducer.filters;
    let { res, xs, elem, groupByTopics, params } = args;
    let data = [];
    data.mentions = new Array(xs.length).fill(0);
    let reach_sum = 0;
    let mentions_sum = 0;
    let engagement_sum = 0;
    if (!groupByTopics) {
        let sub = res.forEach((item) => {
            item.subtopics.forEach((subtopic) => {
                let obj = {
                    nodata: false,
                };
                obj.total_reach = subtopic.aggregations["estimated-reach-stats"].sum ? subtopic.aggregations["estimated-reach-stats"].sum : 0;
                obj.avg_reach = subtopic.aggregations["estimated-reach-stats"].avg;
                obj.total_engagement =
                    subtopic.aggregations["comment-count-stats"].sum +
                    subtopic.aggregations["share-count-stats"].sum +
                    subtopic.aggregations["like-count-stats"].sum +
                    subtopic.aggregations["view-count-stats"].sum;
                obj.avg_engagement =
                    subtopic.aggregations["comment-count-stats"].avg +
                    subtopic.aggregations["share-count-stats"].avg +
                    subtopic.aggregations["like-count-stats"].avg +
                    subtopic.aggregations["view-count-stats"].avg;
                obj.like_count = subtopic.aggregations["like-count-stats"].sum;
                obj.share_count = subtopic.aggregations["share-count-stats"].sum;
                obj.view_count = subtopic.aggregations["view-count-stats"].sum;
                obj.comment_count = subtopic.aggregations["comment-count-stats"].sum;
                obj.avg_impact_score = subtopic.aggregations["impact-stats"].avg;
                obj.id = subtopic.subtopic_id;
                obj.name = subtopic.subtopic_name;
                obj.topic_name = item.topic_name;
                obj.total_mentions = 0;
                obj.mentionsChartData = [];
                let tz = JSON.parse(localStorage.company).user_timezone_name;
                subtopic.aggregations.volume_of_conversation.buckets.forEach((d, i) => {
                    let xsIndex = xs.findIndex((x) => x === d.key);
                    data.mentions[xsIndex] = d.doc_count;
                    obj.total_mentions += d.doc_count;
                    let date = d.key;
                    if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                    if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                    obj.mentionsChartData.push({
                        x: date,
                        y: d.doc_count,
                        boolean: subtopic.subtopic_id,
                    });
                });
                obj.avg_mentions = obj.total_mentions / xs.length;
                if (obj.total_reach == 0 || obj.total_mentions == 0 || obj.total_engagement == 0) {
                    obj.nodata = true;
                }
                reach_sum += obj.total_reach;
                mentions_sum += obj.total_mentions;
                engagement_sum += obj.total_engagement;
                data.push(obj);
            });
        });
    } else {
        let sub = res.forEach((item) => {
            let obj = {
                nodata: false,
            };
            obj.total_reach = item.aggregations["estimated-reach-stats"].sum ? item.aggregations["estimated-reach-stats"].sum : 0;
            obj.avg_reach = item.aggregations["estimated-reach-stats"].avg;
            obj.total_engagement =
                item.aggregations["comment-count-stats"].sum +
                item.aggregations["share-count-stats"].sum +
                item.aggregations["like-count-stats"].sum +
                item.aggregations["view-count-stats"].sum;
            obj.avg_engagement =
                item.aggregations["comment-count-stats"].avg +
                item.aggregations["share-count-stats"].avg +
                item.aggregations["like-count-stats"].avg +
                item.aggregations["view-count-stats"].avg;
            obj.like_count = item.aggregations["like-count-stats"].sum;
            obj.share_count = item.aggregations["share-count-stats"].sum;
            obj.view_count = item.aggregations["view-count-stats"].sum;
            obj.comment_count = item.aggregations["comment-count-stats"].sum;
            obj.avg_impact_score = item.aggregations["impact-stats"].avg;
            obj.id = item.subtopic_id;
            obj.name = item.subtopic_name;
            obj.topic_name = item.topic_name;
            obj.total_mentions = 0;
            obj.mentionsChartData = [];
            let tz = JSON.parse(localStorage.company).user_timezone_name;
            item.aggregations.volume_of_conversation.buckets.forEach((d, i) => {
                let xsIndex = xs.findIndex((x) => x === d.key);
                data.mentions[xsIndex] = d.doc_count;
                obj.total_mentions += d.doc_count;
                let date = d.key;
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                obj.mentionsChartData.push({
                    x: date,
                    y: d.doc_count,
                    boolean: item.topic_id,
                });
            });
            obj.avg_mentions = obj.total_mentions / xs.length;
            if (obj.total_reach == 0 || obj.total_mentions == 0 || obj.total_engagement == 0) {
                obj.nodata = true;
            }
            reach_sum += obj.total_reach;
            mentions_sum += obj.total_mentions;
            engagement_sum += obj.total_engagement;
            data.push(obj);
        });
    }
    return { reach_sum, mentions_sum, engagement_sum, data, groupByTopics };
};

export const leaderboardAndHealthDataHelper = (filter) => {
    let filterDuration = filter["duration"];
    let xs = [];
    var tz = JSON.parse(localStorage.company).user_timezone_name;
    if (filterDuration != "custom") {
        if (filterDuration === "1") {
            let currentHr = moment().tz(tz).hour();
            let startOf = moment().tz(tz).startOf("day").unix() * 1000;
            xs.push(startOf);
            for (let i = 1; i <= currentHr; i++) {
                xs.push(startOf + i * 60 * 60 * 1000);
            }
        } else {
            let startOf = moment().tz(tz).startOf("day").unix() * 1000;
            filterDuration = parseInt(filterDuration);
            for (let i = filterDuration - 1; i >= 1; i--) {
                xs.push(startOf - i * 24 * 60 * 60 * 1000);
            }
            xs.push(startOf);
        }
    } else {
        let startDate = moment(filter["start_date"]).tz(tz);
        let endDate = moment(filter["end_date"]).tz(tz);
        let diff = endDate.diff(startDate, "hours");
        if (diff > 24) {
            let daysDiff = endDate.diff(startDate, "days");
            let startOf = endDate.startOf("day").unix() * 1000;
            for (var i = daysDiff; i >= 1; i--) {
                xs.push(startOf - i * 24 * 60 * 60 * 1000);
            }
            xs.push(startOf);
        } else {
            let startOf = endDate.startOf("hour").unix() * 1000;
            for (let i = 1; i <= diff; i++) {
                xs.push(startOf - i * 60 * 60 * 1000);
            }
            xs.push(startOf);
        }
    }
    return xs;
};

const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const scenesNameFormating = (label) => {
    if (label.indexOf("_") > -1) {
        label = label.replaceAll("_", " ");
    }
    if (label.indexOf("/") > -1) {
        label = label
            .split("/")
            .map((l) => toTitleCase(l))
            .join("/");
    } else label = toTitleCase(label);

    return label;
};

export const getCorrectedDate = (params, date) => {
    const isHourly = formatIsHourly(params);
    let diff = "hour";
    if (!isHourly) diff = "day";

    diff = moment(params.start_date).diff(moment(params.start_date).startOf(diff), "minutes");

    date = +moment(date).add(diff, "minutes").format("x");

    return date;
};

const formatIsHourly = (params) => {
    return params["aggs-interval"] ? params["aggs-interval"] === "hour" : moment(params.end_date).diff(params.start_date, "days", true) <= 1 ? true : false;
};

export const formatEmotionAnalyticsShareOfVoiceData = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        total: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let stacked = {
        data: [],
    };
    let hasLineData = dt[0] && dt[0].subtopics && dt[0].subtopics[0] && dt[0].subtopics[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;

    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataPie: [],
            chartDataBar: [],

            othersBar: [],
            maximizeBar: [],
            StackedBarData: [],
            maximizeStackedBarData: [],

            csvData: [],
        };

        let stackedTopic = {
            chartDatastacked: [],
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            csvData: [],
        };

        topic.chartDataLine = [];

        let pieData = [];
        let barData = [];
        let lineData = [];
        let stackedData = [];
        let t = 0;

        tpc.aggregations.channel_analysis.buckets.forEach((subtpc) => {
            t += subtpc.doc_count;

            sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);

            let name = toTitleCase(subtpc.key);
            let pie = {
                y: subtpc.doc_count,
                name,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                color: intToRGB(hashCode(subtpc.key)),
                subtopicId: sub[0].subtopicIds,
                allSubtopicSelected: false,
            };

            let bar = {
                data: [
                    {
                        name,
                        y: subtpc.doc_count,
                        categoryName: subtpc.key,
                        topicId: tpc.topic_id,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected: false,
                    },
                ],
                name: name,
                value: subtpc.doc_count,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode(subtpc.key)),
                allSubtopicSelected: false,
            };

            let line;

            line = {
                data: [],
                name,
                value: subtpc.doc_count,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode(subtpc.key)),
                allSubtopicSelected: false,
            };

            subtpc.channel_analysis.buckets.map((b) => {
                let date = b.key;

                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

                line.data.push({
                    x: date,
                    y: b.doc_count,
                    categoryName: subtpc.key,
                    topicId: tpc.topic_id,
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected: false,
                });
            });

            pieData.push(pie);
            barData.push(bar);
            stackedData.push(bar);
            if (line) {
                lineData.push(line);
                topic.csvData.push(line);
            } else {
                topic.csvData.push(bar);
                stackedTopic.csvData.push(bar);
            }

            let subTopic = topicsObject[tpc.topic_id].subtopics;

            if (subTopic.length === sub[0].subtopicIds.length) {
                pie.allSubtopicSelected = true;
                bar.allSubtopicSelected = true;
                bar.data[0].allSubtopicSelected = true;
                line.allSubtopicSelected = true;
                line.data.forEach((ele) => {
                    ele.allSubtopicSelected = true;
                });

                allSubtopicSelected = true;
            }
        });
        ret.total += t;
        topic.value = t;
        stackedTopic.value = t;
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);

        stackedTopic.chartDatastacked = barData;

        if (pieData.length < 10) {
            topic.chartDataPie = pieData;
            topic.chartDataBar = barData;
            topic.chartDataLine = lineData;
        } else {
            topic.chartDataPie = pieData.slice(0, 9);
            topic.chartDataBar = barData.slice(0, 9);

            lineData.sort((a, b) => b.value - a.value);
            topic.chartDataLine = lineData.slice(0, 9);

            topic.maximizeBar.push(barData.slice(9));

            let total = 0;

            let topics = [];
            let subtopics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;

                subtopics.push(pieData[i].subtopicId[0]);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                // if (hasLineData) {
                lineData[i].data.map((d) => {
                    if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                    else othersLineData[d.x] = d.y;
                });
                // }
            }

            let subTopic = topicsObject[tpc.topic_id].subtopics;

            topic.chartDataPie.push({
                y: total,
                name: "Others",
                topicId: pieData[0].topicId,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
                allSubtopicSelected,
            });

            topic.othersBar.push({
                data: [
                    {
                        name: "Others",
                        y: total,
                        items,
                        topicId: pieData[0].topicId,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected,
                    },
                ],
                name: "Others",
                value: total,
                topicId: pieData[0].topicId,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });

            // if (hasLineData) {
            let x = [];
            Object.keys(othersLineData).map((k) =>
                x.push({
                    name: "Others",
                    x: Number(k),
                    y: othersLineData[k],
                    topicId: lineData[0].topicId,
                    items,
                    subtopicId: sub[0].subtopicIds,
                    allSubtopicSelected,
                }),
            );
            topic.chartDataLine.push({
                data: x,
                name: "Others",
                topicId: lineData[0].topicId,
                value: total,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode("Others")),
                optionType: "others",
                items,
            });
            //  }
        }
        ret.data.push(topic);
        stacked.data.push(stackedTopic);
    });

    // Stacked Chart Formation

    let total = 0;
    let staticData = [];
    let maximizeBar = [];
    let downloadStaticData = [];
    let respData = stacked.data.sort((a, b) => b.value - a.value);

    let othersTopicCount = 0;
    respData.forEach((topic, tpc_index) => {
        {
            if (tpc_index < 50) {
                maximizeBar.push({
                    name: topic.name,
                    y: 0,
                    topicId: [],
                    subtopicId: [],
                    topic_total: topic.value,
                });
            }
            if (tpc_index < 9) {
                staticData.push({
                    name: topic.name,
                    y: 0,
                    topicId: [],
                    subtopicId: [],
                    topic_total: topic.value,
                });
            } else {
                othersTopicCount += topic.value;
            }
        }
        downloadStaticData.push({ name: topic.name, y: 0 });
    });
    if (respData.length > 9) {
        staticData.push({
            name: "Others",
            y: 0,
            topicId: [],
            subtopicId: [],
            platformId: [],
            topic_total: othersTopicCount,
        });
    }

    let platformInfo = [];
    let maximiseInfo = [];
    respData[0].chartDatastacked.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["name"] = key.name;
        allPlatformsOutput["color"] = intToRGB(hashCode(key.name.toLowerCase()));
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(staticData));
        allPlatformsOutput["download_data"] = JSON.parse(JSON.stringify(downloadStaticData));
        platformInfo.push(allPlatformsOutput);
    });

    respData[0].chartDatastacked.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["name"] = key.name;
        allPlatformsOutput["color"] = intToRGB(hashCode(key.name.toLowerCase()));
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(maximizeBar));
        maximiseInfo.push(allPlatformsOutput);
    });

    // 9+1  Stacked chart

    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topicId);

        topic?.chartDatastacked?.forEach((bucket, b_index) => {
            let p_id = bucket.name;
            total += bucket.value;
            let othersEmotions = [];

            let index_p = platformInfo.findIndex((ele) => ele.name === p_id);
            if (index_p !== -1) {
                if (tpc_index < 9) {
                    platformInfo[index_p].data[tpc_index].y = bucket.value;
                    platformInfo[index_p].data[tpc_index]["emotions"] = bucket.name;
                    if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[tpc_index].topicId.push(topic.topicId);
                    } else {
                        platformInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                    }
                    platformInfo[index_p].count += bucket.value;
                    count += bucket.value;
                } else {
                    othersEmotions.push(p_id);
                    platformInfo[index_p].data[9].y += bucket.value;
                    if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[9].topicId.push(topic.topicId);
                    } else {
                        platformInfo[index_p].data[9].subtopicId.push(subTopic[0]?.subtopicIds);
                    }
                }
                if (platformInfo[index_p].data[9]) platformInfo[index_p].data[9]["emotions"] = othersEmotions;
                platformInfo[index_p].download_data[tpc_index].y = bucket.value;
            }
        });
    });

    // Maximise Stacked chart
    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topicId);

        topic?.chartDatastacked?.forEach((bucket, b_index) => {
            let p_id = bucket.name;
            total += bucket.value;
            let index_p = maximiseInfo.findIndex((ele) => ele.name === p_id);
            if (index_p !== -1 && maximiseInfo[index_p].data[tpc_index]) {
                // if (tpc_index < 9) {
                maximiseInfo[index_p].data[tpc_index].y = bucket.value;
                maximiseInfo[index_p].data[tpc_index]["emotions"] = bucket.name;
                if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                    maximiseInfo[index_p].data[tpc_index].topicId.push(topic.topicId);
                } else {
                    maximiseInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                }

                //   platformInfo[index_p].data[tpc_index].platformId.push(platformInfo[index_p].platform_id);
                maximiseInfo[index_p].count += bucket.value;
                count += bucket.value;
            }
            // }
        });
    });

    let filteredData = platformInfo.filter((ele) => ele.count > 0);
    let filteredMaximiseData = maximiseInfo.filter((ele) => ele.count > 0);

    if (total === 0 || ret.data.length === 0) {
        ret.nodata = true;
    } else {
        ret.StackedBarData = filteredData;
        //ret.total = total;
        ret.maximizeStackedBarData = filteredMaximiseData;
    }

    // if (ret.total === 0 || ret.data.length === 0) ret.nodata = true;
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatTopicWiseStackedEmotionsBreakdown = (dt, params) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let ret = {
        data: [],
        nodata: false,
        BarData: [],
        total: 0,
        csvData: [],
        others: [],
        maximizeBar: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    let total = 0;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;
    let sub;
    let allSubtopicSelected = false;
    dt.forEach((tpc) => {
        let topic = {
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            value: 0,
            chartDataBar: [],
            othersBar: [],
            maximizeBar: [],
            csvData: [],
        };

        let barData = [];
        let t = 0;

        tpc.aggregations.channel_analysis.buckets.forEach((subtpc) => {
            t += subtpc.doc_count;
            sub = params.topic_data.filter((ele) => ele.topic_id === tpc.topic_id);
            let name = toTitleCase(subtpc.key);

            let bar = {
                data: [
                    {
                        name,
                        y: subtpc.doc_count,
                        categoryName: subtpc.key,
                        topicId: tpc.topic_id,
                        subtopicId: sub[0].subtopicIds,
                        allSubtopicSelected: false,
                    },
                ],
                name: name,
                value: subtpc.doc_count,
                topicId: tpc.topic_id,
                categoryName: subtpc.key,
                subtopicId: sub[0].subtopicIds,
                color: intToRGB(hashCode(subtpc.key)),
                allSubtopicSelected: false,
            };

            barData.push(bar);
            topic.csvData.push(bar);

            let subTopic = topicsObject[tpc.topic_id].subtopics;

            if (subTopic.length === sub[0].subtopicIds.length) {
                bar.allSubtopicSelected = true;
                bar.data[0].allSubtopicSelected = true;
                allSubtopicSelected = true;
            }
        });

        ret.total += t;
        topic.value = t;

        barData.sort((a, b) => b.value - a.value);

        topic.chartDataBar = barData;

        ret.data.push(topic);
    });

    let staticData = [];
    let maximizeBar = [];
    let downloadStaticData = [];
    let respData = ret.data.sort((a, b) => b.value - a.value);

    let othersTopicCount = 0;
    respData.forEach((topic, tpc_index) => {
        {
            if (topic.value != 0) {
                maximizeBar.push({
                    name: topic.name,
                    y: 0,
                    topicId: [],
                    subtopicId: [],
                    topic_total: topic.value,
                });
            }
            if (tpc_index < 9) {
                staticData.push({
                    name: topic.name,
                    y: 0,
                    topicId: [],
                    subtopicId: [],
                    topic_total: topic.value,
                });
            } else {
                othersTopicCount += topic.value;
            }
        }
        downloadStaticData.push({ name: topic.name, y: 0 });
    });
    if (respData.length > 9) {
        staticData.push({
            name: "Others",
            y: 0,
            topicId: [],
            subtopicId: [],
            platformId: [],
            topic_total: othersTopicCount,
        });
    }

    let platformInfo = [];
    let maximiseInfo = [];
    respData[0].chartDataBar.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["name"] = key.name;
        allPlatformsOutput["color"] = intToRGB(hashCode(key.name));
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(staticData));
        allPlatformsOutput["download_data"] = JSON.parse(JSON.stringify(downloadStaticData));
        platformInfo.push(allPlatformsOutput);
    });

    respData[0].chartDataBar.forEach((key) => {
        let allPlatformsOutput = {};
        allPlatformsOutput["name"] = key.name;
        allPlatformsOutput["color"] = intToRGB(hashCode(key.name));
        allPlatformsOutput["count"] = 0;
        allPlatformsOutput["data"] = JSON.parse(JSON.stringify(maximizeBar));
        maximiseInfo.push(allPlatformsOutput);
    });

    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topicId);

        topic?.chartDataBar?.forEach((bucket, b_index) => {
            let p_id = bucket.name;
            total += bucket.value;
            let othersEmotions = [];

            let index_p = platformInfo.findIndex((ele) => ele.name === p_id);
            if (index_p !== -1) {
                if (tpc_index < 9) {
                    platformInfo[index_p].data[tpc_index].y = bucket.value;
                    platformInfo[index_p].data[tpc_index]["emotions"] = bucket.name;
                    if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[tpc_index].topicId.push(topic.topicId);
                    } else {
                        platformInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                    }

                    //   platformInfo[index_p].data[tpc_index].platformId.push(platformInfo[index_p].platform_id);
                    platformInfo[index_p].count += bucket.value;
                    count += bucket.value;
                } else {
                    othersEmotions.push(p_id);
                    platformInfo[index_p].data[9].y += bucket.value;
                    if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                        platformInfo[index_p].data[9].topicId.push(topic.topicId);
                    } else {
                        platformInfo[index_p].data[9].subtopicId.push(subTopic[0]?.subtopicIds);
                    }
                }
                if (platformInfo[index_p].data[9]) platformInfo[index_p].data[9]["emotions"] = othersEmotions;
                platformInfo[index_p].download_data[tpc_index].y = bucket.value;
            }
        });
    });

    respData.forEach((topic, tpc_index) => {
        let count = 0;
        let subTopic = params.topic_data.filter((ele) => ele.topic_id === topic.topicId);

        topic?.chartDataBar?.forEach((bucket, b_index) => {
            let p_id = bucket.name;
            total += bucket.value;
            let index_p = maximiseInfo.findIndex((ele) => ele.name === p_id);
            if (index_p !== -1) {
                // if (tpc_index < 9) {
                maximiseInfo[index_p].data[tpc_index].y = bucket.value;
                maximiseInfo[index_p].data[tpc_index]["emotions"] = bucket.name;
                if (topicsObject[topic.topicId].subtopicsIds.length === subTopic[0].subtopicIds.length) {
                    maximiseInfo[index_p].data[tpc_index].topicId.push(topic.topicId);
                } else {
                    maximiseInfo[index_p].data[tpc_index].subtopicId.push(subTopic[0]?.subtopicIds);
                }

                //   platformInfo[index_p].data[tpc_index].platformId.push(platformInfo[index_p].platform_id);
                maximiseInfo[index_p].count += bucket.value;
                count += bucket.value;
            }
            // }
        });
    });

    let filteredData = platformInfo.filter((ele) => ele.count > 0);
    let filteredMaximiseData = maximiseInfo.filter((ele) => ele.count > 0);

    if (total === 0) {
        ret.nodata = true;
    } else {
        ret.BarData = filteredData;
        ret.total = total;
        ret.maximizeBar = filteredMaximiseData;
    }

    return ret;
};
export const truncate = (str, max = 80) => {
    const ellipsis = str.length > max ? "..." : "";
    return str.slice(0, max) + ellipsis;
};

export const formatDashboardEngagementOverTime = (data, params) => {
    let res = {};
    let chartData = {
        Comments: [],
        Likes: [],
        Shares: [],
        Views: [],
        total: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let nodata = false;
    let totalData = 0;
    res.xs = [];
    let Comments = new Array(data.length).fill(0);
    let Likes = new Array(data.length).fill(0);
    let Shares = new Array(data.length).fill(0);
    let Views = new Array(data.length).fill(0);
    let total = new Array(data.length).fill(0);

    res.data = { Comments, Likes, Shares, Views, total };

    data.aggregations?.reactions_datewise_breakdown.buckets.forEach((bucket, ind) => {
        res.xs.push(bucket.key);
        // bucket["sentiments.sentiment_group"].group1.group2.buckets.forEach((sent) => {
        //     if (["positive", "negative", "neutral"].indexOf(sent.key) > -1) res.data[sent.key][ind] = sent.doc_count;
        // });

        // let bucket = bucket;
        res.data["Comments"][ind] = bucket.comment_count.value;
        res.data["Likes"][ind] = bucket.like_count.value;
        res.data["Shares"][ind] = bucket.share_count.value;
        res.data["Views"][ind] = bucket.view_count.value;

        res.data["total"][ind] = bucket.comment_count.value + bucket.like_count.value + bucket.share_count.value + bucket.view_count.value;
        totalData += bucket.comment_count.value + bucket.like_count.value + bucket.share_count.value + bucket.view_count.value;
    });

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (totalData > 0) {
        Object.keys(res.data).forEach((x) => {
            res.data[x].forEach((d, i) => {
                let date = res.xs[i];
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                date = chartData[x].push({
                    x: date,
                    y: d,
                    sentiment: x,
                });
            });
        });
    } else nodata = true;
    chartData.date.start_date = params.start_date;
    chartData.date.end_date = params.end_date;

    return { nodata, chartData };
};

export const formatTopicEngagementOverTime = (dt, params, topicsObjectparams) => {
    const topicsObject = topicsObjectparams ? topicsObjectparams : store.getState().filterSettingReducer.topicsObject;
    let topic_data = params.topic_data;

    let hasLineData = dt[0] && dt[0].aggregations;
    let tz;
    tz = JSON.parse(localStorage.company).user_timezone_name;

    let ret = {
        chartDataBar: [],
        chartDataPie: [],
        othersBar: [],
        maximizeBar: [],
        nodata: false,
        total: 0,
        uniqueData: 0,
        csvData: [],
        date: {
            start_date: "",
            end_date: "",
        },
    };

    ret.chartDataLine = [];

    let pieData = [];
    let barData = [];
    let lineData = [];

    dt.forEach((tpc, i) => {
        let tpc_data = topic_data.find((t) => t.topic_id === tpc.topic_id);
        let totalEngagement = 0;
        let line;

        line = {
            data: [],
            name: tpc.topic_name,

            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            color: topicsObject[tpc.topic_id].color,
            allSubtopicSelected: false,
        };

        JSON.parse(JSON.stringify(tpc)).aggregations.engagement_datewise_breakdown_with_exclusion.buckets.map((b) => {
            let date = b.key;
            if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
            if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);

            let count = 0;

            let commentValue = b.comment_count?.value ? b.comment_count.value : 0;
            let likevalue = b.like_count?.value ? b.like_count.value : 0;
            let shareValue = b.share_count?.value ? b.share_count.value : 0;
            let viewValue = b.view_count?.value ? b.view_count.value : 0;

            count = commentValue + likevalue + shareValue + viewValue;

            line.data.push({
                x: date,
                y: count,
            });

            totalEngagement += count;
            ret.total += count;
        });

        line.value = totalEngagement;

        let pie = {
            y: totalEngagement,
            name: tpc.topic_name,
            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            color: topicsObject[tpc.topic_id].color,
            allSubtopicSelected: false,
        };

        let bar = {
            data: [{ name: tpc.topic_name, y: totalEngagement }],
            // data: tpc.total,
            name: tpc.topic_name,
            value: totalEngagement,
            topicId: tpc.topic_id,
            subtopicIds: tpc_data.subtopicIds,
            color: topicsObject[tpc.topic_id].color,
            allSubtopicSelected: false,
        };

        let sub = topicsObject[tpc.topic_id].subtopics;
        if (sub.length === tpc_data.subtopicIds.length) {
            pie.allSubtopicSelected = true;
            bar.allSubtopicSelected = true;
            if (line) line.allSubtopicSelected = true;
        }

        pieData.push(pie);
        barData.push(bar);
        if (line) {
            lineData.push(line);
            ret.csvData.push(line);
        } else ret.csvData.push(bar);
    });

    if (ret.total === 0) ret.nodata = true;
    else {
        pieData.sort((a, b) => b.y - a.y);
        barData.sort((a, b) => b.value - a.value);
        ret.maximizeBar = barData.slice(9);
        if (pieData.length < 10) {
            ret.chartDataPie = pieData;
            ret.chartDataBar = barData;

            if (hasLineData) ret.chartDataLine = lineData;
        } else {
            ret.chartDataPie = pieData.slice(0, 9);
            ret.chartDataBar = barData.slice(0, 9);
            if (hasLineData) {
                lineData.sort((a, b) => b.value - a.value);
                ret.chartDataLine = lineData.slice(0, 9);
            }

            let total = 0;
            let subtopics = [];
            let topics = [];
            let items = [];
            let othersLineData = {};

            for (let i = 9; i < pieData.length; i++) {
                total += pieData[i].y;
                if (pieData[i].allSubtopicSelected) topics.push(pieData[i].topicId);
                else subtopics.push(...pieData[i].subtopicIds);
                items.push({ name: pieData[i].name, value: pieData[i].y });
                if (hasLineData) {
                    lineData[i].data.map((d) => {
                        if (othersLineData[d.x]) othersLineData[d.x] += d.y;
                        else othersLineData[d.x] = d.y;
                    });
                }
            }

            ret.chartDataPie.push({
                y: total,
                name: "Others",
                topicIds: topics,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });

            ret.othersBar.push({
                data: [{ name: "Others", y: total }],
                name: "Others",
                topicIds: topics,
                subtopicIds: subtopics,
                color: intToRGB(hashCode("Others")),
                allSubtopicSelected: "others",
                items,
            });

            if (hasLineData) {
                let x = [];
                Object.keys(othersLineData).map((k) => x.push({ x: Number(k), y: othersLineData[k] }));
                ret.chartDataLine.push({
                    data: x,
                    name: "Others",
                    topicIds: topics,
                    value: total,
                    subtopicIds: subtopics,
                    color: intToRGB(hashCode("Others")),
                    allSubtopicSelected: "others",
                    items,
                });
            }
        }
    }
    ret.date.start_date = params.start_date;
    ret.date.end_date = params.end_date;

    return ret;
};

export const formatAdvanceChartData = (data, advanceChart, params) => {
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    const advanceChartState = store.getState().advCustomChartReducer;
    const showAdvanceEditor = store.getState().dashboardReducer.showAdvanceEditor;
    const masterFilterData = store.getState().filterSettingReducer;
    const isChecked = store.getState().dashboardReducer.viewCountCheckboxes;
    const viewCountCheckbox = isChecked?.[advanceChart?.widgetId] || false;
    const post_types_names = {
        0: "Only Post",
        1: "Comment/ Replies",
        2: "Retweet",
        3: "LexisNexis Online Post",
        4: "LexisNexis Offline Post",
        5: "Quoted Retweet",
    };

    let dimensionName, breakdownDimensionName, metricName, breakdownMetricName, isTopicSubTopicDimension;

    if (showAdvanceEditor) {
        // dimensionName = ["topics_data", "sub_topics_data"].includes(advanceChartState.multiDimensionChartConfig.dimensionName)
        //     ? advanceChartState.multiDimensionChartConfig.breakdownDimensionName || advanceChartState.multiDimensionChartConfig.dimensionName
        //     : advanceChartState.multiDimensionChartConfig.dimensionName;
        dimensionName = advanceChartState.multiDimensionChartConfig.dimensionName.label || advanceChartState.multiDimensionChartConfig.dimensionName;
        breakdownDimensionName =
            advanceChartState.multiDimensionChartConfig.breakdownDimensionName.label || advanceChartState.multiDimensionChartConfig.breakdownDimensionName;
        metricName = advanceChartState.multiDimensionChartConfig.metricName.label || advanceChartState.multiDimensionChartConfig.metricName;
        breakdownMetricName =
            advanceChartState.multiDimensionChartConfig.breakdownMetricName.label || advanceChartState.multiDimensionChartConfig.breakdownMetricName;
        isTopicSubTopicDimension = ["topics_data", "sub_topics_data"].includes(
            advanceChartState.multiDimensionChartConfig.dimensionName.label || advanceChartState.multiDimensionChartConfig.dimensionName,
        )
            ? advanceChartState.multiDimensionChartConfig.dimensionName.label || advanceChartState.multiDimensionChartConfig.dimensionName
            : false;
    } else {
        // dimensionName = ["topics_data", "sub_topics_data"].includes(advanceChart.breakdown_dimension_name)
        //     ? advanceChart.breakdown_dimension_name || advanceChart.dimension_name
        //     : advanceChart.dimension_name;
        dimensionName = advanceChart.isTopicsSubTopicsDimensionPresent ? advanceChart.isTopicsSubTopicsDimensionPresent : advanceChart.dimension_name;
        breakdownDimensionName = advanceChart.isTopicsSubTopicsDimensionPresent ? advanceChart.dimension_name : advanceChart.breakdown_dimension_name;
        metricName = advanceChart.metric_name;
        breakdownMetricName = advanceChart.breakdown_metric_name;
        isTopicSubTopicDimension = advanceChart.isTopicsSubTopicsDimensionPresent ? advanceChart.isTopicsSubTopicsDimensionPresent : false;
    }

    //2-dimensions : 2-metric && 1-dimensions : 2-metric

    if (breakdownMetricName) {
        if (["topics_data", "sub_topics_data"].includes(dimensionName)) {
            let updatedData = [];
            let res = data?.statusCode || data?.status ? data?.data : data;
            updatedData.push(res);
            let newAdvanceChart = JSON.parse(JSON.stringify(advanceChart));
            newAdvanceChart.dimension_name = dimensionName;
            newAdvanceChart.breakdown_dimension_name = breakdownDimensionName;
            updatedData.push(newAdvanceChart);
            res[0] && res[0].meta && res[0].meta.child_tags_data && updatedData.push(res[0].meta.child_tags_data);
            return updatedData;
        }

        let updatedData = [];
        let responseData = data.aggregations ? data.aggregations[dimensionName] : data.data.aggregations[dimensionName];
        let momentsMeta = data.aggregations ? data.meta?.child_tags_data : data.data.meta?.child_tags_data;
        // let responseData = data.data.aggregations[dimensionName];

        if (dimensionName === "sentiments") {
            updatedData.push(responseData.group1.group2.buckets);
        } else {
            updatedData.push(responseData.buckets);
        }
        updatedData.push(advanceChart);
        updatedData.push(momentsMeta);
        updatedData.push(params);
        updatedData.push(tz);

        return updatedData;
    }

    //2-dimensions : 1-metric
    if (breakdownDimensionName) {
        if (["topics_data", "sub_topics_data"].includes(dimensionName) || isTopicSubTopicDimension) {
            let ret = {
                data: [],
                nodata: false,
                csvData: {
                    data: [],
                    master_dimension: [],
                },
            };
            let totalDataCount = 0;
            let responseData = data?.statusCode || data?.status ? data?.data : data;
            // let dimension1 = responseData.buckets;

            console.log("AdvanceRetIn2d1mTopic 1111", responseData);
            const transformed_dimension2 = format2D1MTopicsSubtopicsData({
                responseData,
                breakdownDimensionName,
                dimensionName,
                metricName,
                masterFilterData,
                totalDataCount,
                viewCountCheckbox,
                post_types_names,
            });

            ret.data.push(...transformed_dimension2);
            ret.csvData.data.push(...transformed_dimension2);

            // //this won't work need to change logic for subtopics....
            // //if data is 0, value is not pushed,,needs to fix this issue
            // let topNineData = [];
            // let othersData = [];
            // let topicResp = JSON.parse(JSON.stringify(responseData));
            // //this won't work need to change logic for subtopics....
            // //if data is 0, value is not pushed,,needs to fix this issue
            // let topNineData = [];
            // let othersData = [];
            // let topicResp = JSON.parse(JSON.stringify(responseData));

            // if (dimensionName === "topics_data") {
            //     topNineData = JSON.parse(JSON.stringify(responseData.slice(0, 9)));
            //     othersData = JSON.parse(JSON.stringify(responseData.slice(9)));
            // } else {
            //     topicResp.forEach((obj) => {
            //         if (obj.subtopics?.length > 9) {
            //             let topNineObj = { ...obj, subtopics: obj.subtopics.slice(0, 9) };
            //             let othersObj = { ...obj, subtopics: obj.subtopics.slice(9) };
            //             topNineData.push(topNineObj);
            //             othersData.push(othersObj);
            //         } else {
            //             topNineData.push(obj);
            //         }
            //     });
            // }

            // if (dimensionName === "topics_data") {
            //     topNineData = JSON.parse(JSON.stringify(responseData.slice(0, 9)));
            //     othersData = JSON.parse(JSON.stringify(responseData.slice(9)));
            // } else {
            //     topicResp.forEach((obj) => {
            //         if (obj.subtopics?.length > 9) {
            //             let topNineObj = { ...obj, subtopics: obj.subtopics.slice(0, 9) };
            //             let othersObj = { ...obj, subtopics: obj.subtopics.slice(9) };
            //             topNineData.push(topNineObj);
            //             othersData.push(othersObj);
            //         } else {
            //             topNineData.push(obj);
            //         }
            //     });
            // }

            // if (totalDataCount === 0 || ret.data?.length === 0) ret.nodata = true;

            return ret;
        }

        let ret = {
            data: [],
            lineData: [],
            nodata: false,
            // minimizedData: [],
            csvData: {
                data: [],
                lineData: [],
                master_dimension: [],
            },
        };
        let totalDataCount = 0;
        let responseData = data.aggregations ? data.aggregations[dimensionName] : data.data.aggregations[dimensionName];
        let momentsMeta = data.aggregations ? data.meta?.child_tags_data : data.data.meta?.child_tags_data;

        const allowedKeys = ["male", "female", "person", "non-person", "brand", "news"];
        if (dimensionName === "entity_sub_type" || dimensionName === "entity_types") {
            responseData.buckets = responseData.buckets?.filter((obj) => {
                return allowedKeys.includes(obj.key);
            });
        }

        let dimension1 = responseData.buckets;

        const {
            updatedData: transformed_dimension2,
            allDimension1,
            lineData,
        } = format2D1MData({
            responseData,
            dimension1,
            breakdownDimensionName,
            dimensionName,
            masterFilterData,
            metricName,
            post_types_names,
            viewCountCheckbox,
            momentsMeta,
            params,
            // totalDataCount,
        });

        ret.data.push(...transformed_dimension2);
        ret.csvData.data.push(...transformed_dimension2);
        ret.csvData.master_dimension.push(...allDimension1);
        ret.lineData.push(lineData);
        ret.csvData.lineData.push(lineData);

        if (ret.data?.length === 0) ret.nodata = true;

        return ret;
    }
    //1-dimensions : 1-metric
    else {
        if (isTopicSubTopicDimension || ["topics_data", "sub_topics_data"].includes(dimensionName)) {
            let ret = format1D1MTopicsSubTopicsData({
                data,
                dimensionName,
                metricName,
                viewCountCheckbox,
            });

            return ret;
        }
        let ret = {
            data: [],
            lineData: [],
            nodata: false,
            maximizeData: [],

            csvData: [],
        };
        let idData;

        if (dimensionName === "platforms") {
            idData = masterFilterData.masterPlatforms;
        } else if (dimensionName === "countries") {
            idData = masterFilterData.masterLocations;
        } else if (dimensionName === "languages") {
            idData = masterFilterData.masterLanguages;
        }

        let updatedData = [];
        let responseData = data.aggregations ? data.aggregations[dimensionName].buckets : data.data.aggregations[dimensionName].buckets;
        let momentsMeta = data.aggregations ? data.meta?.child_tags_data : data.data.meta?.child_tags_data;

        let barData = [];
        let totalDataCount = 0;
        if (dimensionName === "sentiments") {
            {
                data.aggregations
                    ? (responseData = data.aggregations[dimensionName].group1.group2.buckets)
                    : (responseData = data.data.aggregations[dimensionName].group1.group2.buckets);
            }
        }
        const allowedKeys = ["male", "female", "person", "non-person", "brand", "news"];
        if (dimensionName === "entity_sub_type" || dimensionName === "entity_types") {
            // responseData = responseData.filter((obj) => obj.key !== "unknown"||"");
            responseData = responseData?.filter((obj) => {
                return allowedKeys.includes(obj.key);
            });
        }

        responseData.forEach((subtpc) => {
            let name, id, color;
            switch (dimensionName) {
                case "published_date":
                    name = moment(subtpc.key_as_string).format("YYYY-MM-DD"); //tz(tz)
                    break;
                case "post_types":
                    name = post_types_names[subtpc.key];
                    break;

                case "sentiments":
                    name = toTitleCase(subtpc.key);
                    break;
                case "entity_sub_type":
                    name = toTitleCase(subtpc.key || "");
                    break;

                case "entity_types":
                    name = toTitleCase(subtpc.key || "");
                    break;

                case "product_attributes": {
                    let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subtpc.key);
                    name = ProductAttributesName[0]?.attributeName || subtpc.key;
                    break;
                }
                case "moments":
                    id = subtpc.key;
                    name = momentsMeta.find((elem) => elem.id === subtpc.key)?.name || subtpc.key;
                    break;
                case "top_influencers":
                    name = subtpc.user_latest_post?.hits.hits[0]._source.post_author.name;
                    break;
                default:
                    name = subtpc.key;
            }
            let count_value = 0;
            if (dimensionName !== "sentiments") {
                if (metricName === "mention") {
                    count_value = subtpc.doc_count;
                } else if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        count_value = subtpc.comment_count.sum + subtpc.like_count.sum + subtpc.share_count.sum;
                    } else {
                        count_value = subtpc.view_count.sum + subtpc.comment_count.sum + subtpc.like_count.sum + subtpc.share_count.sum;
                    }
                } else if (metricName === "unique_user") {
                    count_value = subtpc[metricName].value;
                } else if (metricName === "sentiment") {
                    count_value = parseFloat(advancedNetSentimentMetric(subtpc.sentiments.group1.group2.buckets).toFixed(2));
                    // subtpc.sentiments.group1.group2.buckets.forEach((ele) => {
                    //     count_value += ele.doc_count;
                    // });
                } else {
                    count_value = subtpc[metricName].sum;
                }
            } else {
                if (metricName === "mention") {
                    count_value = subtpc.doc_count;
                } else if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        count_value = subtpc[metricName].comment_count.sum + subtpc[metricName].like_count.sum + subtpc[metricName].share_count.sum;
                    } else {
                        count_value =
                            subtpc[metricName].view_count.sum +
                            subtpc[metricName].comment_count.sum +
                            subtpc[metricName].like_count.sum +
                            subtpc[metricName].share_count.sum;
                    }
                } else if (metricName === "unique_user") {
                    count_value = subtpc[metricName][metricName].value;
                } else if (metricName === "sentiment") {
                    count_value = parseFloat(advancedNetSentimentMetric(subtpc[metricName].sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    count_value = subtpc[metricName][metricName].sum;
                }
            }

            if (idData) {
                let reqObject = idData.find((obj) => obj.name === name);

                id = reqObject?.id;
            } else if (dimensionName === "published_date") {
                if (moment(params.start_date).isAfter(moment(subtpc.key).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) id = getCorrectedDate(params, subtpc.key);
                else id = subtpc.key;
            } else {
                id = subtpc.key;
            }
            console.log("xyz", params);

            switch (dimensionName) {
                case "sentiments":
                    color = getSentimentColor(name.toLowerCase());
                    break;

                case "platforms":
                    color = getPlatformColorCode(name);
                    break;

                case "entity_sub_type":
                    color = getEntityColor(name.toLowerCase());
                    break;
                case "published_date":
                    color = intToRGB(hashCode(subtpc.key_as_string));
                    break;

                default:
                    color = intToRGB(hashCode(name));
            }

            let metricsVal = metricsNameObj[metricName] || metricName;
            let dimensionVal = dimensionNameObj[dimensionName] || dimensionName;

            let bar = {
                data: [{ name, y: count_value, dataId: id, dimensionName, metricName, yAxisName: metricsVal }],
                name: name,
                value: count_value,
                dataId: id,
                metricName: metricsVal,
                color: color,
                dimensionName: dimensionVal,
            };

            totalDataCount += count_value;

            let csv = {
                name: name,
                value: count_value,
                y: count_value,
            };

            ret.csvData.push(csv);
            //   ret.data.push(bar);
            barData.push(bar);
        });

        ret.data.sort((a, b) => b.value - a.value);
        updatedData.push(barData);

        ret.maximizeData = barData;
        if (dimensionName !== "published_date") {
            barData.sort((a, b) => b.value - a.value);
        }

        let initialData = barData.slice(0, 9);
        let OthersData = barData.slice(9);

        let yValueData = 0;
        let dataIds = [];
        let metricsVal = metricsNameObj[metricName] || metricName;
        OthersData.forEach((o) => {
            yValueData += o.value;
            dataIds.push(o.dataId);
        });

        if (metricName === "sentiment") yValueData = +yValueData.toFixed(2);
        if (barData.length > 9) {
            initialData.push({
                data: [{ name: "Others", y: yValueData, dataId: dataIds, dimensionName: dimensionName, metricName: metricName, yAxisName: metricsVal }],
                dataId: dataIds,
                name: "Others",
                metricName: metricName,

                color: intToRGB(hashCode("Others")),
                // othersItems: others,
            });
        }

        if (totalDataCount === 0) ret.nodata = true;
        if (updatedData) ret.nodata = false;
        // if (ret.data?.length === 0 || totalDataCount === 0) ret.nodata = true;
        // ret.data.sort((a, b) => b.value - a.value);
        ret.data = initialData;
        if (dimensionName !== "published_date") {
            ret.data.sort((a, b) => b.value - a.value);
            ret.maximizeData.sort((a, b) => b.value - a.value);
        }
        if (dimensionName == "published_date") {
            let result = format1D1MLineChartData(responseData, dimensionName, metricName, viewCountCheckbox, params);

            ret.lineData = result;
        }

        return ret;
    }
    // return data;
};

export const format1D1MTopicsSubTopicsData = ({ data, dimensionName, metricName, viewCountCheckbox }) => {
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
                subtopic_topic_name: ele.topic_name,
            };
        });
    }

    let ret = {
        data: [],
        nodata: false,
        csvData: [],
    };
    let barData = [];
    let updatedData = [];
    let totalDataCount = 0;
    let idData;

    let responseData = data?.statusCode || data?.status ? data?.data : data;

    responseData.forEach((subtpc) => {
        let name, color;
        // let dimension= dimensionName==="topics_data"? "topic_name":""

        if (dimensionName === "topics_data") {
            let count_value = 0;
            idData = subtpc.topic_id;

            name = subtpc.topic_name;
            if (metricName === "enagagment_value") {
                if (viewCountCheckbox) {
                    count_value = subtpc.aggregations.comment_count.sum + subtpc.aggregations.like_count.sum + subtpc.aggregations.share_count.sum;
                } else {
                    count_value =
                        subtpc.aggregations.view_count.sum +
                        subtpc.aggregations.comment_count.sum +
                        subtpc.aggregations.like_count.sum +
                        subtpc.aggregations.share_count.sum;
                }
            } else if (metricName === "mention") {
                count_value = subtpc.total;
            } else if (metricName === "unique_user") {
                count_value = subtpc.aggregations[metricName].value;
            } else if (metricName === "sentiment") {
                count_value = parseFloat(advancedNetSentimentMetric(subtpc.aggregations.sentiments.group1.group2.buckets).toFixed(2));
                // subtpc.aggregations.sentiments.group1.group2.buckets.forEach((ele) => {
                //     count_value += ele.doc_count;
                // });
            } else {
                count_value = subtpc.aggregations[metricName].sum;
            }
            let dimensionVal = dimensionNameObj[dimensionName] || dimensionName;
            let metricsVal = metricsNameObj[metricName] || metricName;

            color = topicsObject[subtpc.topic_id].color;

            let bar = {
                data: [{ name, y: count_value, dataId: idData, dimensionName }],
                name: name,
                value: count_value,
                // id: id,
                yAxisName: metricsVal,
                // color: color,
                dataId: idData,
                dimensionName: dimensionVal,
                metricName: metricsVal,
                color: color,
            };
            totalDataCount += count_value;
            let csv = {
                name: name,
                value: count_value,
                y: count_value,
            };

            ret.csvData.push(csv);
            ret.data.push(bar);
            barData.push(bar);
        } else {
            subtpc?.subtopics?.forEach((subArr) => {
                let count_value = 0;
                name = subArr.subtopic_name + "(" + `${subtopicObject[subArr.subtopic_id].subtopic_topic_name}` + ")";
                idData = subArr.subtopic_id;

                color = subtopicObject[subArr.subtopic_id].subtopic_color || "#FF0000";

                if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        count_value = subArr.aggregations.comment_count.sum + subArr.aggregations.like_count.sum + subArr.aggregations.share_count.sum;
                    } else {
                        count_value =
                            subArr.aggregations.view_count.sum +
                            subArr.aggregations.comment_count.sum +
                            subArr.aggregations.like_count.sum +
                            subArr.aggregations.share_count.sum;
                    }
                } else if (metricName === "mention") {
                    count_value = subArr.total;
                } else if (metricName === "unique_user") {
                    count_value = subArr.aggregations[metricName].value;
                } else if (metricName === "sentiment") {
                    count_value = parseFloat(advancedNetSentimentMetric(subArr.aggregations.sentiments.group1.group2.buckets).toFixed(2));

                    // subArr.aggregations.sentiments.group1.group2.buckets.forEach((ele) => {
                    //     count_value += ele.doc_count;
                    // });
                } else {
                    count_value = subArr.aggregations[metricName].sum;
                }
                let metricsVal = metricsNameObj[metricName] || metricName;
                let dimensionVal = dimensionNameObj[dimensionName] || dimensionName;

                let bar = {
                    data: [{ name, y: count_value, dataId: idData, dimensionName, yAxisName: metricsVal }],
                    name: name,
                    value: count_value,
                    dataId: idData,
                    metricName: metricsVal,
                    dimensionName: dimensionVal,
                    color: color,
                };
                totalDataCount += count_value;
                let csv = {
                    name: name,
                    value: count_value,
                    y: count_value,
                };
                totalDataCount += count_value;

                ret.csvData.push(csv);
                ret.data.push(bar);
                // ret.data.sort((a, b) => b.value - a.value);
                barData.push(bar);
            });
        }
    });
    updatedData.push(barData);

    if (ret.data?.length === 0 || totalDataCount === 0) ret.nodata = true;

    ret.maximizeData = JSON.parse(JSON.stringify(barData));
    barData?.sort((a, b) => b.value - a.value);
    ret.data?.sort((a, b) => b.value - a.value);
    ret.maximizeData?.sort((a, b) => b.value - a.value);

    let initialData = barData.slice(0, 9);
    let OthersData = barData.slice(9);

    let yValueData = 0;
    let dataIds = [];
    let metricsVal = OthersData[0]?.metricName;
    OthersData.forEach((o) => {
        yValueData += o.value;
        dataIds.push(o.dataId);
    });

    if (metricName === "sentiment") yValueData = +yValueData.toFixed(2);
    if (barData.length > 9) {
        initialData.push({
            data: [{ name: "Others", y: yValueData, dataId: dataIds, dimensionName: dimensionName, metricName: metricName, yAxisName: metricsVal }],
            dataId: dataIds,
            name: "Others",
            metricName: metricName,

            color: intToRGB(hashCode("Others")),
            // othersItems: others,
        });
    }
    ret.data = initialData;
    ret.data?.sort((a, b) => b.value - a.value);

    return ret;
};
export const format2D1MData = ({
    responseData,
    dimension1,
    breakdownDimensionName,
    dimensionName,
    masterFilterData,
    metricName,
    totalDataCount,
    post_types_names,
    viewCountCheckbox,
    momentsMeta,
    params,
}) => {
    console.log(
        "firstmetric",
        responseData,
        dimension1,
        breakdownDimensionName,
        dimensionName,
        masterFilterData,
        metricName,
        totalDataCount,
        post_types_names,
        viewCountCheckbox,
        momentsMeta,
        params,
    );
    let unsorted_dimension2 = [];

    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];
    let idData, idData_dimension;
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    if (breakdownDimensionName === "platforms") {
        idData = masterFilterData.masterPlatforms;
    } else if (breakdownDimensionName === "countries") {
        idData = masterFilterData.masterLocations;
    } else if (breakdownDimensionName === "languages") {
        idData = masterFilterData.masterLanguages;
    }

    if (dimensionName === "platforms") {
        idData_dimension = masterFilterData.masterPlatforms;
    } else if (dimensionName === "countries") {
        idData_dimension = masterFilterData.masterLocations;
    } else if (dimensionName === "languages") {
        idData_dimension = masterFilterData.masterLanguages;
    }

    if (dimensionName === "sentiments") {
        dimension1 = responseData.group1.group2.buckets;
    }

    dimension1.forEach((ele, g) => {
        dimension2_data[g] =
            breakdownDimensionName == "sentiments"
                ? ele[breakdownDimensionName].group1.group2.buckets
                : dimensionName === "sentiments"
                ? ele[breakdownDimensionName][breakdownDimensionName].buckets
                : ele[breakdownDimensionName].buckets;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);

    master_dimension2.forEach((item, i) => {
        if (item.user_latest_post?.hits?.hits[0]?._source?.post_author) {
            key_dimension2[i] = {
                key: item.key,
                post_author: item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    ? item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    : item.key,
            };
        } else {
            key_dimension2[i] = item.key;
        }
    });

    if (typeof key_dimension2[0] === "object") {
        unique_dimension2 = key_dimension2.filter((item, index, array) => {
            return array.findIndex((obj) => obj.key === item.key) === index;
        });
    } else {
        unique_dimension2 = [...new Set(key_dimension2)];
    }
    console.log("lofi_unique", unique_dimension2);

    const allDimension1 = dimension1.map((item) => item.key);
    dimension1.forEach((dim1, dim1_ind) => {
        unique_dimension2.forEach((ele) => {
            let temporaryBreakdown;
            let mainPlatformValue;
            let influencerId;

            switch (dimensionName) {
                case "published_date":
                    // main_platform = dim1.key_as_string;
                    mainPlatformValue = moment(dim1.key_as_string).format("YYYY-MM-DD");

                    break;
                case "post_types":
                    mainPlatformValue = post_types_names[dim1.key];

                    break;

                case "entity_sub_type":
                    mainPlatformValue = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();

                    break;

                case "entity_types":
                    mainPlatformValue = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();

                    break;

                case "product_attributes": {
                    let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                    mainPlatformValue = ProductAttributesName[0]?.attributeName || dim1.key;

                    break;
                }

                case "moments":
                    mainPlatformValue = momentsMeta.find((elem) => elem.id === dim1.key)?.name;
                    break;
                case "top_influencers":
                    mainPlatformValue = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                        ? dim1.user_latest_post.hits.hits[0]?._source?.post_author?.name
                        : dim1.key;
                    break;

                default:
                    mainPlatformValue = toTitleCase(dim1.key);
            }
            switch (breakdownDimensionName) {
                case "published_date":
                    // main_breakdown_dimension = subDim.key_as_string;
                    temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                    break;
                case "post_types":
                    temporaryBreakdown = post_types_names[ele];

                    break;

                case "entity_sub_type":
                    temporaryBreakdown = toTitleCase(ele);

                    break;

                case "entity_types":
                    temporaryBreakdown = toTitleCase(ele);

                    break;

                case "moments":
                    temporaryBreakdown = momentsMeta.find((elem) => elem.id === ele)?.name || ele;

                    break;

                case "product_attributes": {
                    let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                    temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                    break;
                }
                case "sentiments": {
                    temporaryBreakdown = toTitleCase(ele);
                    break;
                }

                case "top_influencers":
                    temporaryBreakdown = ele.post_author;
                    influencerId = ele.key;

                    break;

                default:
                    temporaryBreakdown = ele;
            }

            unsorted_dimension2.push({
                main_platform: mainPlatformValue,
                dimension_id: dim1.key,
                breakdown_dimension_id: influencerId ? influencerId : ele,
                main_breakdown_dimension: temporaryBreakdown,
                breakdown_count: 0,
            });
        });

        if (breakdownDimensionName === "sentiments") {
            dim1[breakdownDimensionName].group1.group2.buckets.forEach((subDim, subDim_ind) => {
                let main_platform;
                let dimensionId, breakdownId;
                let main_breakdown_dimension;

                switch (dimensionName) {
                    case "published_date":
                        // main_platform = dim1.key_as_string;
                        main_platform = moment(dim1.key_as_string).format("YYYY-MM-DD");
                        dimensionId = dim1.key;

                        break;
                    case "post_types":
                        main_platform = post_types_names[dim1.key];
                        dimensionId = dim1.key;
                        break;

                    // case "sentiments":
                    case "entity_types":
                        main_platform = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "entity_sub_type":
                        main_platform = toTitleCase(dim1.key);
                        dimensionId = dim1.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                        main_platform = ProductAttributesName[0]?.attributeName || dim1.key;
                        dimensionId = dim1.key;
                        break;
                    }

                    case "moments":
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        main_platform = momentsMeta.find((elem) => elem.id === dimensionId)?.name || dimensionId;

                        break;

                    case "top_influencers":
                        main_platform = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : dim1.key;
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;
                    default:
                        main_platform = toTitleCase(dim1.key);

                        dimensionId = dim1.key;
                }

                main_breakdown_dimension = toTitleCase(subDim.key);
                breakdownId = subDim.key;

                let breakdown_count;
                if (metricName === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        breakdown_count = subDim[metricName].comment_count.sum + subDim[metricName].like_count.sum + subDim[metricName].share_count.sum;
                    } else {
                        breakdown_count =
                            subDim[metricName].view_count.sum +
                            subDim[metricName].comment_count.sum +
                            subDim[metricName].like_count.sum +
                            subDim[metricName].share_count.sum;
                    }
                } else if (metricName === "unique_user") {
                    breakdown_count = subDim[metricName][metricName].value;
                } else if (metricName === "sentiment") {
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[metricName][metricName].sum;
                }
                unsorted_dimension2.forEach((ele) => {
                    // console.log("Insider", ele.breakdown_dimension_id, breakdownId, ele.dimension_id, dimensionId);
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        } else if (dimensionName === "sentiments") {
            dim1[breakdownDimensionName][breakdownDimensionName].buckets.forEach((subDim, subDim_ind) => {
                console.log("first1235566", subDim, dim1);
                let main_platform;
                let main_breakdown_dimension;
                let dimensionId, breakdownId;
                let publishBreakId;
                main_platform = toTitleCase(dim1.key);
                dimensionId = JSON.parse(JSON.stringify(dim1.key));

                switch (breakdownDimensionName) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        publishBreakId = subDim.key_as_string;
                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownId = subDim.key;
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;
                    }

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                }

                let breakdown_count;
                if (metricName === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    } else {
                        breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    }
                } else if (metricName === "unique_user") {
                    breakdown_count = subDim[metricName].value;
                } else if (metricName === "sentiment") {
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[metricName].sum;
                }

                // unsorted_dimension2.push({
                //     main_platform: main_platform,
                //     dimension_id: dimensionId,
                //     breakdown_dimension_id: breakdownId,
                //     main_breakdown_dimension: main_breakdown_dimension,
                //     breakdown_count: breakdown_count,
                // });

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownId;
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        } else {
            dim1[breakdownDimensionName].buckets.forEach((subDim, subDim_ind) => {
                console.log("first1235566", subDim, dim1);
                let main_platform;
                let main_breakdown_dimension;
                let dimensionId, breakdownId;
                let publishBreakId;
                switch (dimensionName) {
                    case "published_date":
                        // main_platform = dim1.key_as_string;
                        main_platform = moment(dim1.key_as_string).format("YYYY-MM-DD");
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));

                        break;
                    case "post_types":
                        main_platform = post_types_names[dim1.key];
                        dimensionId = dim1.key;
                        break;

                    case "entity_sub_type":
                        main_platform = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();

                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;

                    case "entity_types":
                        main_platform = dim1.key.charAt(0).toUpperCase() + dim1.key.substr(1).toLowerCase();
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === dim1.key);
                        main_platform = ProductAttributesName[0]?.attributeName || dim1.key;
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;
                    }

                    case "moments":
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        main_platform = momentsMeta.find((elem) => elem.id === dimensionId)?.name || dimensionId;
                        break;

                    case "top_influencers":
                        main_platform = dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? dim1.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : dim1.key;
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                        break;

                    default:
                        main_platform = toTitleCase(dim1.key);
                        dimensionId = JSON.parse(JSON.stringify(dim1.key));
                }

                switch (breakdownDimensionName) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownId = subDim.key; //tz(tz)
                        publishBreakId = subDim.key_as_string;
                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownId = subDim.key;
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;
                    }

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                }

                let breakdown_count;
                if (metricName === "mention") {
                    breakdown_count = subDim.doc_count;
                } else if (metricName === "enagagment_value") {
                    if (viewCountCheckbox) {
                        breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    } else {
                        breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                    }
                } else if (metricName === "unique_user") {
                    breakdown_count = subDim[metricName].value;
                } else if (metricName === "sentiment") {
                    // breakdown_count = advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets);
                    breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                } else {
                    breakdown_count = subDim[metricName].sum;
                }
                console.log("firstpush", dimensionId, breakdownId, subDim, dim1);

                // unsorted_dimension2.push({
                //     main_platform: main_platform,
                //     dimension_id: dimensionId,
                //     breakdown_dimension_id: breakdownId,
                //     main_breakdown_dimension: main_breakdown_dimension,
                //     breakdown_count: breakdown_count,
                // });

                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownId;
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        }
    });

    const transformed_dimension2 = [];

    unsorted_dimension2.sort((a, b) => b.breakdown_count - a.breakdown_count);
    // unsorted_dimension2.slice(0,9)
    // if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types") {
    //     unsorted_dimension2 = unsorted_dimension2.filter((obj) => obj.main_breakdown_dimension !== "Unknown"||"");
    // }

    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news"]; //Unknown
    console.log("unsorted_dimension2 2134323", JSON.parse(JSON.stringify(unsorted_dimension2)));
    if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types")
        unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
            // return allowedValues.includes(obj.main_breakdown_dimension)}
            if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
            return false;
        });

    unsorted_dimension2.forEach((topic, index) => {
        const existingTopic = transformed_dimension2.find((item) => item.main_breakdown_dimension === topic.main_breakdown_dimension);
        let color, id1, id2;
        if (idData) {
            let reqObject = idData.find((obj) => obj.name === topic.main_breakdown_dimension);
            id1 = reqObject?.id;
        } else if (breakdownDimensionName === "post_types") {
            id1 = topic.breakdown_dimension_id;
        } else {
            id1 = topic.breakdown_dimension_id;
        }

        if (idData_dimension) {
            let reqObject = idData_dimension.find((obj) => obj.name === topic.main_platform);
            id2 = reqObject?.id;
        } else if (dimensionName === "post_types") {
            id2 = topic.dimension_id;
        } else if (dimensionName === "published_date") {
            if (moment(params.start_date).isAfter(moment(topic.dimension_id).tz(tz).format("YYYY-MM-DDTHH:mm:ss")))
                id2 = getCorrectedDate(params, topic.dimension_id);
            else id2 = topic.dimension_id;
        } else {
            id2 = topic.dimension_id;
        }
        // if (dimensionName === "moments") {
        //     let momentId = JSON.parse(JSON.stringify(topic.main_platform));
        //     topic.main_platform = momentsMeta.find((elem) => elem.id === momentId)?.name || momentId;
        //     id2 = momentId;
        // }
        // if (breakdownDimensionName === "moments") {
        //     let momentId = JSON.parse(JSON.stringify(topic.main_breakdown_dimension));
        //     topic.main_breakdown_dimension = momentsMeta.find((elem) => elem.id === momentId)?.name || momentId;
        //     id1 = momentId;
        // }
        console.log("breakdownDimensionNamebreakdownDimensionName", topic);

        switch (breakdownDimensionName) {
            case "sentiments":
                color = getSentimentColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "platforms":
                color = getPlatformColorCode(topic.main_breakdown_dimension);
                break;

            case "entity_sub_type":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "entity_types":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "published_date":
                color = intToRGB(hashCode(moment(topic.breakdown_dimension_id).format()));
                break;

            default:
                color = intToRGB(hashCode(topic.main_breakdown_dimension));
        }
        let yAxisValue = metricsNameObj[metricName] || metricName;
        // totalDataCount = 0;
        // totalDataCount += topic.breakdown_count;
        if (existingTopic) {
            existingTopic.data.push({
                name: topic.main_platform,
                y: topic.breakdown_count,
                dataId: id2,
                yAxisName: yAxisValue,
                dimensionName: dimensionName,
                color: color,
                breakdownDimensionName: breakdownDimensionName,
                breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                breakDownName: topic.main_breakdown_dimension,
            });
        } else {
            let yAxisLabel = metricsNameObj[metricName] || metricName;

            transformed_dimension2.push({
                main_breakdown_dimension: topic.main_breakdown_dimension,
                color: color,
                dataId: id1,
                yAxisName: yAxisLabel,
                // legendIndex:index+1,
                // totalDataCount: totalDataCount,
                data: [
                    {
                        name: topic.main_platform,
                        y: topic.breakdown_count,
                        dataId: id2,
                        yAxisName: yAxisValue,
                        dimensionName: dimensionName,
                        color: color,
                        breakdownDimensionName: breakdownDimensionName,
                        breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                        breakDownName: topic.main_breakdown_dimension,
                    },
                ],
            });
        }
    });

    transformed_dimension2.forEach((ele) => {
        ele.name = ele.main_breakdown_dimension;
        delete ele.main_breakdown_dimension;
    });
    console.log("transformedDimension", transformed_dimension2);

    let updatedData = [];
    updatedData = [...updatedData, transformed_dimension2];

    if (breakdownDimensionName == "published_date") {
        transformed_dimension2.sort((a, b) => {
            if (a.dataId > b.dataId) return 1;
            if (a.dataId < b.dataId) return -1;
        });
    }
    // updatedData = [...updatedData, transformed_dimension2];

    updatedData = transformed_dimension2.filter((item) => item.name !== "");
    console.log("lofi", updatedData);
    let lineData = [];
    if (dimensionName === "published_date") {
        let result = format2D1MLineChartData(
            responseData,
            dimension1,
            dimensionName,
            breakdownDimensionName,
            metricName,
            params,
            viewCountCheckbox,
            momentsMeta,
            ProductAttributes,
            idData,
            post_types_names,
        );
        lineData = result;
    }

    // console.log("Result&Params", result, params);

    return {
        updatedData,
        allDimension1,
        lineData,
    };
};

export const advancedNetSentimentMetric = (elements) => {
    let totalData = 0;
    let totalPositive = 0;
    let totalNegative = 0;

    elements.forEach((ele) => {
        if (ele.key == "positive") {
            totalPositive += ele.doc_count;
        } else if (ele.key == "negative") {
            totalNegative += ele.doc_count;
        }

        totalData += ele.doc_count;
    });
    let netSentimentPercentage = ((totalPositive - totalNegative) / totalData) * 100;
    if (elements.length == 0) {
        netSentimentPercentage = 0;
    }
    return netSentimentPercentage;
};

const format2D1MTopicsSubtopicsData = ({
    responseData,
    breakdownDimensionName,
    dimensionName,
    metricName,
    masterFilterData,
    totalDataCount,
    viewCountCheckbox,
    post_types_names,
}) => {
    let unsorted_dimension2 = [];
    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];
    let idData;
    if (breakdownDimensionName === "platforms") {
        idData = masterFilterData.masterPlatforms;
    } else if (breakdownDimensionName === "countries") {
        idData = masterFilterData.masterLocations;
    } else if (breakdownDimensionName === "languages") {
        idData = masterFilterData.masterLanguages;
    }
    const topicsObject = store.getState().filterSettingReducer.topicsObject;
    let subtopicObject = {};
    for (let key in topicsObject) {
        let topicSubtopic = topicsObject[key].subtopics;
        topicSubtopic.forEach((ele) => {
            subtopicObject[ele.subtopic_id] = {
                subtopic_name: ele.subtopic_name,
                subtopic_color: ele.subtopic_graph_color,
                subtopic_topic_name: ele.topic_name,
            };
        });
    }

    responseData.forEach((ele, g) => {
        dimension2_data[g] =
            dimensionName === "topics_data"
                ? breakdownDimensionName === "sentiments"
                    ? ele.aggregations.sentiments.group1.group2.buckets
                    : ele.aggregations[breakdownDimensionName].buckets
                : ele.subtopics;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);

    let temporary_block = [];
    if (dimensionName === "topics_data") {
        temporary_block = master_dimension2;
    } else {
        master_dimension2.forEach((ele, g) => {
            temporary_block[g] =
                breakdownDimensionName === "sentiments" ? ele.aggregations.sentiments.group1.group2.buckets : ele.aggregations[breakdownDimensionName].buckets;
        });

        temporary_block = temporary_block.flatMap((array) => array);
    }

    console.log("lofi", temporary_block);
    temporary_block.forEach((item, i) => {
        if (item.user_latest_post?.hits?.hits[0]?._source?.post_author) {
            key_dimension2[i] = {
                key: item.key,
                post_author: item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    ? item.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                    : item.key,
            };
        } else {
            key_dimension2[i] = item.key;
        }
    });
    console.log("lofi", key_dimension2);

    if (typeof key_dimension2[0] === "object") {
        unique_dimension2 = key_dimension2.filter((item, index, array) => {
            return array.findIndex((obj) => obj.key === item.key) === index;
        });
    } else {
        unique_dimension2 = [...new Set(key_dimension2)];
    }

    let momentsMetaTS = responseData[0]?.meta?.child_tags_data;
    if (dimensionName === "topics_data") {
        responseData.forEach((dim1) => {
            let arrayObject = dim1.aggregations?.[breakdownDimensionName]?.buckets;
            if (breakdownDimensionName === "sentiments") {
                arrayObject = dim1.aggregations?.[breakdownDimensionName]?.group1?.group2?.buckets;
            }
            unique_dimension2.forEach((ele) => {
                let temporaryBreakdown;
                let mainPlatformValue;
                mainPlatformValue = dim1.topic_name;
                let influencerId;
                switch (breakdownDimensionName) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                        break;
                    case "post_types":
                        temporaryBreakdown = post_types_names[ele];

                        break;

                    case "entity_sub_type":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "entity_types":
                        temporaryBreakdown = toTitleCase(ele);

                        break;

                    case "moments":
                        temporaryBreakdown = momentsMetaTS.find((elem) => elem.id === ele)?.name || ele;

                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                        temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                        break;
                    }
                    case "sentiments": {
                        temporaryBreakdown = toTitleCase(ele);
                        break;
                    }

                    case "top_influencers":
                        temporaryBreakdown = ele.post_author;
                        influencerId = ele.key;

                        break;

                    default:
                        temporaryBreakdown = ele;
                }

                unsorted_dimension2.push({
                    main_platform: mainPlatformValue,
                    dimension_id: dim1.topic_id,
                    breakdown_dimension_id: influencerId ? influencerId : ele,
                    main_breakdown_dimension: temporaryBreakdown,
                    breakdown_count: 0,
                });
            });

            arrayObject.forEach((subDim) => {
                let main_platform;
                let main_breakdown_dimension;
                let dimensionId, breakdownId;
                dimensionId = dim1.topic_id;
                main_platform = dim1.topic_name;
                let publishBreakId;

                switch (breakdownDimensionName) {
                    case "published_date":
                        // main_breakdown_dimension = subDim.key_as_string;
                        main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                        breakdownId = subDim.key;
                        publishBreakId = subDim.key_as_string;

                        break;
                    case "post_types":
                        main_breakdown_dimension = post_types_names[subDim.key];
                        breakdownId = subDim.key;
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                        breakdownId = subDim.key;
                        break;
                    }
                    case "sentiments":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(subDim.key);
                        breakdownId = subDim.key;
                        break;

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        main_breakdown_dimension = momentsMetaTS.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                        break;

                    case "top_influencers":
                        main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                            : subDim.key;
                        breakdownId = JSON.parse(JSON.stringify(subDim.key));
                        break;

                    default:
                        main_breakdown_dimension = subDim.key;
                        breakdownId = subDim.key;
                }
                let breakdown_count;

                if (breakdownDimensionName !== "sentiments") {
                    if (metricName === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (metricName === "enagagment_value") {
                        if (viewCountCheckbox) {
                            breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        } else {
                            breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                        }
                    } else if (metricName === "unique_user") {
                        breakdown_count = subDim[metricName]?.value;
                    } else if (metricName === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[metricName]?.sum;
                    }
                } else {
                    if (metricName === "mention") {
                        breakdown_count = subDim.doc_count;
                    } else if (metricName === "enagagment_value") {
                        if (viewCountCheckbox) {
                            breakdown_count = subDim[metricName].comment_count.sum + subDim[metricName].like_count.sum + subDim[metricName].share_count.sum;
                        } else {
                            breakdown_count =
                                subDim[metricName].view_count.sum +
                                subDim[metricName].comment_count.sum +
                                subDim[metricName].like_count.sum +
                                subDim[metricName].share_count.sum;
                        }
                    } else if (metricName === "unique_user") {
                        breakdown_count = subDim[metricName][metricName]?.value;
                    } else if (metricName === "sentiment") {
                        breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                    } else {
                        breakdown_count = subDim[metricName][metricName]?.sum;
                    }
                }
                const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news"]; //Unknown
                if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types")
                    unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
                        // return allowedValues.includes(obj.main_breakdown_dimension)}
                        if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
                        return false;
                    });
                // unsorted_dimension2.push({
                //     main_platform: main_platform,
                //     main_breakdown_dimension: main_breakdown_dimension,
                //     breakdown_count: breakdown_count,
                //     breakdown_dimension_id: breakdownId,
                //     dimension_id: dimensionId,
                // });
                unsorted_dimension2.forEach((ele) => {
                    if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                        ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownId;
                        ele.breakdown_count = breakdown_count;
                        ele.main_platform = main_platform;
                        ele.main_breakdown_dimension = main_breakdown_dimension;
                    }
                });
            });
        });
    } else {
        responseData.forEach((dim1) => {
            dim1?.subtopics?.forEach((subTopicsArr) => {
                let arrayObject = subTopicsArr?.aggregations?.[breakdownDimensionName]?.buckets;
                if (breakdownDimensionName === "sentiments") {
                    arrayObject = subTopicsArr?.aggregations?.[breakdownDimensionName]?.group1?.group2?.buckets;
                }

                unique_dimension2.forEach((ele) => {
                    let temporaryBreakdown;
                    let mainPlatformValue;
                    let influencerId;
                    mainPlatformValue = subTopicsArr.subtopic_name + "(" + `${subtopicObject[subTopicsArr.subtopic_id].subtopic_topic_name}` + ")";
                    switch (breakdownDimensionName) {
                        case "published_date":
                            // main_breakdown_dimension = subDim.key_as_string;
                            temporaryBreakdown = moment(ele).format("YYYY-MM-DD");

                            break;
                        case "post_types":
                            temporaryBreakdown = post_types_names[ele];

                            break;

                        case "entity_sub_type":
                            temporaryBreakdown = toTitleCase(ele);

                            break;

                        case "entity_types":
                            temporaryBreakdown = toTitleCase(ele);

                            break;

                        case "moments":
                            temporaryBreakdown = momentsMetaTS.find((elem) => elem.id === ele)?.name || ele;

                            break;

                        case "product_attributes": {
                            let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === ele);
                            temporaryBreakdown = ProductAttributesName[0]?.attributeName || ele;
                            break;
                        }
                        case "sentiments": {
                            temporaryBreakdown = toTitleCase(ele);
                            break;
                        }

                        case "top_influencers":
                            temporaryBreakdown = ele.post_author;
                            influencerId = ele.key;

                            break;

                        default:
                            temporaryBreakdown = ele;
                    }

                    unsorted_dimension2.push({
                        main_platform: mainPlatformValue,
                        dimension_id: subTopicsArr.subtopic_id,
                        breakdown_dimension_id: influencerId ? influencerId : ele,
                        main_breakdown_dimension: temporaryBreakdown,
                        breakdown_count: 0,
                    });
                });

                arrayObject.forEach((subDim) => {
                    let main_platform;
                    let main_breakdown_dimension;
                    let dimensionId, breakdownId;
                    main_platform = subTopicsArr.subtopic_name + "(" + `${subtopicObject[subTopicsArr.subtopic_id].subtopic_topic_name}` + ")";
                    dimensionId = subTopicsArr.subtopic_id;
                    let publishBreakId;

                    switch (breakdownDimensionName) {
                        case "published_date":
                            // main_breakdown_dimension = subDim.key_as_string;
                            main_breakdown_dimension = moment(subDim.key_as_string).format("YYYY-MM-DD");
                            breakdownId = subDim.key;
                            publishBreakId = subDim.key_as_string;

                            break;
                        case "post_types":
                            main_breakdown_dimension = post_types_names[subDim.key];
                            breakdownId = subDim.key;
                            break;

                        case "sentiments":
                            main_breakdown_dimension = toTitleCase(subDim.key);
                            breakdownId = subDim.key;
                            break;

                        case "entity_sub_type":
                            main_breakdown_dimension = toTitleCase(subDim.key);
                            breakdownId = subDim.key;
                            break;

                        case "entity_types":
                            main_breakdown_dimension = toTitleCase(subDim.key);
                            breakdownId = subDim.key;
                            break;
                        case "product_attributes": {
                            let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === subDim.key);
                            main_breakdown_dimension = ProductAttributesName[0]?.attributeName || subDim.key;
                            breakdownId = subDim.key;
                            break;
                        }

                        case "moments":
                            breakdownId = JSON.parse(JSON.stringify(subDim.key));
                            main_breakdown_dimension = momentsMetaTS.find((elem) => elem.id === breakdownId)?.name || breakdownId;
                            break;

                        case "top_influencers":
                            main_breakdown_dimension = subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                                ? subDim.user_latest_post?.hits.hits[0]?._source?.post_author?.name
                                : subDim.key;
                            breakdownId = JSON.parse(JSON.stringify(subDim.key));
                            break;

                        default:
                            main_breakdown_dimension = subDim.key;
                            breakdownId = subDim.key;
                    }

                    let breakdown_count;
                    if (breakdownDimensionName !== "sentiments") {
                        if (metricName === "mention") {
                            breakdown_count = subDim.doc_count;
                        } else if (metricName === "enagagment_value") {
                            if (viewCountCheckbox) {
                                breakdown_count = subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                            } else {
                                breakdown_count = subDim.view_count.sum + subDim.comment_count.sum + subDim.like_count.sum + subDim.share_count.sum;
                            }
                        } else if (metricName === "unique_user") {
                            breakdown_count = subDim[metricName]?.value;
                        } else if (metricName === "sentiment") {
                            breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            breakdown_count = subDim[metricName]?.sum;
                        }
                    } else {
                        if (metricName === "mention") {
                            breakdown_count = subDim.doc_count;
                        } else if (metricName === "enagagment_value") {
                            if (viewCountCheckbox) {
                                breakdown_count = subDim[metricName].comment_count.sum + subDim[metricName].like_count.sum + subDim[metricName].share_count.sum;
                            } else {
                                breakdown_count =
                                    subDim[metricName].view_count.sum +
                                    subDim[metricName].comment_count.sum +
                                    subDim[metricName].like_count.sum +
                                    subDim[metricName].share_count.sum;
                            }
                        } else if (metricName === "unique_user") {
                            breakdown_count = subDim[metricName][metricName]?.value;
                        } else if (metricName === "sentiment") {
                            breakdown_count = parseFloat(advancedNetSentimentMetric(subDim.sentiment.sentiments.group1.group2.buckets).toFixed(2));
                        } else {
                            breakdown_count = subDim[metricName][metricName]?.sum;
                        }
                    }

                    const allowedValues = [
                        "Person",
                        "Non-person",
                        "Male",
                        "Female",
                        "Brand",
                        "News",
                        "person",
                        "non-person",
                        "male",
                        "female",
                        "brand",
                        "news",
                    ]; //Unknown
                    if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types")
                        unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
                            // return allowedValues.includes(obj.main_breakdown_dimension)}
                            if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
                            return false;
                        });
                    // unsorted_dimension2.push({
                    //     main_platform: main_platform,
                    //     main_breakdown_dimension: main_breakdown_dimension,
                    //     breakdown_count: breakdown_count,
                    //     breakdown_dimension_id: breakdownId,
                    //     dimension_id: dimensionId,
                    // });

                    unsorted_dimension2.forEach((ele) => {
                        if (ele.breakdown_dimension_id == breakdownId && ele.dimension_id == dimensionId) {
                            ele.breakdown_dimension_id = publishBreakId ? publishBreakId : breakdownId;
                            ele.breakdown_count = breakdown_count;
                            ele.main_platform = main_platform;
                            ele.main_breakdown_dimension = main_breakdown_dimension;
                        }
                    });
                });
            });
        });
    }
    const transformed_dimension2 = [];
    let color;
    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news"]; //Unknown
    if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types")
        unsorted_dimension2 = unsorted_dimension2.filter((obj) => {
            // return allowedValues.includes(obj.main_breakdown_dimension)}
            if (allowedValues.includes(obj.main_breakdown_dimension)) return true;
            return false;
        });
    let yAxisValue = metricsNameObj[metricName] || metricName;
    unsorted_dimension2.forEach((topic) => {
        const existingTopic = transformed_dimension2.find((item) => item.main_breakdown_dimension === topic.main_breakdown_dimension);
        let id1, id2;
        if (idData) {
            let reqObject = idData.find((obj) => obj.name === topic.main_breakdown_dimension);
            id1 = reqObject?.id;
        } else if (breakdownDimensionName === "post_types") {
            id1 = topic.breakdown_dimension_id;
        } else {
            id1 = topic.breakdown_dimension_id;
        }

        id2 = topic.dimension_id;
        switch (breakdownDimensionName) {
            case "sentiments":
                color = getSentimentColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "platforms":
                color = getPlatformColorCode(topic.main_breakdown_dimension);
                break;

            case "entity_sub_type":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "entity_types":
                color = getEntityColor(topic.main_breakdown_dimension.toLowerCase());
                break;

            case "published_date":
                color = intToRGB(hashCode(moment(topic.breakdown_dimension_id).format()));
                break;

            case "moments":
                color = intToRGB(hashCode(topic.main_breakdown_dimension));
                break;

            default:
                color = intToRGB(hashCode(topic.main_breakdown_dimension));
        }

        if (existingTopic) {
            existingTopic.data.push({
                name: topic.main_platform,
                y: topic.breakdown_count,
                dimensionName: dimensionName,
                breakdownDimensionName: breakdownDimensionName,
                dataId: id2,
                color: color,
                yAxisName: yAxisValue,
                breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                breakDownName: topic.main_breakdown_dimension,
            });
            totalDataCount += topic.breakdown_count;
        } else {
            // if (idData) {
            //     let reqObject = idData.find((obj) => obj.name === topic.main_breakdown_dimension);
            //     id1 = reqObject.id;
            // }

            let yAxisLabel = metricsNameObj[metricName] || metricName;
            transformed_dimension2.push({
                main_breakdown_dimension: topic.main_breakdown_dimension,
                color: color,
                yAxisName: yAxisLabel,
                dataId: id1,
                data: [
                    {
                        name: topic.main_platform,
                        y: topic.breakdown_count,
                        dataId: id2,
                        dimensionName: dimensionName,
                        color: color,
                        breakdownDimensionName: breakdownDimensionName,
                        breakDownId: id1 ? id1 : topic.main_breakdown_dimension,
                        breakDownName: topic.main_breakdown_dimension,
                        yAxisName: yAxisValue,
                    },
                ],
            });
            totalDataCount += topic.breakdown_count;
        }
    });

    transformed_dimension2.forEach((ele) => {
        ele.name = ele.main_breakdown_dimension;
        delete ele.main_breakdown_dimension;
    });
    let updatedData = [];
    // updatedData = [...updatedData, transformed_dimension2];

    updatedData = transformed_dimension2.filter((item) => item.name !== "");
    console.log("updatedData", updatedData);
    // return {
    //     // transformed_dimension2,
    //     updatedData,
    // };
    return updatedData;
};

const format2D1MLineChartData = (
    responseData,
    dimension1,
    dimensionName,
    breakdownDimensionName,
    metricName,
    params,
    viewCountCheckbox,
    momentsMeta,
    ProductAttributes,
    idData,
    post_types_names,
) => {
    console.log("response", responseData, metricName);
    let res = {};
    res.nodata = false;

    let dimension2_data = [];
    let master_dimension2 = [];
    let key_dimension2 = [];
    let unique_dimension2 = [];
    let totalData = 0;

    dimension1.forEach((ele, g) => {
        dimension2_data[g] =
            breakdownDimensionName == "sentiments"
                ? ele[breakdownDimensionName].group1.group2.buckets
                : dimensionName === "sentiments"
                ? ele[breakdownDimensionName][breakdownDimensionName].buckets
                : ele[breakdownDimensionName].buckets;
    });

    master_dimension2 = dimension2_data.flatMap((array) => array);

    master_dimension2.forEach((item, i) => {
        key_dimension2[i] = item.key;
    });

    unique_dimension2 = [...new Set(key_dimension2)];
    console.log("response_unique", unique_dimension2);
    res.chartData = {
        date: {
            start_date: "",
            end_date: "",
        },
    };
    let arrays = {};
    unique_dimension2.forEach((ele) => {
        arrays[ele] = new Array(responseData.length).fill(0);
        res.chartData[ele] = [];
    });

    console.log("response_arrays", JSON.parse(JSON.stringify(arrays)), JSON.parse(JSON.stringify(res.chartData)));
    res.xs = [];
    res.data = arrays;

    responseData.buckets.forEach((ele, ind) => {
        res.xs.push(ele.key);
        let arrayObject = ele.sentiments?.group1?.group2?.buckets ? ele.sentiments?.group1?.group2?.buckets : ele[breakdownDimensionName].buckets;
        arrayObject.forEach((item) => {
            let breakdownCount;
            if (metricName === "mention") {
                breakdownCount = item.doc_count;
            } else if (metricName === "enagagment_value") {
                if (viewCountCheckbox) {
                    breakdownCount = item[metricName]
                        ? item[metricName].comment_count.sum + item[metricName].like_count.sum + item[metricName].share_count.sum
                        : item.comment_count.sum + item.like_count.sum + item.share_count.sum;
                } else {
                    breakdownCount = item[metricName]
                        ? item[metricName].view_count.sum +
                          item[metricName].comment_count.sum +
                          item[metricName].like_count.sum +
                          item[metricName].share_count.sum
                        : item.view_count.sum + item.comment_count.sum + item.like_count.sum + item.share_count.sum;
                }
            } else if (metricName === "unique_user") {
                breakdownCount = item[metricName][metricName] ? item[metricName][metricName].value : item[metricName].value;
            } else if (metricName === "sentiment") {
                breakdownCount = parseFloat(
                    advancedNetSentimentMetric(
                        item.sentiment ? item.sentiment.sentiments.group1.group2.buckets : item.sentiments.group1.group2.buckets,
                    ).toFixed(2),
                );
            } else {
                breakdownCount = item[metricName][metricName]?.sum ? item[metricName][metricName]?.sum : item[metricName]?.sum;
            }
            res.data[item.key][ind] = breakdownCount;
            totalData += breakdownCount;
        });
    });

    res.xs.forEach((data, ind) => {
        Object.keys(res.data).forEach((x) => {
            if (!res.data[x][ind]) {
                res.data[x][ind] = 0;
            }
        });
    });

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (totalData > 0) {
        Object.keys(res.data).forEach((x) => {
            res.data[x].forEach((d, i) => {
                let date = res.xs[i];
                if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
                if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
                console.log("result_loop", x, d, date);
                let breakdownId, main_breakdown_dimension, id1;
                switch (breakdownDimensionName) {
                    case "post_types":
                        main_breakdown_dimension = post_types_names[x];
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "entity_sub_type":
                        main_breakdown_dimension = toTitleCase(x);
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "entity_types":
                        main_breakdown_dimension = toTitleCase(x);
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;

                    case "moments":
                        breakdownId = JSON.parse(JSON.stringify(x));
                        main_breakdown_dimension = momentsMeta.find((elem) => elem.id == breakdownId).name;
                        break;
                    case "sentiments":
                        breakdownId = JSON.parse(JSON.stringify(x));
                        main_breakdown_dimension = toTitleCase(x);
                        break;

                    case "product_attributes": {
                        let ProductAttributesName = ProductAttributes.data.filter((obj) => obj.categoryName === x);
                        main_breakdown_dimension = ProductAttributesName[0]?.attributeName || x;
                        breakdownId = JSON.parse(JSON.stringify(x));
                        break;
                    }

                    default:
                        main_breakdown_dimension = x;
                        breakdownId = JSON.parse(JSON.stringify(x));
                }

                if (idData) {
                    let reqObject = idData.find((obj) => obj.name === main_breakdown_dimension);
                    id1 = reqObject?.id;
                } else {
                    id1 = breakdownId;
                }

                let color;
                switch (breakdownDimensionName) {
                    case "sentiments":
                        color = getSentimentColor(main_breakdown_dimension.toLowerCase());
                        break;

                    case "platforms":
                        color = getPlatformColorCode(main_breakdown_dimension);
                        break;

                    case "entity_sub_type":
                        color = getEntityColor(main_breakdown_dimension.toLowerCase());
                        break;

                    case "entity_types":
                        color = getEntityColor(main_breakdown_dimension.toLowerCase());
                        break;

                    default:
                        color = intToRGB(hashCode(main_breakdown_dimension));
                }
                let yAxisValue = metricsNameObj[metricName] || metricName;

                res.chartData[x].push({
                    x: date,
                    y: d,
                    metricName: metricName,
                    yAxisName: yAxisValue,
                    dataId: date,
                    dimensionName: dimensionName,
                    breakdownDimensionName: dimensionNameObj[breakdownDimensionName] || breakdownDimensionName,
                    color: color,
                    breakDownId: id1 ? id1 : main_breakdown_dimension,
                    breakDownName: main_breakdown_dimension,
                });
            });
        });
    } else res.nodata = true;
    res.chartData.date.start_date = params.start_date;
    res.chartData.date.end_date = params.end_date;
    // console.log("Response", chartData);
    const allowedValues = ["Person", "Non-person", "Male", "Female", "Brand", "News", "person", "non-person", "male", "female", "brand", "news", "date"]; //Unknown

    if (breakdownDimensionName === "entity_sub_type" || breakdownDimensionName === "entity_types") {
        res.chartData = Object.fromEntries(
            Object.entries(res.chartData).filter((obj) => {
                if (allowedValues.includes(obj[0])) return true;
                return false;
            }),
        );
    }

    res.chartData = Object.fromEntries(
        Object.entries(res.chartData).filter((obj) => {
            if (obj[0] == "") return false;
            return true;
        }),
    );

    console.log("response", res);

    return res;
};

const format1D1MLineChartData = (responseData, dimensionName, metricName, viewCountCheckbox, params) => {
    console.log("response", responseData, metricName);
    let res = {
        data: [],
        nodata: false,
    };

    let totalData = 0;
    let count_value = 0;
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    responseData.forEach((ele) => {
        if (metricName === "mention") {
            count_value = ele.doc_count;
        } else if (metricName === "enagagment_value") {
            if (viewCountCheckbox) {
                count_value = ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
            } else {
                count_value = ele.view_count.sum + ele.comment_count.sum + ele.like_count.sum + ele.share_count.sum;
            }
        } else if (metricName === "unique_user") {
            count_value = ele[metricName].value;
        } else if (metricName === "sentiment") {
            count_value = parseFloat(advancedNetSentimentMetric(ele.sentiments.group1.group2.buckets).toFixed(2));
        } else {
            count_value = ele[metricName].sum;
        }
        let date = ele.key;
        if (moment(params.end_date).isBefore(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) return;
        if (moment(params.start_date).isAfter(moment(date).tz(tz).format("YYYY-MM-DDTHH:mm:ss"))) date = getCorrectedDate(params, date);
        let yAxisValue = metricsNameObj[metricName] || metricName;
        res.data.push({
            name: date,
            y: count_value,
            metricName: metricName,
            yAxisName: yAxisValue,
            dimensionName: dimensionName,
            dataId: date,
        });
        totalData += count_value;
    });

    console.log("response", JSON.parse(JSON.stringify(res)));

    return res;
};
